const EvaBlink = [
  {
    "": "0",
    time: "1637709673.929125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-53.7109375",
    c3: "-24.4140625",
    c4: "-54.19921875",
  },
  {
    "": "1",
    time: "1637709673.9330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-47.36328125",
    c3: "-9.27734375",
    c4: "-21.97265625",
  },
  {
    "": "2",
    time: "1637709673.9369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-41.015625",
    c3: "-5.37109375",
    c4: "-6.34765625",
  },
  {
    "": "3",
    time: "1637709673.9408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-54.19921875",
    c3: "-27.83203125",
    c4: "-37.109375",
  },
  {
    "": "4",
    time: "1637709673.94475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-53.7109375",
    c3: "-63.4765625",
    c4: "-41.50390625",
  },
  {
    "": "5",
    time: "1637709673.9486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-35.64453125",
    c3: "-42.48046875",
    c4: "-11.71875",
  },
  {
    "": "6",
    time: "1637709673.9525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-34.1796875",
    c3: "15.13671875",
    c4: "4.39453125",
  },
  {
    "": "7",
    time: "1637709673.9564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-36.1328125",
    c3: "10.25390625",
    c4: "-28.80859375",
  },
  {
    "": "8",
    time: "1637709673.960375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-50.78125",
    c3: "-29.78515625",
    c4: "-50.78125",
  },
  {
    "": "9",
    time: "1637709673.9642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-46.38671875",
    c3: "-18.5546875",
    c4: "-27.83203125",
  },
  {
    "": "10",
    time: "1637709673.9681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-36.1328125",
    c3: "5.859375",
    c4: "-5.859375",
  },
  {
    "": "11",
    time: "1637709673.9720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-34.1796875",
    c3: "-25.390625",
    c4: "-14.16015625",
  },
  {
    "": "12",
    time: "1637709673.976125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-36.1328125",
    c3: "-41.015625",
    c4: "-59.08203125",
  },
  {
    "": "13",
    time: "1637709673.9800313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-51.26953125",
    c3: "-19.53125",
    c4: "-58.59375",
  },
  {
    "": "14",
    time: "1637709673.9839375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-46.875",
    c3: "4.8828125",
    c4: "0.48828125",
  },
  {
    "": "15",
    time: "1637709673.9878438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-48.828125",
    c3: "-5.859375",
    c4: "-2.9296875",
  },
  {
    "": "16",
    time: "1637709673.99175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-44.43359375",
    c3: "-53.22265625",
    c4: "-22.94921875",
  },
  {
    "": "17",
    time: "1637709673.9956563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-16.11328125",
    c3: "-78.125",
    c4: "-39.55078125",
  },
  {
    "": "18",
    time: "1637709673.9995625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-38.0859375",
    c3: "-46.875",
    c4: "-27.34375",
  },
  {
    "": "19",
    time: "1637709674.0034688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-46.38671875",
    c3: "-22.4609375",
    c4: "7.32421875",
  },
  {
    "": "20",
    time: "1637709674.007375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-35.15625",
    c3: "-39.55078125",
    c4: "-35.64453125",
  },
  {
    "": "21",
    time: "1637709674.0112813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-45.41015625",
    c3: "-19.04296875",
    c4: "-73.73046875",
  },
  {
    "": "22",
    time: "1637709674.0151875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-51.26953125",
    c3: "-22.4609375",
    c4: "-36.1328125",
  },
  {
    "": "23",
    time: "1637709674.0190938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-45.8984375",
    c3: "-25.390625",
    c4: "-3.41796875",
  },
  {
    "": "24",
    time: "1637709674.019125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-39.55078125",
    c3: "-11.71875",
    c4: "-21.484375",
  },
  {
    "": "25",
    time: "1637709674.0230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-62.01171875",
    c3: "-20.5078125",
    c4: "-56.15234375",
  },
  {
    "": "26",
    time: "1637709674.0269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-84.9609375",
    c3: "-31.25",
    c4: "-36.62109375",
  },
  {
    "": "27",
    time: "1637709674.0308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-63.96484375",
    c3: "-39.0625",
    c4: "9.27734375",
  },
  {
    "": "28",
    time: "1637709674.03475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-52.734375",
    c3: "-41.9921875",
    c4: "-1.953125",
  },
  {
    "": "29",
    time: "1637709674.0386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-56.640625",
    c3: "-56.15234375",
    c4: "-51.7578125",
  },
  {
    "": "30",
    time: "1637709674.0425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-39.0625",
    c3: "-56.15234375",
    c4: "-57.12890625",
  },
  {
    "": "31",
    time: "1637709674.0464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-30.2734375",
    c3: "-73.2421875",
    c4: "5.37109375",
  },
  {
    "": "32",
    time: "1637709674.050375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-19.53125",
    c3: "-83.0078125",
    c4: "16.11328125",
  },
  {
    "": "33",
    time: "1637709674.0542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-0.9765625",
    c3: "-24.4140625",
    c4: "-43.9453125",
  },
  {
    "": "34",
    time: "1637709674.0581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-28.3203125",
    c3: "-15.625",
    c4: "-61.03515625",
  },
  {
    "": "35",
    time: "1637709674.0620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-50.78125",
    c3: "-29.296875",
    c4: "-22.94921875",
  },
  {
    "": "36",
    time: "1637709674.065125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-40.0390625",
    c3: "-5.37109375",
    c4: "-0.48828125",
  },
  {
    "": "37",
    time: "1637709674.0690312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-22.94921875",
    c3: "17.578125",
    c4: "-13.671875",
  },
  {
    "": "38",
    time: "1637709674.0729375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-8.7890625",
    c3: "-6.8359375",
    c4: "-45.8984375",
  },
  {
    "": "39",
    time: "1637709674.0768437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-16.6015625",
    c3: "-20.5078125",
    c4: "-24.4140625",
  },
  {
    "": "40",
    time: "1637709674.08075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-28.80859375",
    c3: "-7.8125",
    c4: "16.6015625",
  },
  {
    "": "41",
    time: "1637709674.0846562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-35.15625",
    c3: "-31.25",
    c4: "-8.7890625",
  },
  {
    "": "42",
    time: "1637709674.0885625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-27.83203125",
    c3: "-52.734375",
    c4: "-37.109375",
  },
  {
    "": "43",
    time: "1637709674.0924687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-15.13671875",
    c3: "-41.9921875",
    c4: "-24.4140625",
  },
  {
    "": "44",
    time: "1637709674.096375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-18.06640625",
    c3: "5.37109375",
    c4: "10.7421875",
  },
  {
    "": "45",
    time: "1637709674.1002812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-18.5546875",
    c3: "6.8359375",
    c4: "-8.7890625",
  },
  {
    "": "46",
    time: "1637709674.1041875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-2.44140625",
    c3: "-43.45703125",
    c4: "-45.41015625",
  },
  {
    "": "47",
    time: "1637709674.1080937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-7.32421875",
    c3: "-54.6875",
    c4: "-40.0390625",
  },
  {
    "": "48",
    time: "1637709674.108125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-38.57421875",
    c3: "-12.20703125",
    c4: "-12.6953125",
  },
  {
    "": "49",
    time: "1637709674.1120312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-31.73828125",
    c3: "-21.484375",
    c4: "-8.30078125",
  },
  {
    "": "50",
    time: "1637709674.1159375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-5.37109375",
    c3: "-41.50390625",
    c4: "-52.734375",
  },
  {
    "": "51",
    time: "1637709674.1198437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-18.06640625",
    c3: "-25.390625",
    c4: "-58.10546875",
  },
  {
    "": "52",
    time: "1637709674.12375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-35.15625",
    c3: "-24.90234375",
    c4: "-0.48828125",
  },
  {
    "": "53",
    time: "1637709674.1276562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-29.78515625",
    c3: "-13.671875",
    c4: "14.16015625",
  },
  {
    "": "54",
    time: "1637709674.1315625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-25.390625",
    c3: "-46.875",
    c4: "-17.08984375",
  },
  {
    "": "55",
    time: "1637709674.1354687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-30.2734375",
    c3: "-57.6171875",
    c4: "-5.859375",
  },
  {
    "": "56",
    time: "1637709674.139375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-25.390625",
    c3: "-6.8359375",
    c4: "18.06640625",
  },
  {
    "": "57",
    time: "1637709674.1432812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-30.2734375",
    c3: "-5.859375",
    c4: "20.5078125",
  },
  {
    "": "58",
    time: "1637709674.1471875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-32.71484375",
    c3: "-19.53125",
    c4: "-11.23046875",
  },
  {
    "": "59",
    time: "1637709674.1510937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-28.3203125",
    c3: "-20.01953125",
    c4: "-50.78125",
  },
  {
    "": "60",
    time: "1637709674.157125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-28.3203125",
    c3: "-21.97265625",
    c4: "-37.59765625",
  },
  {
    "": "61",
    time: "1637709674.1610312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-27.34375",
    c3: "-35.15625",
    c4: "12.20703125",
  },
  {
    "": "62",
    time: "1637709674.1649375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-18.5546875",
    c3: "-44.43359375",
    c4: "-1.46484375",
  },
  {
    "": "63",
    time: "1637709674.1688437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-10.7421875",
    c3: "-45.8984375",
    c4: "-39.55078125",
  },
  {
    "": "64",
    time: "1637709674.17275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-35.64453125",
    c3: "-32.2265625",
    c4: "-37.59765625",
  },
  {
    "": "65",
    time: "1637709674.1766562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-44.921875",
    c3: "-26.85546875",
    c4: "-2.44140625",
  },
  {
    "": "66",
    time: "1637709674.1805625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-36.62109375",
    c3: "-30.2734375",
    c4: "7.32421875",
  },
  {
    "": "67",
    time: "1637709674.1844687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-28.3203125",
    c3: "-27.34375",
    c4: "-34.1796875",
  },
  {
    "": "68",
    time: "1637709674.188375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-21.484375",
    c3: "-26.3671875",
    c4: "-59.5703125",
  },
  {
    "": "69",
    time: "1637709674.1922812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-20.5078125",
    c3: "-27.83203125",
    c4: "-17.578125",
  },
  {
    "": "70",
    time: "1637709674.1961875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-26.85546875",
    c3: "-17.08984375",
    c4: "8.30078125",
  },
  {
    "": "71",
    time: "1637709674.2000937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-52.24609375",
    c3: "-10.25390625",
    c4: "-26.3671875",
  },
  {
    "": "72",
    time: "1637709674.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-60.546875",
    c3: "-43.9453125",
    c4: "-42.96875",
  },
  {
    "": "73",
    time: "1637709674.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-41.50390625",
    c3: "-67.3828125",
    c4: "-4.8828125",
  },
  {
    "": "74",
    time: "1637709674.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-28.80859375",
    c3: "-42.48046875",
    c4: "13.18359375",
  },
  {
    "": "75",
    time: "1637709674.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-32.2265625",
    c3: "-47.36328125",
    c4: "-21.484375",
  },
  {
    "": "76",
    time: "1637709674.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-60.05859375",
    c3: "-66.89453125",
    c4: "-50.29296875",
  },
  {
    "": "77",
    time: "1637709674.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-56.15234375",
    c3: "-90.33203125",
    c4: "-33.69140625",
  },
  {
    "": "78",
    time: "1637709674.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-26.85546875",
    c3: "-107.91015625",
    c4: "9.27734375",
  },
  {
    "": "79",
    time: "1637709674.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-34.1796875",
    c3: "-42.48046875",
    c4: "-12.20703125",
  },
  {
    "": "80",
    time: "1637709674.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-40.52734375",
    c3: "-4.39453125",
    c4: "-56.15234375",
  },
  {
    "": "81",
    time: "1637709674.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-26.85546875",
    c3: "-6.34765625",
    c4: "-45.41015625",
  },
  {
    "": "82",
    time: "1637709674.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-28.3203125",
    c3: "-0.48828125",
    c4: "-8.7890625",
  },
  {
    "": "83",
    time: "1637709674.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-29.78515625",
    c3: "13.671875",
    c4: "-7.32421875",
  },
  {
    "": "84",
    time: "1637709674.259125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-50.78125",
    c3: "-15.13671875",
    c4: "-31.73828125",
  },
  {
    "": "85",
    time: "1637709674.2630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-46.38671875",
    c3: "-56.640625",
    c4: "-42.48046875",
  },
  {
    "": "86",
    time: "1637709674.2669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-28.3203125",
    c3: "-47.8515625",
    c4: "-24.4140625",
  },
  {
    "": "87",
    time: "1637709674.2708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-41.50390625",
    c3: "-25.390625",
    c4: "3.90625",
  },
  {
    "": "88",
    time: "1637709674.27475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-37.59765625",
    c3: "-34.1796875",
    c4: "-11.23046875",
  },
  {
    "": "89",
    time: "1637709674.2786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-29.78515625",
    c3: "-50.78125",
    c4: "-33.69140625",
  },
  {
    "": "90",
    time: "1637709674.2825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-64.94140625",
    c3: "-29.78515625",
    c4: "-17.578125",
  },
  {
    "": "91",
    time: "1637709674.2864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-83.984375",
    c3: "0.0",
    c4: "36.1328125",
  },
  {
    "": "92",
    time: "1637709674.290375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-50.29296875",
    c3: "-46.38671875",
    c4: "21.97265625",
  },
  {
    "": "93",
    time: "1637709674.2942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-41.9921875",
    c3: "-99.609375",
    c4: "-20.99609375",
  },
  {
    "": "94",
    time: "1637709674.2981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-54.19921875",
    c3: "-41.50390625",
    c4: "-17.578125",
  },
  {
    "": "95",
    time: "1637709674.3020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-47.8515625",
    c3: "-5.37109375",
    c4: "5.37109375",
  },
  {
    "": "96",
    time: "1637709674.304125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-32.2265625",
    c3: "-47.8515625",
    c4: "11.71875",
  },
  {
    "": "97",
    time: "1637709674.3080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-20.5078125",
    c3: "-78.125",
    c4: "-22.4609375",
  },
  {
    "": "98",
    time: "1637709674.3119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-29.296875",
    c3: "-53.22265625",
    c4: "-47.8515625",
  },
  {
    "": "99",
    time: "1637709674.3158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-37.59765625",
    c3: "-50.29296875",
    c4: "-13.671875",
  },
  {
    "": "100",
    time: "1637709674.31975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-46.875",
    c3: "-60.546875",
    c4: "-0.48828125",
  },
  {
    "": "101",
    time: "1637709674.3236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-63.96484375",
    c3: "-53.22265625",
    c4: "-44.43359375",
  },
  {
    "": "102",
    time: "1637709674.3275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-45.41015625",
    c3: "-42.96875",
    c4: "-82.03125",
  },
  {
    "": "103",
    time: "1637709674.3314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-28.3203125",
    c3: "-38.0859375",
    c4: "-49.8046875",
  },
  {
    "": "104",
    time: "1637709674.335375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-55.6640625",
    c3: "-61.5234375",
    c4: "-14.6484375",
  },
  {
    "": "105",
    time: "1637709674.3392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-71.2890625",
    c3: "-53.22265625",
    c4: "-42.48046875",
  },
  {
    "": "106",
    time: "1637709674.3431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-49.8046875",
    c3: "-21.97265625",
    c4: "-67.3828125",
  },
  {
    "": "107",
    time: "1637709674.3470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-42.96875",
    c3: "-47.8515625",
    c4: "-39.55078125",
  },
  {
    "": "108",
    time: "1637709674.350125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-41.50390625",
    c3: "-66.89453125",
    c4: "-11.71875",
  },
  {
    "": "109",
    time: "1637709674.3540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-41.50390625",
    c3: "-31.25",
    c4: "-33.203125",
  },
  {
    "": "110",
    time: "1637709674.3579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-42.48046875",
    c3: "-5.859375",
    c4: "-50.78125",
  },
  {
    "": "111",
    time: "1637709674.3618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-41.015625",
    c3: "-18.06640625",
    c4: "-30.2734375",
  },
  {
    "": "112",
    time: "1637709674.36575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-43.45703125",
    c3: "-15.13671875",
    c4: "1.46484375",
  },
  {
    "": "113",
    time: "1637709674.3696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-35.64453125",
    c3: "-17.578125",
    c4: "8.7890625",
  },
  {
    "": "114",
    time: "1637709674.3735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-29.78515625",
    c3: "-19.53125",
    c4: "-22.4609375",
  },
  {
    "": "115",
    time: "1637709674.3774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-33.203125",
    c3: "-36.62109375",
    c4: "-28.3203125",
  },
  {
    "": "116",
    time: "1637709674.381375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-41.9921875",
    c3: "-31.73828125",
    c4: "25.390625",
  },
  {
    "": "117",
    time: "1637709674.3852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-74.21875",
    c3: "4.39453125",
    c4: "26.3671875",
  },
  {
    "": "118",
    time: "1637709674.3891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-61.5234375",
    c3: "-15.625",
    c4: "-23.92578125",
  },
  {
    "": "119",
    time: "1637709674.3930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-19.04296875",
    c3: "-71.77734375",
    c4: "-35.64453125",
  },
  {
    "": "120",
    time: "1637709674.394125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-33.69140625",
    c3: "-60.546875",
    c4: "-11.23046875",
  },
  {
    "": "121",
    time: "1637709674.3980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-40.52734375",
    c3: "5.37109375",
    c4: "23.92578125",
  },
  {
    "": "122",
    time: "1637709674.4019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-41.015625",
    c3: "9.765625",
    c4: "-2.44140625",
  },
  {
    "": "123",
    time: "1637709674.4058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-47.8515625",
    c3: "-48.828125",
    c4: "-40.52734375",
  },
  {
    "": "124",
    time: "1637709674.40975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-28.3203125",
    c3: "-45.8984375",
    c4: "-20.01953125",
  },
  {
    "": "125",
    time: "1637709674.4136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-20.99609375",
    c3: "-19.53125",
    c4: "8.7890625",
  },
  {
    "": "126",
    time: "1637709674.4175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-32.2265625",
    c3: "-28.3203125",
    c4: "6.34765625",
  },
  {
    "": "127",
    time: "1637709674.4214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-25.87890625",
    c3: "-66.89453125",
    c4: "-27.34375",
  },
  {
    "": "128",
    time: "1637709674.425375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-31.73828125",
    c3: "-49.31640625",
    c4: "-39.55078125",
  },
  {
    "": "129",
    time: "1637709674.4292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-55.6640625",
    c3: "16.6015625",
    c4: "-2.9296875",
  },
  {
    "": "130",
    time: "1637709674.4331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-65.4296875",
    c3: "-26.3671875",
    c4: "14.16015625",
  },
  {
    "": "131",
    time: "1637709674.4370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-64.453125",
    c3: "-48.828125",
    c4: "-41.50390625",
  },
  {
    "": "132",
    time: "1637709674.442125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-37.109375",
    c3: "-14.16015625",
    c4: "-40.0390625",
  },
  {
    "": "133",
    time: "1637709674.4460313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-32.2265625",
    c3: "-4.39453125",
    c4: "-1.46484375",
  },
  {
    "": "134",
    time: "1637709674.4499376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-37.109375",
    c3: "-29.296875",
    c4: "4.39453125",
  },
  {
    "": "135",
    time: "1637709674.4538438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-30.76171875",
    c3: "-37.59765625",
    c4: "-13.671875",
  },
  {
    "": "136",
    time: "1637709674.45775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-36.62109375",
    c3: "-10.7421875",
    c4: "-56.640625",
  },
  {
    "": "137",
    time: "1637709674.4616563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-44.921875",
    c3: "-27.83203125",
    c4: "-51.7578125",
  },
  {
    "": "138",
    time: "1637709674.4655626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-48.33984375",
    c3: "-49.31640625",
    c4: "-15.13671875",
  },
  {
    "": "139",
    time: "1637709674.4694688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-41.50390625",
    c3: "-47.8515625",
    c4: "-26.3671875",
  },
  {
    "": "140",
    time: "1637709674.473375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-35.15625",
    c3: "-34.66796875",
    c4: "-59.08203125",
  },
  {
    "": "141",
    time: "1637709674.4772813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-39.55078125",
    c3: "-5.859375",
    c4: "-53.7109375",
  },
  {
    "": "142",
    time: "1637709674.4811876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-50.78125",
    c3: "8.30078125",
    c4: "-17.08984375",
  },
  {
    "": "143",
    time: "1637709674.4850938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-35.64453125",
    c3: "-19.53125",
    c4: "-2.9296875",
  },
  {
    "": "144",
    time: "1637709674.484125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-5.37109375",
    c3: "-32.71484375",
    c4: "-45.8984375",
  },
  {
    "": "145",
    time: "1637709674.4880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-29.78515625",
    c3: "-6.8359375",
    c4: "-73.73046875",
  },
  {
    "": "146",
    time: "1637709674.4919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-71.77734375",
    c3: "7.8125",
    c4: "-41.9921875",
  },
  {
    "": "147",
    time: "1637709674.4958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-52.734375",
    c3: "-19.04296875",
    c4: "-17.08984375",
  },
  {
    "": "148",
    time: "1637709674.49975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-19.53125",
    c3: "-31.73828125",
    c4: "-57.6171875",
  },
  {
    "": "149",
    time: "1637709674.5036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-15.625",
    c3: "-11.23046875",
    c4: "-82.03125",
  },
  {
    "": "150",
    time: "1637709674.5075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-15.625",
    c3: "-38.57421875",
    c4: "-49.31640625",
  },
  {
    "": "151",
    time: "1637709674.5114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-18.06640625",
    c3: "-39.55078125",
    c4: "6.8359375",
  },
  {
    "": "152",
    time: "1637709674.515375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-29.296875",
    c3: "17.578125",
    c4: "-11.71875",
  },
  {
    "": "153",
    time: "1637709674.5192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-38.57421875",
    c3: "15.13671875",
    c4: "-63.96484375",
  },
  {
    "": "154",
    time: "1637709674.5231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-52.734375",
    c3: "-5.859375",
    c4: "-25.390625",
  },
  {
    "": "155",
    time: "1637709674.5270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-50.29296875",
    c3: "16.6015625",
    c4: "22.4609375",
  },
  {
    "": "156",
    time: "1637709674.530125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-39.55078125",
    c3: "20.01953125",
    c4: "-1.953125",
  },
  {
    "": "157",
    time: "1637709674.5340312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-52.734375",
    c3: "10.7421875",
    c4: "-52.734375",
  },
  {
    "": "158",
    time: "1637709674.5379374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-49.31640625",
    c3: "13.18359375",
    c4: "-50.29296875",
  },
  {
    "": "159",
    time: "1637709674.5418437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-33.69140625",
    c3: "15.13671875",
    c4: "-7.32421875",
  },
  {
    "": "160",
    time: "1637709674.54575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-41.50390625",
    c3: "24.90234375",
    c4: "-16.11328125",
  },
  {
    "": "161",
    time: "1637709674.5496562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-54.6875",
    c3: "-10.25390625",
    c4: "-71.2890625",
  },
  {
    "": "162",
    time: "1637709674.5535624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-40.0390625",
    c3: "-36.62109375",
    c4: "-71.2890625",
  },
  {
    "": "163",
    time: "1637709674.5574687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-31.73828125",
    c3: "2.9296875",
    c4: "-39.0625",
  },
  {
    "": "164",
    time: "1637709674.561375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-40.52734375",
    c3: "30.76171875",
    c4: "-34.1796875",
  },
  {
    "": "165",
    time: "1637709674.5652812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-47.36328125",
    c3: "-19.53125",
    c4: "-63.96484375",
  },
  {
    "": "166",
    time: "1637709674.5691874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-42.48046875",
    c3: "-49.8046875",
    c4: "-68.359375",
  },
  {
    "": "167",
    time: "1637709674.5730937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-41.015625",
    c3: "2.44140625",
    c4: "-52.24609375",
  },
  {
    "": "168",
    time: "1637709674.588125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-48.828125",
    c3: "5.37109375",
    c4: "-28.3203125",
  },
  {
    "": "169",
    time: "1637709674.5920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-61.03515625",
    c3: "-12.20703125",
    c4: "-40.0390625",
  },
  {
    "": "170",
    time: "1637709674.5959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-45.41015625",
    c3: "-11.23046875",
    c4: "-49.31640625",
  },
  {
    "": "171",
    time: "1637709674.5998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-23.4375",
    c3: "-31.25",
    c4: "-27.34375",
  },
  {
    "": "172",
    time: "1637709674.60375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-34.66796875",
    c3: "-26.85546875",
    c4: "-9.27734375",
  },
  {
    "": "173",
    time: "1637709674.6076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-39.0625",
    c3: "-17.08984375",
    c4: "-31.73828125",
  },
  {
    "": "174",
    time: "1637709674.6115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-28.80859375",
    c3: "-22.94921875",
    c4: "-67.3828125",
  },
  {
    "": "175",
    time: "1637709674.6154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-23.4375",
    c3: "18.06640625",
    c4: "-56.15234375",
  },
  {
    "": "176",
    time: "1637709674.619375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-46.875",
    c3: "20.01953125",
    c4: "-28.80859375",
  },
  {
    "": "177",
    time: "1637709674.6232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-57.6171875",
    c3: "0.48828125",
    c4: "-19.53125",
  },
  {
    "": "178",
    time: "1637709674.6271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-54.19921875",
    c3: "-20.99609375",
    c4: "-53.7109375",
  },
  {
    "": "179",
    time: "1637709674.6310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-37.59765625",
    c3: "-59.08203125",
    c4: "-81.54296875",
  },
  {
    "": "180",
    time: "1637709674.622125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-22.94921875",
    c3: "-54.6875",
    c4: "-46.38671875",
  },
  {
    "": "181",
    time: "1637709674.6260312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-28.80859375",
    c3: "-12.20703125",
    c4: "-0.48828125",
  },
  {
    "": "182",
    time: "1637709674.6299374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-21.484375",
    c3: "8.30078125",
    c4: "-36.1328125",
  },
  {
    "": "183",
    time: "1637709674.6338437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-39.55078125",
    c3: "-6.8359375",
    c4: "-78.125",
  },
  {
    "": "184",
    time: "1637709674.63775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-51.7578125",
    c3: "-21.97265625",
    c4: "-44.43359375",
  },
  {
    "": "185",
    time: "1637709674.6416562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-41.9921875",
    c3: "-26.85546875",
    c4: "-9.27734375",
  },
  {
    "": "186",
    time: "1637709674.6455624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-45.8984375",
    c3: "-16.6015625",
    c4: "-36.62109375",
  },
  {
    "": "187",
    time: "1637709674.6494687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-40.52734375",
    c3: "-35.64453125",
    c4: "-41.50390625",
  },
  {
    "": "188",
    time: "1637709674.653375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-41.9921875",
    c3: "-71.77734375",
    c4: "-23.4375",
  },
  {
    "": "189",
    time: "1637709674.6572812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-52.734375",
    c3: "-48.33984375",
    c4: "12.6953125",
  },
  {
    "": "190",
    time: "1637709674.6611874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-34.66796875",
    c3: "-8.30078125",
    c4: "-2.9296875",
  },
  {
    "": "191",
    time: "1637709674.6650937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-44.43359375",
    c3: "-20.99609375",
    c4: "-58.10546875",
  },
  {
    "": "192",
    time: "1637709674.680125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-70.3125",
    c3: "-30.76171875",
    c4: "-43.45703125",
  },
  {
    "": "193",
    time: "1637709674.6840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-59.5703125",
    c3: "-20.5078125",
    c4: "2.44140625",
  },
  {
    "": "194",
    time: "1637709674.6879375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-19.04296875",
    c3: "-9.27734375",
    c4: "20.01953125",
  },
  {
    "": "195",
    time: "1637709674.6918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-3.90625",
    c3: "-25.87890625",
    c4: "-3.41796875",
  },
  {
    "": "196",
    time: "1637709674.69575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-39.55078125",
    c3: "-77.63671875",
    c4: "-26.85546875",
  },
  {
    "": "197",
    time: "1637709674.6996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-37.109375",
    c3: "-69.3359375",
    c4: "-16.6015625",
  },
  {
    "": "198",
    time: "1637709674.7035625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-18.5546875",
    c3: "-1.46484375",
    c4: "-2.9296875",
  },
  {
    "": "199",
    time: "1637709674.7074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-20.01953125",
    c3: "-8.7890625",
    c4: "-36.62109375",
  },
  {
    "": "200",
    time: "1637709674.711375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-28.3203125",
    c3: "-41.9921875",
    c4: "-55.6640625",
  },
  {
    "": "201",
    time: "1637709674.7152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-42.96875",
    c3: "-25.390625",
    c4: "-27.83203125",
  },
  {
    "": "202",
    time: "1637709674.7191875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-40.0390625",
    c3: "-0.9765625",
    c4: "-1.953125",
  },
  {
    "": "203",
    time: "1637709674.7230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-52.734375",
    c3: "-14.16015625",
    c4: "-11.23046875",
  },
  {
    "": "204",
    time: "1637709674.725125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-53.22265625",
    c3: "-15.13671875",
    c4: "-52.734375",
  },
  {
    "": "205",
    time: "1637709674.7290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-49.8046875",
    c3: "-9.765625",
    c4: "-20.99609375",
  },
  {
    "": "206",
    time: "1637709674.7329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-65.91796875",
    c3: "-23.4375",
    c4: "22.94921875",
  },
  {
    "": "207",
    time: "1637709674.7368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-54.19921875",
    c3: "-22.4609375",
    c4: "6.34765625",
  },
  {
    "": "208",
    time: "1637709674.74075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-15.625",
    c3: "-29.78515625",
    c4: "-24.4140625",
  },
  {
    "": "209",
    time: "1637709674.7446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-10.7421875",
    c3: "-34.1796875",
    c4: "-22.4609375",
  },
  {
    "": "210",
    time: "1637709674.7485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-10.7421875",
    c3: "-40.0390625",
    c4: "27.34375",
  },
  {
    "": "211",
    time: "1637709674.7524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-16.11328125",
    c3: "-55.17578125",
    c4: "43.9453125",
  },
  {
    "": "212",
    time: "1637709674.756375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-40.52734375",
    c3: "-52.24609375",
    c4: "-7.8125",
  },
  {
    "": "213",
    time: "1637709674.7602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-39.0625",
    c3: "-20.5078125",
    c4: "-48.33984375",
  },
  {
    "": "214",
    time: "1637709674.7641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-30.2734375",
    c3: "-16.11328125",
    c4: "1.953125",
  },
  {
    "": "215",
    time: "1637709674.7680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "19.04296875",
    c2: "-32.2265625",
    c3: "-34.1796875",
    c4: "34.1796875",
  },
  {
    "": "216",
    time: "1637709674.769125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-36.62109375",
    c3: "-26.3671875",
    c4: "-10.25390625",
  },
  {
    "": "217",
    time: "1637709674.7730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-53.22265625",
    c3: "-16.11328125",
    c4: "-28.80859375",
  },
  {
    "": "218",
    time: "1637709674.7769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-58.10546875",
    c3: "-25.390625",
    c4: "8.7890625",
  },
  {
    "": "219",
    time: "1637709674.7808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "-41.015625",
    c3: "-28.80859375",
    c4: "55.17578125",
  },
  {
    "": "220",
    time: "1637709674.78475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-48.828125",
    c3: "-31.25",
    c4: "21.484375",
  },
  {
    "": "221",
    time: "1637709674.7886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-81.0546875",
    c3: "-80.56640625",
    c4: "-22.94921875",
  },
  {
    "": "222",
    time: "1637709674.7925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-56.15234375",
    c3: "-107.91015625",
    c4: "-22.94921875",
  },
  {
    "": "223",
    time: "1637709674.7964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-8.7890625",
    c3: "-80.56640625",
    c4: "9.765625",
  },
  {
    "": "224",
    time: "1637709674.800375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-28.3203125",
    c3: "-38.57421875",
    c4: "12.6953125",
  },
  {
    "": "225",
    time: "1637709674.8042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-42.48046875",
    c3: "1.953125",
    c4: "-34.66796875",
  },
  {
    "": "226",
    time: "1637709674.8081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-34.1796875",
    c3: "-39.55078125",
    c4: "-50.78125",
  },
  {
    "": "227",
    time: "1637709674.8120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-24.90234375",
    c3: "-26.85546875",
    c4: "5.859375",
  },
  {
    "": "228",
    time: "1637709674.830125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-14.6484375",
    c3: "23.92578125",
    c4: "28.3203125",
  },
  {
    "": "229",
    time: "1637709674.8340313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-18.06640625",
    c3: "17.578125",
    c4: "-29.296875",
  },
  {
    "": "230",
    time: "1637709674.8379376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-29.78515625",
    c3: "-19.04296875",
    c4: "-55.6640625",
  },
  {
    "": "231",
    time: "1637709674.8418438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-43.45703125",
    c3: "-35.15625",
    c4: "-22.94921875",
  },
  {
    "": "232",
    time: "1637709674.84575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-38.57421875",
    c3: "-18.5546875",
    c4: "13.18359375",
  },
  {
    "": "233",
    time: "1637709674.8496563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-33.203125",
    c3: "-24.90234375",
    c4: "1.46484375",
  },
  {
    "": "234",
    time: "1637709674.8535626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-31.73828125",
    c3: "-48.828125",
    c4: "-29.296875",
  },
  {
    "": "235",
    time: "1637709674.8574688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-36.62109375",
    c3: "-51.26953125",
    c4: "-6.34765625",
  },
  {
    "": "236",
    time: "1637709674.861375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-23.92578125",
    c3: "-13.671875",
    c4: "11.23046875",
  },
  {
    "": "237",
    time: "1637709674.8652813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-4.39453125",
    c3: "-28.3203125",
    c4: "-9.27734375",
  },
  {
    "": "238",
    time: "1637709674.8691876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "1.46484375",
    c3: "-57.6171875",
    c4: "-43.9453125",
  },
  {
    "": "239",
    time: "1637709674.8730938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-0.48828125",
    c3: "-34.1796875",
    c4: "-44.921875",
  },
  {
    "": "240",
    time: "1637709674.859125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-24.90234375",
    c3: "7.8125",
    c4: "-3.90625",
  },
  {
    "": "241",
    time: "1637709674.8630311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-43.45703125",
    c3: "8.7890625",
    c4: "17.08984375",
  },
  {
    "": "242",
    time: "1637709674.8669374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-39.55078125",
    c3: "-19.04296875",
    c4: "-4.8828125",
  },
  {
    "": "243",
    time: "1637709674.8708436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-25.87890625",
    c3: "-38.57421875",
    c4: "-13.671875",
  },
  {
    "": "244",
    time: "1637709674.87475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-43.9453125",
    c3: "-24.90234375",
    c4: "8.7890625",
  },
  {
    "": "245",
    time: "1637709674.8786561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-51.26953125",
    c3: "-13.18359375",
    c4: "19.53125",
  },
  {
    "": "246",
    time: "1637709674.8825624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-31.25",
    c3: "-35.64453125",
    c4: "-4.8828125",
  },
  {
    "": "247",
    time: "1637709674.8864686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-40.52734375",
    c3: "-40.0390625",
    c4: "-35.64453125",
  },
  {
    "": "248",
    time: "1637709674.890375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-45.41015625",
    c3: "-19.53125",
    c4: "-17.08984375",
  },
  {
    "": "249",
    time: "1637709674.8942811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-35.15625",
    c3: "-16.6015625",
    c4: "12.20703125",
  },
  {
    "": "250",
    time: "1637709674.8981874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-37.59765625",
    c3: "-61.03515625",
    c4: "6.34765625",
  },
  {
    "": "251",
    time: "1637709674.9020936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-41.50390625",
    c3: "-49.31640625",
    c4: "-41.9921875",
  },
  {
    "": "252",
    time: "1637709674.907125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-39.0625",
    c3: "5.859375",
    c4: "-39.55078125",
  },
  {
    "": "253",
    time: "1637709674.9110312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-39.55078125",
    c3: "-6.8359375",
    c4: "19.53125",
  },
  {
    "": "254",
    time: "1637709674.9149375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-32.71484375",
    c3: "-37.59765625",
    c4: "14.6484375",
  },
  {
    "": "255",
    time: "1637709674.9188437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-22.4609375",
    c3: "-32.2265625",
    c4: "-36.1328125",
  },
  {
    "": "256",
    time: "1637709674.92275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-26.3671875",
    c3: "-2.9296875",
    c4: "-43.45703125",
  },
  {
    "": "257",
    time: "1637709674.9266562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-21.97265625",
    c3: "-31.73828125",
    c4: "1.953125",
  },
  {
    "": "258",
    time: "1637709674.9305625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-21.484375",
    c3: "-28.3203125",
    c4: "14.16015625",
  },
  {
    "": "259",
    time: "1637709674.9344687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-28.3203125",
    c3: "17.08984375",
    c4: "-36.62109375",
  },
  {
    "": "260",
    time: "1637709674.938375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-44.43359375",
    c3: "-23.4375",
    c4: "-65.91796875",
  },
  {
    "": "261",
    time: "1637709674.9422812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-59.08203125",
    c3: "-78.125",
    c4: "-10.7421875",
  },
  {
    "": "262",
    time: "1637709674.9461875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-46.38671875",
    c3: "-44.921875",
    c4: "9.27734375",
  },
  {
    "": "263",
    time: "1637709674.9500937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-35.64453125",
    c3: "-8.7890625",
    c4: "-36.1328125",
  },
  {
    "": "264",
    time: "1637709674.964125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-39.0625",
    c3: "-37.59765625",
    c4: "-46.38671875",
  },
  {
    "": "265",
    time: "1637709674.9680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-37.59765625",
    c3: "-29.296875",
    c4: "-19.04296875",
  },
  {
    "": "266",
    time: "1637709674.9719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-50.29296875",
    c3: "-1.953125",
    c4: "13.18359375",
  },
  {
    "": "267",
    time: "1637709674.9758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-61.03515625",
    c3: "-15.625",
    c4: "3.41796875",
  },
  {
    "": "268",
    time: "1637709674.97975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-36.62109375",
    c3: "-20.99609375",
    c4: "-42.96875",
  },
  {
    "": "269",
    time: "1637709674.9836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-38.57421875",
    c3: "-47.36328125",
    c4: "-45.41015625",
  },
  {
    "": "270",
    time: "1637709674.9875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-43.9453125",
    c3: "-43.9453125",
    c4: "2.9296875",
  },
  {
    "": "271",
    time: "1637709674.9914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-28.80859375",
    c3: "19.04296875",
    c4: "5.859375",
  },
  {
    "": "272",
    time: "1637709674.995375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-30.2734375",
    c3: "-5.37109375",
    c4: "-35.64453125",
  },
  {
    "": "273",
    time: "1637709674.9992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-31.73828125",
    c3: "-50.78125",
    c4: "-42.96875",
  },
  {
    "": "274",
    time: "1637709675.0031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-39.55078125",
    c3: "-2.9296875",
    c4: "2.44140625",
  },
  {
    "": "275",
    time: "1637709675.0070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-49.31640625",
    c3: "19.04296875",
    c4: "15.13671875",
  },
  {
    "": "276",
    time: "1637709675.009125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-46.875",
    c3: "-20.01953125",
    c4: "-10.25390625",
  },
  {
    "": "277",
    time: "1637709675.0130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-50.29296875",
    c3: "-25.87890625",
    c4: "-10.7421875",
  },
  {
    "": "278",
    time: "1637709675.0169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-60.546875",
    c3: "-23.4375",
    c4: "10.7421875",
  },
  {
    "": "279",
    time: "1637709675.0208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-43.45703125",
    c3: "-26.3671875",
    c4: "14.6484375",
  },
  {
    "": "280",
    time: "1637709675.02475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-21.484375",
    c3: "-20.99609375",
    c4: "-2.44140625",
  },
  {
    "": "281",
    time: "1637709675.0286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-38.57421875",
    c3: "-38.0859375",
    c4: "-31.25",
  },
  {
    "": "282",
    time: "1637709675.0325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-43.9453125",
    c3: "-34.66796875",
    c4: "-28.3203125",
  },
  {
    "": "283",
    time: "1637709675.0364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-36.62109375",
    c3: "-6.8359375",
    c4: "10.25390625",
  },
  {
    "": "284",
    time: "1637709675.040375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-26.3671875",
    c3: "-34.66796875",
    c4: "0.9765625",
  },
  {
    "": "285",
    time: "1637709675.0442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-44.43359375",
    c3: "-83.0078125",
    c4: "-37.109375",
  },
  {
    "": "286",
    time: "1637709675.0481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-52.24609375",
    c3: "-22.94921875",
    c4: "-20.01953125",
  },
  {
    "": "287",
    time: "1637709675.0520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-23.4375",
    c3: "23.92578125",
    c4: "37.109375",
  },
  {
    "": "288",
    time: "1637709675.054125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-23.4375",
    c3: "27.83203125",
    c4: "28.80859375",
  },
  {
    "": "289",
    time: "1637709675.0580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-38.0859375",
    c3: "-3.41796875",
    c4: "-19.53125",
  },
  {
    "": "290",
    time: "1637709675.0619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-31.73828125",
    c3: "-49.31640625",
    c4: "-24.90234375",
  },
  {
    "": "291",
    time: "1637709675.0658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-21.484375",
    c3: "-10.7421875",
    c4: "14.16015625",
  },
  {
    "": "292",
    time: "1637709675.06975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.99609375",
    c2: "-59.5703125",
    c3: "-1.953125",
    c4: "48.828125",
  },
  {
    "": "293",
    time: "1637709675.0736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-76.171875",
    c3: "-25.390625",
    c4: "16.11328125",
  },
  {
    "": "294",
    time: "1637709675.0775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-57.6171875",
    c3: "-20.01953125",
    c4: "-10.25390625",
  },
  {
    "": "295",
    time: "1637709675.0814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-48.33984375",
    c3: "-8.7890625",
    c4: "14.6484375",
  },
  {
    "": "296",
    time: "1637709675.085375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-35.15625",
    c3: "-28.80859375",
    c4: "55.6640625",
  },
  {
    "": "297",
    time: "1637709675.0892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-45.41015625",
    c3: "-22.94921875",
    c4: "11.71875",
  },
  {
    "": "298",
    time: "1637709675.0931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-50.78125",
    c3: "4.8828125",
    c4: "-53.22265625",
  },
  {
    "": "299",
    time: "1637709675.0970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-38.57421875",
    c3: "9.765625",
    c4: "-26.85546875",
  },
  {
    "": "300",
    time: "1637709675.099125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-52.734375",
    c3: "13.671875",
    c4: "25.87890625",
  },
  {
    "": "301",
    time: "1637709675.1030312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-46.38671875",
    c3: "24.4140625",
    c4: "7.8125",
  },
  {
    "": "302",
    time: "1637709675.1069374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-25.390625",
    c3: "10.7421875",
    c4: "-42.48046875",
  },
  {
    "": "303",
    time: "1637709675.1108437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-53.7109375",
    c3: "-34.1796875",
    c4: "-34.1796875",
  },
  {
    "": "304",
    time: "1637709675.11475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-76.171875",
    c3: "-41.9921875",
    c4: "11.23046875",
  },
  {
    "": "305",
    time: "1637709675.1186562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-49.8046875",
    c3: "-19.04296875",
    c4: "10.7421875",
  },
  {
    "": "306",
    time: "1637709675.1225624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-43.9453125",
    c3: "-19.04296875",
    c4: "-38.0859375",
  },
  {
    "": "307",
    time: "1637709675.1264687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-50.29296875",
    c3: "-54.19921875",
    c4: "-51.7578125",
  },
  {
    "": "308",
    time: "1637709675.130375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-41.50390625",
    c3: "-49.31640625",
    c4: "-8.30078125",
  },
  {
    "": "309",
    time: "1637709675.1342812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-28.80859375",
    c3: "28.80859375",
    c4: "11.23046875",
  },
  {
    "": "310",
    time: "1637709675.1381874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-35.64453125",
    c3: "32.2265625",
    c4: "-22.94921875",
  },
  {
    "": "311",
    time: "1637709675.1420937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-42.96875",
    c3: "7.8125",
    c4: "-44.921875",
  },
  {
    "": "312",
    time: "1637709675.145125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-45.41015625",
    c3: "4.8828125",
    c4: "-27.34375",
  },
  {
    "": "313",
    time: "1637709675.1490312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-51.7578125",
    c3: "5.37109375",
    c4: "1.46484375",
  },
  {
    "": "314",
    time: "1637709675.1529374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-40.52734375",
    c3: "2.44140625",
    c4: "-12.6953125",
  },
  {
    "": "315",
    time: "1637709675.1568437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-34.66796875",
    c3: "-60.05859375",
    c4: "-36.62109375",
  },
  {
    "": "316",
    time: "1637709675.16075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-30.2734375",
    c3: "-72.265625",
    c4: "-18.5546875",
  },
  {
    "": "317",
    time: "1637709675.1646562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-38.0859375",
    c3: "-2.44140625",
    c4: "9.765625",
  },
  {
    "": "318",
    time: "1637709675.1685624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-61.5234375",
    c3: "28.3203125",
    c4: "-4.39453125",
  },
  {
    "": "319",
    time: "1637709675.1724687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-55.17578125",
    c3: "-2.44140625",
    c4: "-34.1796875",
  },
  {
    "": "320",
    time: "1637709675.176375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-31.25",
    c3: "-16.11328125",
    c4: "-34.1796875",
  },
  {
    "": "321",
    time: "1637709675.1802812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-32.2265625",
    c3: "3.90625",
    c4: "-1.46484375",
  },
  {
    "": "322",
    time: "1637709675.1841874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-41.015625",
    c3: "-4.39453125",
    c4: "6.34765625",
  },
  {
    "": "323",
    time: "1637709675.1880937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-26.3671875",
    c3: "-4.39453125",
    c4: "-50.29296875",
  },
  {
    "": "324",
    time: "1637709675.191125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-26.85546875",
    c3: "-14.6484375",
    c4: "-77.1484375",
  },
  {
    "": "325",
    time: "1637709675.1950312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-42.48046875",
    c3: "-26.3671875",
    c4: "-37.109375",
  },
  {
    "": "326",
    time: "1637709675.1989374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-32.2265625",
    c3: "-4.39453125",
    c4: "9.27734375",
  },
  {
    "": "327",
    time: "1637709675.2028437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-15.625",
    c3: "5.859375",
    c4: "-10.7421875",
  },
  {
    "": "328",
    time: "1637709675.20675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-20.01953125",
    c3: "-16.6015625",
    c4: "-35.64453125",
  },
  {
    "": "329",
    time: "1637709675.2106562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-34.66796875",
    c3: "-24.4140625",
    c4: "-19.04296875",
  },
  {
    "": "330",
    time: "1637709675.2145624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-43.9453125",
    c3: "-15.625",
    c4: "24.4140625",
  },
  {
    "": "331",
    time: "1637709675.2184687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-56.15234375",
    c3: "-35.15625",
    c4: "20.5078125",
  },
  {
    "": "332",
    time: "1637709675.222375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-47.8515625",
    c3: "-4.39453125",
    c4: "-40.52734375",
  },
  {
    "": "333",
    time: "1637709675.2262812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-45.41015625",
    c3: "12.20703125",
    c4: "-35.15625",
  },
  {
    "": "334",
    time: "1637709675.2301874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-39.0625",
    c3: "0.0",
    c4: "11.23046875",
  },
  {
    "": "335",
    time: "1637709675.2340937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-31.73828125",
    c3: "12.6953125",
    c4: "5.37109375",
  },
  {
    "": "336",
    time: "1637709675.234125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-24.4140625",
    c3: "5.859375",
    c4: "-31.73828125",
  },
  {
    "": "337",
    time: "1637709675.2380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-16.11328125",
    c3: "-19.04296875",
    c4: "-38.0859375",
  },
  {
    "": "338",
    time: "1637709675.2419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-31.73828125",
    c3: "-29.78515625",
    c4: "-1.46484375",
  },
  {
    "": "339",
    time: "1637709675.2458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-50.29296875",
    c3: "-23.92578125",
    c4: "13.18359375",
  },
  {
    "": "340",
    time: "1637709675.24975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-49.8046875",
    c3: "-27.34375",
    c4: "-33.203125",
  },
  {
    "": "341",
    time: "1637709675.2536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-36.62109375",
    c3: "-63.96484375",
    c4: "-58.59375",
  },
  {
    "": "342",
    time: "1637709675.2575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-36.1328125",
    c3: "-87.890625",
    c4: "-16.6015625",
  },
  {
    "": "343",
    time: "1637709675.2614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-36.1328125",
    c3: "-55.6640625",
    c4: "1.46484375",
  },
  {
    "": "344",
    time: "1637709675.265375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-40.52734375",
    c3: "9.27734375",
    c4: "-52.734375",
  },
  {
    "": "345",
    time: "1637709675.2692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-69.82421875",
    c3: "0.48828125",
    c4: "-81.0546875",
  },
  {
    "": "346",
    time: "1637709675.2731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-66.40625",
    c3: "-26.85546875",
    c4: "-42.48046875",
  },
  {
    "": "347",
    time: "1637709675.2770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-38.0859375",
    c3: "11.71875",
    c4: "3.41796875",
  },
  {
    "": "348",
    time: "1637709675.281125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-28.3203125",
    c3: "17.578125",
    c4: "-27.83203125",
  },
  {
    "": "349",
    time: "1637709675.2850313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-23.92578125",
    c3: "-18.06640625",
    c4: "-67.87109375",
  },
  {
    "": "350",
    time: "1637709675.2889376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-22.94921875",
    c3: "-23.92578125",
    c4: "-40.0390625",
  },
  {
    "": "351",
    time: "1637709675.2928438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-27.34375",
    c3: "13.18359375",
    c4: "-1.953125",
  },
  {
    "": "352",
    time: "1637709675.29675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-40.52734375",
    c3: "13.18359375",
    c4: "2.9296875",
  },
  {
    "": "353",
    time: "1637709675.3006563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-63.96484375",
    c3: "-52.734375",
    c4: "-19.53125",
  },
  {
    "": "354",
    time: "1637709675.3045626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-57.6171875",
    c3: "-81.0546875",
    c4: "-41.50390625",
  },
  {
    "": "355",
    time: "1637709675.3084688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-46.875",
    c3: "-3.90625",
    c4: "-9.27734375",
  },
  {
    "": "356",
    time: "1637709675.312375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-43.45703125",
    c3: "-0.9765625",
    c4: "9.765625",
  },
  {
    "": "357",
    time: "1637709675.3162813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-34.1796875",
    c3: "-63.96484375",
    c4: "-30.2734375",
  },
  {
    "": "358",
    time: "1637709675.3201876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-34.66796875",
    c3: "-20.5078125",
    c4: "-46.38671875",
  },
  {
    "": "359",
    time: "1637709675.3240938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-33.203125",
    c3: "22.94921875",
    c4: "-25.390625",
  },
  {
    "": "360",
    time: "1637709675.325125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-21.97265625",
    c3: "24.90234375",
    c4: "2.9296875",
  },
  {
    "": "361",
    time: "1637709675.3290312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-24.90234375",
    c3: "2.44140625",
    c4: "-17.08984375",
  },
  {
    "": "362",
    time: "1637709675.3329375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-37.59765625",
    c3: "-13.671875",
    c4: "-57.6171875",
  },
  {
    "": "363",
    time: "1637709675.3368437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-36.62109375",
    c3: "1.46484375",
    c4: "-34.1796875",
  },
  {
    "": "364",
    time: "1637709675.34075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-41.50390625",
    c3: "13.671875",
    c4: "18.06640625",
  },
  {
    "": "365",
    time: "1637709675.3446562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-53.7109375",
    c3: "-31.73828125",
    c4: "9.765625",
  },
  {
    "": "366",
    time: "1637709675.3485625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-53.7109375",
    c3: "-56.640625",
    c4: "-34.66796875",
  },
  {
    "": "367",
    time: "1637709675.3524687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-38.57421875",
    c3: "-15.13671875",
    c4: "-30.76171875",
  },
  {
    "": "368",
    time: "1637709675.356375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-47.8515625",
    c3: "4.39453125",
    c4: "12.6953125",
  },
  {
    "": "369",
    time: "1637709675.3602812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-34.1796875",
    c3: "16.6015625",
    c4: "16.6015625",
  },
  {
    "": "370",
    time: "1637709675.3641875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-18.5546875",
    c3: "25.87890625",
    c4: "-21.484375",
  },
  {
    "": "371",
    time: "1637709675.3680937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-19.04296875",
    c3: "7.32421875",
    c4: "-49.31640625",
  },
  {
    "": "372",
    time: "1637709675.384125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-9.765625",
    c3: "-19.53125",
    c4: "-5.859375",
  },
  {
    "": "373",
    time: "1637709675.3880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-23.92578125",
    c3: "-17.08984375",
    c4: "29.296875",
  },
  {
    "": "374",
    time: "1637709675.3919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-40.52734375",
    c3: "-7.32421875",
    c4: "-7.8125",
  },
  {
    "": "375",
    time: "1637709675.3958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-31.73828125",
    c3: "-49.8046875",
    c4: "-40.52734375",
  },
  {
    "": "376",
    time: "1637709675.39975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-30.76171875",
    c3: "-49.8046875",
    c4: "-28.80859375",
  },
  {
    "": "377",
    time: "1637709675.4036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-29.78515625",
    c3: "6.34765625",
    c4: "17.08984375",
  },
  {
    "": "378",
    time: "1637709675.4075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-18.5546875",
    c3: "34.1796875",
    c4: "-3.41796875",
  },
  {
    "": "379",
    time: "1637709675.4114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-17.578125",
    c3: "29.296875",
    c4: "-64.453125",
  },
  {
    "": "380",
    time: "1637709675.415375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-37.109375",
    c3: "-15.13671875",
    c4: "-39.55078125",
  },
  {
    "": "381",
    time: "1637709675.4192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-32.2265625",
    c3: "-27.83203125",
    c4: "24.4140625",
  },
  {
    "": "382",
    time: "1637709675.4231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-23.4375",
    c3: "9.765625",
    c4: "2.9296875",
  },
  {
    "": "383",
    time: "1637709675.4270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-39.0625",
    c3: "-2.44140625",
    c4: "-43.45703125",
  },
  {
    "": "384",
    time: "1637709675.429125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-37.59765625",
    c3: "-24.90234375",
    c4: "-45.8984375",
  },
  {
    "": "385",
    time: "1637709675.4330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-25.87890625",
    c3: "-7.32421875",
    c4: "-10.25390625",
  },
  {
    "": "386",
    time: "1637709675.4369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-26.85546875",
    c3: "5.859375",
    c4: "9.27734375",
  },
  {
    "": "387",
    time: "1637709675.4408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-53.22265625",
    c3: "-22.4609375",
    c4: "-21.97265625",
  },
  {
    "": "388",
    time: "1637709675.44475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-53.7109375",
    c3: "-61.03515625",
    c4: "-7.32421875",
  },
  {
    "": "389",
    time: "1637709675.4486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-37.109375",
    c3: "-72.75390625",
    c4: "29.296875",
  },
  {
    "": "390",
    time: "1637709675.4525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.578125",
    c2: "-37.59765625",
    c3: "-30.2734375",
    c4: "23.92578125",
  },
  {
    "": "391",
    time: "1637709675.4564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-20.99609375",
    c3: "18.5546875",
    c4: "-23.4375",
  },
  {
    "": "392",
    time: "1637709675.460375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-25.390625",
    c3: "-30.2734375",
    c4: "-31.73828125",
  },
  {
    "": "393",
    time: "1637709675.4642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-44.921875",
    c3: "-44.921875",
    c4: "3.90625",
  },
  {
    "": "394",
    time: "1637709675.4681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-21.484375",
    c3: "24.4140625",
    c4: "28.3203125",
  },
  {
    "": "395",
    time: "1637709675.4720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-30.76171875",
    c3: "0.9765625",
    c4: "16.6015625",
  },
  {
    "": "396",
    time: "1637709675.475125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-44.43359375",
    c3: "-20.01953125",
    c4: "-32.2265625",
  },
  {
    "": "397",
    time: "1637709675.4790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-35.15625",
    c3: "4.39453125",
    c4: "-36.62109375",
  },
  {
    "": "398",
    time: "1637709675.4829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-24.4140625",
    c3: "24.4140625",
    c4: "1.953125",
  },
  {
    "": "399",
    time: "1637709675.4868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-14.16015625",
    c3: "9.765625",
    c4: "-3.90625",
  },
  {
    "": "400",
    time: "1637709675.49075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-20.01953125",
    c3: "-22.4609375",
    c4: "-48.828125",
  },
  {
    "": "401",
    time: "1637709675.4946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-30.76171875",
    c3: "-45.8984375",
    c4: "-46.875",
  },
  {
    "": "402",
    time: "1637709675.4985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-40.0390625",
    c3: "-34.1796875",
    c4: "-3.90625",
  },
  {
    "": "403",
    time: "1637709675.5024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-50.29296875",
    c3: "-14.16015625",
    c4: "7.32421875",
  },
  {
    "": "404",
    time: "1637709675.506375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-50.78125",
    c3: "-33.69140625",
    c4: "-15.625",
  },
  {
    "": "405",
    time: "1637709675.5102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-26.3671875",
    c3: "-5.37109375",
    c4: "-47.36328125",
  },
  {
    "": "406",
    time: "1637709675.5141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-16.6015625",
    c3: "-0.48828125",
    c4: "-25.87890625",
  },
  {
    "": "407",
    time: "1637709675.5180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-32.2265625",
    c3: "-31.73828125",
    c4: "16.11328125",
  },
  {
    "": "408",
    time: "1637709675.519125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-25.390625",
    c3: "-18.5546875",
    c4: "-20.01953125",
  },
  {
    "": "409",
    time: "1637709675.5230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-11.23046875",
    c3: "-6.34765625",
    c4: "-71.2890625",
  },
  {
    "": "410",
    time: "1637709675.5269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-23.92578125",
    c3: "-7.32421875",
    c4: "-34.66796875",
  },
  {
    "": "411",
    time: "1637709675.5308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-37.59765625",
    c3: "8.30078125",
    c4: "14.16015625",
  },
  {
    "": "412",
    time: "1637709675.53475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-41.015625",
    c3: "17.08984375",
    c4: "-15.13671875",
  },
  {
    "": "413",
    time: "1637709675.5386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-40.52734375",
    c3: "-3.41796875",
    c4: "-55.17578125",
  },
  {
    "": "414",
    time: "1637709675.5425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-54.6875",
    c3: "-17.08984375",
    c4: "-53.22265625",
  },
  {
    "": "415",
    time: "1637709675.5464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-72.75390625",
    c3: "-45.8984375",
    c4: "-1.46484375",
  },
  {
    "": "416",
    time: "1637709675.550375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-63.4765625",
    c3: "-37.109375",
    c4: "13.671875",
  },
  {
    "": "417",
    time: "1637709675.5542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-55.17578125",
    c3: "-6.34765625",
    c4: "-33.203125",
  },
  {
    "": "418",
    time: "1637709675.5581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-43.9453125",
    c3: "-45.8984375",
    c4: "-35.15625",
  },
  {
    "": "419",
    time: "1637709675.5620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-39.55078125",
    c3: "-38.57421875",
    c4: "-2.9296875",
  },
  {
    "": "420",
    time: "1637709675.565125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-43.45703125",
    c3: "0.9765625",
    c4: "-0.48828125",
  },
  {
    "": "421",
    time: "1637709675.5690312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-27.83203125",
    c3: "-28.80859375",
    c4: "-40.0390625",
  },
  {
    "": "422",
    time: "1637709675.5729375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-1.953125",
    c3: "-59.08203125",
    c4: "-50.78125",
  },
  {
    "": "423",
    time: "1637709675.5768437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-0.48828125",
    c3: "0.48828125",
    c4: "-0.48828125",
  },
  {
    "": "424",
    time: "1637709675.58075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-33.203125",
    c3: "34.66796875",
    c4: "11.71875",
  },
  {
    "": "425",
    time: "1637709675.5846562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-67.3828125",
    c3: "-10.25390625",
    c4: "-23.4375",
  },
  {
    "": "426",
    time: "1637709675.5885625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-67.3828125",
    c3: "-38.0859375",
    c4: "-69.3359375",
  },
  {
    "": "427",
    time: "1637709675.5924687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-58.59375",
    c3: "-21.484375",
    c4: "-52.24609375",
  },
  {
    "": "428",
    time: "1637709675.596375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-54.19921875",
    c3: "21.484375",
    c4: "5.37109375",
  },
  {
    "": "429",
    time: "1637709675.6002812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-34.66796875",
    c3: "0.9765625",
    c4: "14.6484375",
  },
  {
    "": "430",
    time: "1637709675.6041875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-18.06640625",
    c3: "-32.2265625",
    c4: "-52.24609375",
  },
  {
    "": "431",
    time: "1637709675.6080937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-14.6484375",
    c3: "-13.18359375",
    c4: "-76.66015625",
  },
  {
    "": "432",
    time: "1637709675.610125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-19.53125",
    c3: "-1.953125",
    c4: "-14.6484375",
  },
  {
    "": "433",
    time: "1637709675.6140313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-21.484375",
    c3: "-29.78515625",
    c4: "-5.37109375",
  },
  {
    "": "434",
    time: "1637709675.6179376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-25.390625",
    c3: "-52.734375",
    c4: "-48.33984375",
  },
  {
    "": "435",
    time: "1637709675.6218438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-33.69140625",
    c3: "-38.57421875",
    c4: "-60.546875",
  },
  {
    "": "436",
    time: "1637709675.62575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-35.15625",
    c3: "-12.6953125",
    c4: "-16.11328125",
  },
  {
    "": "437",
    time: "1637709675.6296563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-33.203125",
    c3: "-15.13671875",
    c4: "2.44140625",
  },
  {
    "": "438",
    time: "1637709675.6335626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-39.55078125",
    c3: "-58.59375",
    c4: "-25.390625",
  },
  {
    "": "439",
    time: "1637709675.6374688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-37.109375",
    c3: "-56.640625",
    c4: "-45.41015625",
  },
  {
    "": "440",
    time: "1637709675.641375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-36.62109375",
    c3: "0.0",
    c4: "-31.25",
  },
  {
    "": "441",
    time: "1637709675.6452813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-40.52734375",
    c3: "7.32421875",
    c4: "-5.37109375",
  },
  {
    "": "442",
    time: "1637709675.6491876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-62.98828125",
    c3: "-27.34375",
    c4: "-29.78515625",
  },
  {
    "": "443",
    time: "1637709675.6530938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-78.61328125",
    c3: "-45.41015625",
    c4: "-60.05859375",
  },
  {
    "": "444",
    time: "1637709675.655125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-45.8984375",
    c3: "-33.69140625",
    c4: "-29.78515625",
  },
  {
    "": "445",
    time: "1637709675.6590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-23.92578125",
    c3: "-30.2734375",
    c4: "2.9296875",
  },
  {
    "": "446",
    time: "1637709675.6629374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-32.71484375",
    c3: "-35.15625",
    c4: "-4.39453125",
  },
  {
    "": "447",
    time: "1637709675.6668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-25.87890625",
    c3: "-52.734375",
    c4: "-13.18359375",
  },
  {
    "": "448",
    time: "1637709675.67075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-26.3671875",
    c3: "-50.29296875",
    c4: "-29.296875",
  },
  {
    "": "449",
    time: "1637709675.6746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-33.203125",
    c3: "-34.66796875",
    c4: "-1.953125",
  },
  {
    "": "450",
    time: "1637709675.6785624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-36.62109375",
    c3: "-42.48046875",
    c4: "15.13671875",
  },
  {
    "": "451",
    time: "1637709675.6824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-47.36328125",
    c3: "-1.46484375",
    c4: "-43.9453125",
  },
  {
    "": "452",
    time: "1637709675.686375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-39.55078125",
    c3: "1.953125",
    c4: "-54.19921875",
  },
  {
    "": "453",
    time: "1637709675.6902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-41.9921875",
    c3: "-14.6484375",
    c4: "-11.23046875",
  },
  {
    "": "454",
    time: "1637709675.6941874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-38.57421875",
    c3: "16.11328125",
    c4: "1.46484375",
  },
  {
    "": "455",
    time: "1637709675.6980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-28.80859375",
    c3: "-1.953125",
    c4: "-24.90234375",
  },
  {
    "": "456",
    time: "1637709675.714125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-52.734375",
    c3: "-64.94140625",
    c4: "-56.640625",
  },
  {
    "": "457",
    time: "1637709675.7180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-43.45703125",
    c3: "-43.45703125",
    c4: "-33.69140625",
  },
  {
    "": "458",
    time: "1637709675.7219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-28.3203125",
    c3: "11.71875",
    c4: "11.23046875",
  },
  {
    "": "459",
    time: "1637709675.7258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-36.1328125",
    c3: "5.37109375",
    c4: "4.39453125",
  },
  {
    "": "460",
    time: "1637709675.72975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-30.76171875",
    c3: "-11.23046875",
    c4: "-30.76171875",
  },
  {
    "": "461",
    time: "1637709675.7336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-34.1796875",
    c3: "-51.26953125",
    c4: "-21.97265625",
  },
  {
    "": "462",
    time: "1637709675.7375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-24.4140625",
    c3: "-58.59375",
    c4: "20.5078125",
  },
  {
    "": "463",
    time: "1637709675.7414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-14.16015625",
    c3: "-5.859375",
    c4: "6.8359375",
  },
  {
    "": "464",
    time: "1637709675.745375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-23.92578125",
    c3: "10.25390625",
    c4: "-39.55078125",
  },
  {
    "": "465",
    time: "1637709675.7492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-28.3203125",
    c3: "-26.85546875",
    c4: "-34.66796875",
  },
  {
    "": "466",
    time: "1637709675.7531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "-26.3671875",
    c3: "-36.1328125",
    c4: "18.06640625",
  },
  {
    "": "467",
    time: "1637709675.7570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-39.0625",
    c3: "2.44140625",
    c4: "38.57421875",
  },
  {
    "": "468",
    time: "1637709675.758125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-36.1328125",
    c3: "-7.32421875",
    c4: "-9.765625",
  },
  {
    "": "469",
    time: "1637709675.7620313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-34.1796875",
    c3: "-38.57421875",
    c4: "-47.36328125",
  },
  {
    "": "470",
    time: "1637709675.7659376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-39.0625",
    c3: "-15.625",
    c4: "-20.01953125",
  },
  {
    "": "471",
    time: "1637709675.7698438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-40.52734375",
    c3: "3.90625",
    c4: "16.6015625",
  },
  {
    "": "472",
    time: "1637709675.77375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-61.03515625",
    c3: "-22.4609375",
    c4: "-10.25390625",
  },
  {
    "": "473",
    time: "1637709675.7776563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-78.61328125",
    c3: "-42.96875",
    c4: "-46.38671875",
  },
  {
    "": "474",
    time: "1637709675.7815626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-54.6875",
    c3: "-33.69140625",
    c4: "-42.96875",
  },
  {
    "": "475",
    time: "1637709675.7854688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-22.94921875",
    c3: "-12.20703125",
    c4: "-11.23046875",
  },
  {
    "": "476",
    time: "1637709675.789375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-22.94921875",
    c3: "-26.3671875",
    c4: "-6.34765625",
  },
  {
    "": "477",
    time: "1637709675.7932813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-38.57421875",
    c3: "-55.6640625",
    c4: "-46.38671875",
  },
  {
    "": "478",
    time: "1637709675.7971876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-70.80078125",
    c3: "-21.484375",
    c4: "-56.15234375",
  },
  {
    "": "479",
    time: "1637709675.8010938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-63.96484375",
    c3: "16.6015625",
    c4: "-7.32421875",
  },
  {
    "": "480",
    time: "1637709675.805125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-24.4140625",
    c3: "-1.953125",
    c4: "1.953125",
  },
  {
    "": "481",
    time: "1637709675.8090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-20.5078125",
    c3: "-5.859375",
    c4: "-32.2265625",
  },
  {
    "": "482",
    time: "1637709675.8129375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-26.85546875",
    c3: "-0.9765625",
    c4: "-48.828125",
  },
  {
    "": "483",
    time: "1637709675.8168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-28.80859375",
    c3: "-17.08984375",
    c4: "-16.6015625",
  },
  {
    "": "484",
    time: "1637709675.82075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-29.296875",
    c3: "-24.90234375",
    c4: "13.18359375",
  },
  {
    "": "485",
    time: "1637709675.8246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-26.85546875",
    c3: "-14.6484375",
    c4: "-21.97265625",
  },
  {
    "": "486",
    time: "1637709675.8285625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-21.484375",
    c3: "-21.484375",
    c4: "-61.03515625",
  },
  {
    "": "487",
    time: "1637709675.8324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-27.83203125",
    c3: "-56.15234375",
    c4: "-30.2734375",
  },
  {
    "": "488",
    time: "1637709675.836375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-41.015625",
    c3: "-70.80078125",
    c4: "10.7421875",
  },
  {
    "": "489",
    time: "1637709675.8402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-59.5703125",
    c3: "-32.2265625",
    c4: "-13.671875",
  },
  {
    "": "490",
    time: "1637709675.8441875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-71.2890625",
    c3: "-2.9296875",
    c4: "-50.78125",
  },
  {
    "": "491",
    time: "1637709675.8480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-63.96484375",
    c3: "-22.94921875",
    c4: "-30.76171875",
  },
  {
    "": "492",
    time: "1637709675.851125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-59.5703125",
    c3: "-26.3671875",
    c4: "11.71875",
  },
  {
    "": "493",
    time: "1637709675.8550313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-34.66796875",
    c3: "-20.5078125",
    c4: "-0.9765625",
  },
  {
    "": "494",
    time: "1637709675.8589375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-13.671875",
    c3: "-20.01953125",
    c4: "-44.43359375",
  },
  {
    "": "495",
    time: "1637709675.8628438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-20.01953125",
    c3: "-34.1796875",
    c4: "-31.73828125",
  },
  {
    "": "496",
    time: "1637709675.86675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-40.0390625",
    c3: "-43.45703125",
    c4: "7.8125",
  },
  {
    "": "497",
    time: "1637709675.8706563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-42.96875",
    c3: "-23.4375",
    c4: "12.6953125",
  },
  {
    "": "498",
    time: "1637709675.8745625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-37.59765625",
    c3: "-20.99609375",
    c4: "-23.92578125",
  },
  {
    "": "499",
    time: "1637709675.8784688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-38.0859375",
    c3: "-52.24609375",
    c4: "-50.29296875",
  },
  {
    "": "500",
    time: "1637709675.882375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-30.2734375",
    c3: "-61.03515625",
    c4: "-6.8359375",
  },
  {
    "": "501",
    time: "1637709675.8862813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-20.5078125",
    c3: "-22.4609375",
    c4: "26.3671875",
  },
  {
    "": "502",
    time: "1637709675.8901875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-56.15234375",
    c3: "-19.53125",
    c4: "-10.7421875",
  },
  {
    "": "503",
    time: "1637709675.8940938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-89.84375",
    c3: "-21.97265625",
    c4: "-41.50390625",
  },
  {
    "": "504",
    time: "1637709675.894125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-62.98828125",
    c3: "-21.97265625",
    c4: "-13.18359375",
  },
  {
    "": "505",
    time: "1637709675.8980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-39.55078125",
    c3: "-0.9765625",
    c4: "25.87890625",
  },
  {
    "": "506",
    time: "1637709675.9019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-48.33984375",
    c3: "-3.90625",
    c4: "2.9296875",
  },
  {
    "": "507",
    time: "1637709675.9058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-28.80859375",
    c3: "-47.36328125",
    c4: "-26.85546875",
  },
  {
    "": "508",
    time: "1637709675.90975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-14.6484375",
    c3: "-25.390625",
    c4: "-24.90234375",
  },
  {
    "": "509",
    time: "1637709675.9136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-24.4140625",
    c3: "-10.25390625",
    c4: "3.41796875",
  },
  {
    "": "510",
    time: "1637709675.9175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-21.97265625",
    c3: "-13.671875",
    c4: "-5.37109375",
  },
  {
    "": "511",
    time: "1637709675.9214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-38.0859375",
    c3: "-31.25",
    c4: "-51.26953125",
  },
  {
    "": "512",
    time: "1637709675.925375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-39.0625",
    c3: "-36.62109375",
    c4: "-31.73828125",
  },
  {
    "": "513",
    time: "1637709675.9292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-34.1796875",
    c3: "5.37109375",
    c4: "12.20703125",
  },
  {
    "": "514",
    time: "1637709675.9331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-39.55078125",
    c3: "4.8828125",
    c4: "23.92578125",
  },
  {
    "": "515",
    time: "1637709675.9370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-25.390625",
    c3: "-21.97265625",
    c4: "2.9296875",
  },
  {
    "": "516",
    time: "1637709675.941125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-35.64453125",
    c3: "-15.625",
    c4: "-26.3671875",
  },
  {
    "": "517",
    time: "1637709675.9450312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-42.48046875",
    c3: "-7.8125",
    c4: "3.90625",
  },
  {
    "": "518",
    time: "1637709675.9489374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-36.62109375",
    c3: "-13.671875",
    c4: "30.2734375",
  },
  {
    "": "519",
    time: "1637709675.9528437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-39.0625",
    c3: "-2.9296875",
    c4: "-5.37109375",
  },
  {
    "": "520",
    time: "1637709675.95675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-42.96875",
    c3: "-29.78515625",
    c4: "-36.1328125",
  },
  {
    "": "521",
    time: "1637709675.9606562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-41.015625",
    c3: "-65.91796875",
    c4: "-10.7421875",
  },
  {
    "": "522",
    time: "1637709675.9645624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-41.9921875",
    c3: "-32.2265625",
    c4: "23.4375",
  },
  {
    "": "523",
    time: "1637709675.9684687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-56.15234375",
    c3: "-39.0625",
    c4: "-3.90625",
  },
  {
    "": "524",
    time: "1637709675.972375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-59.08203125",
    c3: "-42.96875",
    c4: "-50.29296875",
  },
  {
    "": "525",
    time: "1637709675.9762812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-58.59375",
    c3: "-30.76171875",
    c4: "-40.0390625",
  },
  {
    "": "526",
    time: "1637709675.9801874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-59.08203125",
    c3: "-20.5078125",
    c4: "6.34765625",
  },
  {
    "": "527",
    time: "1637709675.9840937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-46.38671875",
    c3: "2.44140625",
    c4: "-1.953125",
  },
  {
    "": "528",
    time: "1637709675.984125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-25.87890625",
    c3: "0.48828125",
    c4: "-55.6640625",
  },
  {
    "": "529",
    time: "1637709675.9880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-19.04296875",
    c3: "-13.18359375",
    c4: "-43.9453125",
  },
  {
    "": "530",
    time: "1637709675.9919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-20.01953125",
    c3: "-0.48828125",
    c4: "-3.41796875",
  },
  {
    "": "531",
    time: "1637709675.9958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-32.71484375",
    c3: "-9.765625",
    c4: "-11.23046875",
  },
  {
    "": "532",
    time: "1637709675.99975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-46.38671875",
    c3: "-25.390625",
    c4: "-35.64453125",
  },
  {
    "": "533",
    time: "1637709676.0036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-62.5",
    c3: "-53.22265625",
    c4: "-43.45703125",
  },
  {
    "": "534",
    time: "1637709676.0075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-60.546875",
    c3: "-67.87109375",
    c4: "-20.01953125",
  },
  {
    "": "535",
    time: "1637709676.0114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-40.52734375",
    c3: "-31.73828125",
    c4: "-10.25390625",
  },
  {
    "": "536",
    time: "1637709676.015375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-28.80859375",
    c3: "21.484375",
    c4: "-34.66796875",
  },
  {
    "": "537",
    time: "1637709676.0192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-24.4140625",
    c3: "26.3671875",
    c4: "-58.59375",
  },
  {
    "": "538",
    time: "1637709676.0231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-23.92578125",
    c3: "11.23046875",
    c4: "-42.48046875",
  },
  {
    "": "539",
    time: "1637709676.0270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-12.20703125",
    c3: "26.85546875",
    c4: "1.953125",
  },
  {
    "": "540",
    time: "1637709676.031125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-23.92578125",
    c3: "21.97265625",
    c4: "-6.34765625",
  },
  {
    "": "541",
    time: "1637709676.0350313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-45.8984375",
    c3: "-22.4609375",
    c4: "-33.69140625",
  },
  {
    "": "542",
    time: "1637709676.0389376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-34.66796875",
    c3: "-35.15625",
    c4: "-16.11328125",
  },
  {
    "": "543",
    time: "1637709676.0428438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-19.04296875",
    c3: "-1.46484375",
    c4: "18.06640625",
  },
  {
    "": "544",
    time: "1637709676.04675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-11.23046875",
    c3: "-24.90234375",
    c4: "11.23046875",
  },
  {
    "": "545",
    time: "1637709676.0506563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-10.7421875",
    c3: "-60.546875",
    c4: "-27.34375",
  },
  {
    "": "546",
    time: "1637709676.0545626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-21.484375",
    c3: "-41.50390625",
    c4: "-36.62109375",
  },
  {
    "": "547",
    time: "1637709676.0584688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-25.87890625",
    c3: "-2.44140625",
    c4: "12.20703125",
  },
  {
    "": "548",
    time: "1637709676.062375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-20.99609375",
    c3: "-1.953125",
    c4: "33.203125",
  },
  {
    "": "549",
    time: "1637709676.0662813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-24.90234375",
    c3: "-20.01953125",
    c4: "-20.5078125",
  },
  {
    "": "550",
    time: "1637709676.0701876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-49.8046875",
    c3: "-21.484375",
    c4: "-53.22265625",
  },
  {
    "": "551",
    time: "1637709676.0740938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-51.7578125",
    c3: "-3.41796875",
    c4: "-10.7421875",
  },
  {
    "": "552",
    time: "1637709676.075125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-10.25390625",
    c3: "2.44140625",
    c4: "29.296875",
  },
  {
    "": "553",
    time: "1637709676.0790312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "3.90625",
    c3: "-29.78515625",
    c4: "10.7421875",
  },
  {
    "": "554",
    time: "1637709676.0829375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-18.06640625",
    c3: "-36.62109375",
    c4: "-20.5078125",
  },
  {
    "": "555",
    time: "1637709676.0868437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-34.1796875",
    c3: "-31.73828125",
    c4: "0.0",
  },
  {
    "": "556",
    time: "1637709676.09075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-32.71484375",
    c3: "-39.55078125",
    c4: "20.5078125",
  },
  {
    "": "557",
    time: "1637709676.0946562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-33.203125",
    c3: "-44.43359375",
    c4: "-0.9765625",
  },
  {
    "": "558",
    time: "1637709676.0985625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-31.25",
    c3: "-59.5703125",
    c4: "-29.78515625",
  },
  {
    "": "559",
    time: "1637709676.1024687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-38.0859375",
    c3: "-18.06640625",
    c4: "-31.25",
  },
  {
    "": "560",
    time: "1637709676.106375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-50.78125",
    c3: "5.37109375",
    c4: "-7.32421875",
  },
  {
    "": "561",
    time: "1637709676.1102812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-63.96484375",
    c3: "-16.6015625",
    c4: "-18.06640625",
  },
  {
    "": "562",
    time: "1637709676.1141875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-68.84765625",
    c3: "-24.4140625",
    c4: "-36.1328125",
  },
  {
    "": "563",
    time: "1637709676.1180937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-39.55078125",
    c3: "-20.99609375",
    c4: "-41.9921875",
  },
  {
    "": "564",
    time: "1637709676.134125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-45.8984375",
    c3: "-23.92578125",
    c4: "-5.37109375",
  },
  {
    "": "565",
    time: "1637709676.1380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-64.94140625",
    c3: "-17.578125",
    c4: "11.23046875",
  },
  {
    "": "566",
    time: "1637709676.1419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-39.55078125",
    c3: "-20.99609375",
    c4: "-56.15234375",
  },
  {
    "": "567",
    time: "1637709676.1458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-29.78515625",
    c3: "-28.3203125",
    c4: "-70.80078125",
  },
  {
    "": "568",
    time: "1637709676.14975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-29.296875",
    c3: "-55.17578125",
    c4: "-29.78515625",
  },
  {
    "": "569",
    time: "1637709676.1536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-33.69140625",
    c3: "-78.61328125",
    c4: "6.34765625",
  },
  {
    "": "570",
    time: "1637709676.1575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-46.875",
    c3: "-31.25",
    c4: "-0.48828125",
  },
  {
    "": "571",
    time: "1637709676.1614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-58.10546875",
    c3: "-19.53125",
    c4: "-33.69140625",
  },
  {
    "": "572",
    time: "1637709676.165375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-55.6640625",
    c3: "-74.21875",
    c4: "-29.78515625",
  },
  {
    "": "573",
    time: "1637709676.1692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-42.48046875",
    c3: "-58.10546875",
    c4: "14.16015625",
  },
  {
    "": "574",
    time: "1637709676.1731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-29.296875",
    c3: "3.41796875",
    c4: "-9.765625",
  },
  {
    "": "575",
    time: "1637709676.1770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-32.2265625",
    c3: "-3.41796875",
    c4: "-64.453125",
  },
  {
    "": "576",
    time: "1637709676.179125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-35.15625",
    c3: "-14.16015625",
    c4: "-54.19921875",
  },
  {
    "": "577",
    time: "1637709676.1830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-25.87890625",
    c3: "1.953125",
    c4: "-13.18359375",
  },
  {
    "": "578",
    time: "1637709676.1869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-49.8046875",
    c3: "-7.32421875",
    c4: "0.0",
  },
  {
    "": "579",
    time: "1637709676.1908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-68.359375",
    c3: "-28.80859375",
    c4: "-49.8046875",
  },
  {
    "": "580",
    time: "1637709676.19475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-47.8515625",
    c3: "-40.0390625",
    c4: "-57.12890625",
  },
  {
    "": "581",
    time: "1637709676.1986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-42.96875",
    c3: "-17.578125",
    c4: "-5.37109375",
  },
  {
    "": "582",
    time: "1637709676.2025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-37.109375",
    c3: "0.9765625",
    c4: "-5.37109375",
  },
  {
    "": "583",
    time: "1637709676.2064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-19.53125",
    c3: "-30.2734375",
    c4: "-55.6640625",
  },
  {
    "": "584",
    time: "1637709676.210375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-21.97265625",
    c3: "-75.68359375",
    c4: "-80.56640625",
  },
  {
    "": "585",
    time: "1637709676.2142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-43.45703125",
    c3: "-62.01171875",
    c4: "-54.6875",
  },
  {
    "": "586",
    time: "1637709676.2181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-42.48046875",
    c3: "9.765625",
    c4: "-21.484375",
  },
  {
    "": "587",
    time: "1637709676.2220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-33.203125",
    c3: "-17.578125",
    c4: "-18.06640625",
  },
  {
    "": "588",
    time: "1637709676.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-32.2265625",
    c3: "-48.33984375",
    c4: "-64.94140625",
  },
  {
    "": "589",
    time: "1637709676.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-36.1328125",
    c3: "-17.08984375",
    c4: "-68.84765625",
  },
  {
    "": "590",
    time: "1637709676.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-38.0859375",
    c3: "-11.71875",
    c4: "-18.5546875",
  },
  {
    "": "591",
    time: "1637709676.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-40.52734375",
    c3: "-34.66796875",
    c4: "-14.16015625",
  },
  {
    "": "592",
    time: "1637709676.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-42.48046875",
    c3: "-45.8984375",
    c4: "-40.0390625",
  },
  {
    "": "593",
    time: "1637709676.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-31.25",
    c3: "-26.85546875",
    c4: "-48.33984375",
  },
  {
    "": "594",
    time: "1637709676.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-35.15625",
    c3: "3.41796875",
    c4: "-18.06640625",
  },
  {
    "": "595",
    time: "1637709676.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-26.3671875",
    c3: "-7.32421875",
    c4: "4.8828125",
  },
  {
    "": "596",
    time: "1637709676.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-21.484375",
    c3: "-30.2734375",
    c4: "-25.87890625",
  },
  {
    "": "597",
    time: "1637709676.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-41.50390625",
    c3: "-25.87890625",
    c4: "-61.5234375",
  },
  {
    "": "598",
    time: "1637709676.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-56.15234375",
    c3: "-28.3203125",
    c4: "-19.04296875",
  },
  {
    "": "599",
    time: "1637709676.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-42.48046875",
    c3: "-38.57421875",
    c4: "33.203125",
  },
  {
    "": "600",
    time: "1637709676.269125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-30.2734375",
    c3: "-22.4609375",
    c4: "-8.7890625",
  },
  {
    "": "601",
    time: "1637709676.2730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-53.22265625",
    c3: "-13.671875",
    c4: "-50.29296875",
  },
  {
    "": "602",
    time: "1637709676.2769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-48.33984375",
    c3: "-38.0859375",
    c4: "-20.99609375",
  },
  {
    "": "603",
    time: "1637709676.2808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-24.4140625",
    c3: "-28.3203125",
    c4: "3.41796875",
  },
  {
    "": "604",
    time: "1637709676.28475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-18.5546875",
    c3: "-16.11328125",
    c4: "-19.04296875",
  },
  {
    "": "605",
    time: "1637709676.2886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-29.296875",
    c3: "-29.78515625",
    c4: "-53.22265625",
  },
  {
    "": "606",
    time: "1637709676.2925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-40.0390625",
    c3: "-35.64453125",
    c4: "-65.4296875",
  },
  {
    "": "607",
    time: "1637709676.2964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-26.3671875",
    c3: "-46.875",
    c4: "-13.18359375",
  },
  {
    "": "608",
    time: "1637709676.300375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-17.578125",
    c3: "-40.52734375",
    c4: "2.44140625",
  },
  {
    "": "609",
    time: "1637709676.3042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-39.0625",
    c3: "-26.3671875",
    c4: "-39.0625",
  },
  {
    "": "610",
    time: "1637709676.3081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-52.734375",
    c3: "-41.50390625",
    c4: "-51.7578125",
  },
  {
    "": "611",
    time: "1637709676.3120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-40.52734375",
    c3: "-7.8125",
    c4: "-13.671875",
  },
  {
    "": "612",
    time: "1637709676.317125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-61.03515625",
    c3: "-10.7421875",
    c4: "15.625",
  },
  {
    "": "613",
    time: "1637709676.3210313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-77.1484375",
    c3: "-15.625",
    c4: "-35.64453125",
  },
  {
    "": "614",
    time: "1637709676.3249376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-13.671875",
    c3: "-10.7421875",
    c4: "-70.80078125",
  },
  {
    "": "615",
    time: "1637709676.3288438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-7.8125",
    c3: "-19.04296875",
    c4: "-24.90234375",
  },
  {
    "": "616",
    time: "1637709676.33275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.671875",
    c2: "-54.6875",
    c3: "-1.46484375",
    c4: "40.0390625",
  },
  {
    "": "617",
    time: "1637709676.3366563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-48.828125",
    c3: "-49.31640625",
    c4: "18.5546875",
  },
  {
    "": "618",
    time: "1637709676.3405626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-41.50390625",
    c3: "-72.265625",
    c4: "-40.0390625",
  },
  {
    "": "619",
    time: "1637709676.3444688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-29.296875",
    c3: "-33.203125",
    c4: "-35.15625",
  },
  {
    "": "620",
    time: "1637709676.348375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-3.41796875",
    c3: "12.20703125",
    c4: "2.44140625",
  },
  {
    "": "621",
    time: "1637709676.3522813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-14.16015625",
    c3: "10.25390625",
    c4: "-1.46484375",
  },
  {
    "": "622",
    time: "1637709676.3561876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-23.92578125",
    c3: "-22.4609375",
    c4: "-43.45703125",
  },
  {
    "": "623",
    time: "1637709676.3600938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-11.23046875",
    c3: "-61.03515625",
    c4: "-30.2734375",
  },
  {
    "": "624",
    time: "1637709676.359125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-40.0390625",
    c3: "-47.36328125",
    c4: "15.13671875",
  },
  {
    "": "625",
    time: "1637709676.3630311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-52.24609375",
    c3: "5.37109375",
    c4: "16.11328125",
  },
  {
    "": "626",
    time: "1637709676.3669374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-20.5078125",
    c3: "2.44140625",
    c4: "-20.5078125",
  },
  {
    "": "627",
    time: "1637709676.3708436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-12.20703125",
    c3: "-34.66796875",
    c4: "-27.83203125",
  },
  {
    "": "628",
    time: "1637709676.37475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-29.296875",
    c3: "-39.55078125",
    c4: "-3.41796875",
  },
  {
    "": "629",
    time: "1637709676.3786561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-24.90234375",
    c3: "-11.23046875",
    c4: "6.34765625",
  },
  {
    "": "630",
    time: "1637709676.3825624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-15.625",
    c3: "-27.34375",
    c4: "-18.06640625",
  },
  {
    "": "631",
    time: "1637709676.3864686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-29.296875",
    c3: "-54.6875",
    c4: "-29.296875",
  },
  {
    "": "632",
    time: "1637709676.390375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-54.19921875",
    c3: "-9.27734375",
    c4: "-3.90625",
  },
  {
    "": "633",
    time: "1637709676.3942811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-60.05859375",
    c3: "10.25390625",
    c4: "8.30078125",
  },
  {
    "": "634",
    time: "1637709676.3981874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-35.15625",
    c3: "-8.30078125",
    c4: "-25.390625",
  },
  {
    "": "635",
    time: "1637709676.4020936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-40.0390625",
    c3: "-8.7890625",
    c4: "-67.87109375",
  },
  {
    "": "636",
    time: "1637709676.405125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-32.71484375",
    c3: "-3.41796875",
    c4: "-42.96875",
  },
  {
    "": "637",
    time: "1637709676.4090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-9.27734375",
    c3: "7.32421875",
    c4: "7.32421875",
  },
  {
    "": "638",
    time: "1637709676.4129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-11.71875",
    c3: "4.39453125",
    c4: "-2.44140625",
  },
  {
    "": "639",
    time: "1637709676.4168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-17.578125",
    c3: "-25.390625",
    c4: "-49.31640625",
  },
  {
    "": "640",
    time: "1637709676.42075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-22.4609375",
    c3: "-42.48046875",
    c4: "-55.17578125",
  },
  {
    "": "641",
    time: "1637709676.4246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-26.3671875",
    c3: "-38.0859375",
    c4: "2.44140625",
  },
  {
    "": "642",
    time: "1637709676.4285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-20.5078125",
    c3: "-24.4140625",
    c4: "21.97265625",
  },
  {
    "": "643",
    time: "1637709676.4324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-18.06640625",
    c3: "12.20703125",
    c4: "-14.6484375",
  },
  {
    "": "644",
    time: "1637709676.436375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-45.41015625",
    c3: "19.04296875",
    c4: "-37.109375",
  },
  {
    "": "645",
    time: "1637709676.4402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-67.3828125",
    c3: "-11.71875",
    c4: "-4.39453125",
  },
  {
    "": "646",
    time: "1637709676.4441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-72.265625",
    c3: "-32.71484375",
    c4: "21.484375",
  },
  {
    "": "647",
    time: "1637709676.4480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-63.4765625",
    c3: "3.90625",
    c4: "-11.23046875",
  },
  {
    "": "648",
    time: "1637709676.464125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-23.92578125",
    c3: "-3.41796875",
    c4: "-57.12890625",
  },
  {
    "": "649",
    time: "1637709676.4680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-10.7421875",
    c3: "-19.53125",
    c4: "-48.828125",
  },
  {
    "": "650",
    time: "1637709676.4719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-30.76171875",
    c3: "-5.37109375",
    c4: "-12.20703125",
  },
  {
    "": "651",
    time: "1637709676.4758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-38.0859375",
    c3: "-20.99609375",
    c4: "-33.69140625",
  },
  {
    "": "652",
    time: "1637709676.47975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-34.66796875",
    c3: "-34.66796875",
    c4: "-58.59375",
  },
  {
    "": "653",
    time: "1637709676.4836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-21.97265625",
    c3: "-59.08203125",
    c4: "-28.80859375",
  },
  {
    "": "654",
    time: "1637709676.4875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-31.25",
    c3: "-59.5703125",
    c4: "-1.953125",
  },
  {
    "": "655",
    time: "1637709676.4914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-59.08203125",
    c3: "0.9765625",
    c4: "-35.15625",
  },
  {
    "": "656",
    time: "1637709676.495375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-48.828125",
    c3: "0.48828125",
    c4: "-76.66015625",
  },
  {
    "": "657",
    time: "1637709676.4992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-33.203125",
    c3: "-37.59765625",
    c4: "-68.84765625",
  },
  {
    "": "658",
    time: "1637709676.5031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-20.5078125",
    c3: "-48.33984375",
    c4: "-15.625",
  },
  {
    "": "659",
    time: "1637709676.5070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-6.8359375",
    c3: "-9.27734375",
    c4: "-7.8125",
  },
  {
    "": "660",
    time: "1637709676.509125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-30.2734375",
    c3: "-18.06640625",
    c4: "-48.828125",
  },
  {
    "": "661",
    time: "1637709676.5130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-68.359375",
    c3: "-40.0390625",
    c4: "-65.4296875",
  },
  {
    "": "662",
    time: "1637709676.5169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-53.7109375",
    c3: "-9.27734375",
    c4: "-32.71484375",
  },
  {
    "": "663",
    time: "1637709676.5208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-7.8125",
    c3: "19.04296875",
    c4: "15.625",
  },
  {
    "": "664",
    time: "1637709676.52475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-2.44140625",
    c3: "4.39453125",
    c4: "-1.46484375",
  },
  {
    "": "665",
    time: "1637709676.5286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-21.484375",
    c3: "-10.25390625",
    c4: "-31.73828125",
  },
  {
    "": "666",
    time: "1637709676.5325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-13.18359375",
    c3: "-5.37109375",
    c4: "-25.87890625",
  },
  {
    "": "667",
    time: "1637709676.5364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "19.04296875",
    c2: "7.32421875",
    c3: "4.39453125",
    c4: "-6.34765625",
  },
  {
    "": "668",
    time: "1637709676.540375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "-3.90625",
    c3: "-17.578125",
    c4: "7.32421875",
  },
  {
    "": "669",
    time: "1637709676.5442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-3.41796875",
    c3: "-56.640625",
    c4: "-22.4609375",
  },
  {
    "": "670",
    time: "1637709676.5481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-12.6953125",
    c3: "-25.390625",
    c4: "-51.7578125",
  },
  {
    "": "671",
    time: "1637709676.5520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-44.921875",
    c3: "4.8828125",
    c4: "-8.30078125",
  },
  {
    "": "672",
    time: "1637709676.556125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-39.0625",
    c3: "-17.578125",
    c4: "-7.8125",
  },
  {
    "": "673",
    time: "1637709676.5600312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-29.296875",
    c3: "-44.921875",
    c4: "-43.45703125",
  },
  {
    "": "674",
    time: "1637709676.5639374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-48.828125",
    c3: "-22.4609375",
    c4: "-42.48046875",
  },
  {
    "": "675",
    time: "1637709676.5678437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-46.38671875",
    c3: "-11.71875",
    c4: "-45.41015625",
  },
  {
    "": "676",
    time: "1637709676.57175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-21.484375",
    c3: "-44.43359375",
    c4: "-26.85546875",
  },
  {
    "": "677",
    time: "1637709676.5756562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-17.08984375",
    c3: "-41.015625",
    c4: "-51.26953125",
  },
  {
    "": "678",
    time: "1637709676.5795624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-22.94921875",
    c3: "10.25390625",
    c4: "-81.0546875",
  },
  {
    "": "679",
    time: "1637709676.5834687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-17.08984375",
    c3: "30.2734375",
    c4: "-55.6640625",
  },
  {
    "": "680",
    time: "1637709676.587375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-23.4375",
    c3: "-21.484375",
    c4: "-24.4140625",
  },
  {
    "": "681",
    time: "1637709676.5912812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-44.921875",
    c3: "-41.50390625",
    c4: "-25.390625",
  },
  {
    "": "682",
    time: "1637709676.5951874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-33.69140625",
    c3: "-3.41796875",
    c4: "-46.875",
  },
  {
    "": "683",
    time: "1637709676.5990937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-30.2734375",
    c3: "-20.5078125",
    c4: "-35.15625",
  },
  {
    "": "684",
    time: "1637709676.600125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-52.24609375",
    c3: "-8.7890625",
    c4: "8.30078125",
  },
  {
    "": "685",
    time: "1637709676.6040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-22.94921875",
    c3: "32.71484375",
    c4: "-0.48828125",
  },
  {
    "": "686",
    time: "1637709676.6079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-20.01953125",
    c3: "30.2734375",
    c4: "-36.1328125",
  },
  {
    "": "687",
    time: "1637709676.6118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-71.2890625",
    c3: "-19.53125",
    c4: "-24.90234375",
  },
  {
    "": "688",
    time: "1637709676.61575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-44.921875",
    c3: "-55.6640625",
    c4: "0.9765625",
  },
  {
    "": "689",
    time: "1637709676.6196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-13.18359375",
    c3: "-32.2265625",
    c4: "0.48828125",
  },
  {
    "": "690",
    time: "1637709676.6235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-18.5546875",
    c3: "-13.671875",
    c4: "-32.71484375",
  },
  {
    "": "691",
    time: "1637709676.6274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-33.203125",
    c3: "-33.203125",
    c4: "-64.94140625",
  },
  {
    "": "692",
    time: "1637709676.631375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-52.734375",
    c3: "-66.40625",
    c4: "-34.66796875",
  },
  {
    "": "693",
    time: "1637709676.6352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-30.2734375",
    c3: "-19.53125",
    c4: "-16.6015625",
  },
  {
    "": "694",
    time: "1637709676.6391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-11.23046875",
    c3: "2.9296875",
    c4: "-53.7109375",
  },
  {
    "": "695",
    time: "1637709676.6430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-20.5078125",
    c3: "-24.90234375",
    c4: "-78.125",
  },
  {
    "": "696",
    time: "1637709676.645125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-31.25",
    c3: "-26.85546875",
    c4: "-41.9921875",
  },
  {
    "": "697",
    time: "1637709676.6490312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-32.2265625",
    c3: "-0.9765625",
    c4: "1.46484375",
  },
  {
    "": "698",
    time: "1637709676.6529374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-36.1328125",
    c3: "11.71875",
    c4: "-18.5546875",
  },
  {
    "": "699",
    time: "1637709676.6568437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-41.50390625",
    c3: "-23.4375",
    c4: "-45.8984375",
  },
  {
    "": "700",
    time: "1637709676.66075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-17.578125",
    c3: "-43.45703125",
    c4: "-26.3671875",
  },
  {
    "": "701",
    time: "1637709676.6646562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-17.578125",
    c3: "-35.64453125",
    c4: "2.44140625",
  },
  {
    "": "702",
    time: "1637709676.6685624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-45.41015625",
    c3: "-22.4609375",
    c4: "2.44140625",
  },
  {
    "": "703",
    time: "1637709676.6724687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-47.8515625",
    c3: "-46.38671875",
    c4: "-6.8359375",
  },
  {
    "": "704",
    time: "1637709676.676375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-37.59765625",
    c3: "-84.47265625",
    c4: "-31.73828125",
  },
  {
    "": "705",
    time: "1637709676.6802812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-23.4375",
    c3: "-38.57421875",
    c4: "-29.78515625",
  },
  {
    "": "706",
    time: "1637709676.6841874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-22.4609375",
    c3: "-20.99609375",
    c4: "-20.5078125",
  },
  {
    "": "707",
    time: "1637709676.6880937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-21.97265625",
    c3: "-33.203125",
    c4: "-49.31640625",
  },
  {
    "": "708",
    time: "1637709676.690125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-15.13671875",
    c3: "-9.765625",
    c4: "-67.3828125",
  },
  {
    "": "709",
    time: "1637709676.6940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-28.3203125",
    c3: "10.25390625",
    c4: "-48.828125",
  },
  {
    "": "710",
    time: "1637709676.6979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-39.0625",
    c3: "-6.34765625",
    c4: "-20.99609375",
  },
  {
    "": "711",
    time: "1637709676.7018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-23.4375",
    c3: "-34.66796875",
    c4: "-41.50390625",
  },
  {
    "": "712",
    time: "1637709676.70575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-14.16015625",
    c3: "-34.66796875",
    c4: "-63.4765625",
  },
  {
    "": "713",
    time: "1637709676.7096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-24.4140625",
    c3: "-45.8984375",
    c4: "-48.33984375",
  },
  {
    "": "714",
    time: "1637709676.7135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-14.6484375",
    c3: "-68.84765625",
    c4: "-18.5546875",
  },
  {
    "": "715",
    time: "1637709676.7174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-13.18359375",
    c3: "-55.17578125",
    c4: "-22.94921875",
  },
  {
    "": "716",
    time: "1637709676.721375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-31.73828125",
    c3: "-24.4140625",
    c4: "-59.08203125",
  },
  {
    "": "717",
    time: "1637709676.7252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-28.3203125",
    c3: "-53.7109375",
    c4: "-48.828125",
  },
  {
    "": "718",
    time: "1637709676.7291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-20.99609375",
    c3: "-42.96875",
    c4: "-8.30078125",
  },
  {
    "": "719",
    time: "1637709676.7330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-14.6484375",
    c3: "-30.76171875",
    c4: "-4.8828125",
  },
  {
    "": "720",
    time: "1637709676.734125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-19.53125",
    c3: "-49.31640625",
    c4: "-49.8046875",
  },
  {
    "": "721",
    time: "1637709676.7380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-30.2734375",
    c3: "-34.66796875",
    c4: "-63.96484375",
  },
  {
    "": "722",
    time: "1637709676.7419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-10.25390625",
    c3: "-28.3203125",
    c4: "-22.4609375",
  },
  {
    "": "723",
    time: "1637709676.7458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-6.8359375",
    c3: "-32.71484375",
    c4: "6.8359375",
  },
  {
    "": "724",
    time: "1637709676.74975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-28.80859375",
    c3: "-22.94921875",
    c4: "-21.484375",
  },
  {
    "": "725",
    time: "1637709676.7536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-42.48046875",
    c3: "-37.109375",
    c4: "-45.41015625",
  },
  {
    "": "726",
    time: "1637709676.7575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-48.828125",
    c3: "-83.984375",
    c4: "-2.9296875",
  },
  {
    "": "727",
    time: "1637709676.7614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "15.13671875",
    c2: "-51.26953125",
    c3: "-63.4765625",
    c4: "28.3203125",
  },
  {
    "": "728",
    time: "1637709676.765375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-32.2265625",
    c3: "4.39453125",
    c4: "-28.80859375",
  },
  {
    "": "729",
    time: "1637709676.7692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-22.94921875",
    c3: "-12.6953125",
    c4: "-57.6171875",
  },
  {
    "": "730",
    time: "1637709676.7731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-23.92578125",
    c3: "-28.3203125",
    c4: "-23.4375",
  },
  {
    "": "731",
    time: "1637709676.7770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "4.8828125",
    c3: "-20.5078125",
    c4: "23.92578125",
  },
  {
    "": "732",
    time: "1637709676.782125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "11.71875",
    c3: "-27.34375",
    c4: "26.3671875",
  },
  {
    "": "733",
    time: "1637709676.7860312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-14.16015625",
    c3: "-22.94921875",
    c4: "-12.20703125",
  },
  {
    "": "734",
    time: "1637709676.7899375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-44.921875",
    c3: "-23.4375",
    c4: "-16.11328125",
  },
  {
    "": "735",
    time: "1637709676.7938437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-57.12890625",
    c3: "-23.92578125",
    c4: "18.06640625",
  },
  {
    "": "736",
    time: "1637709676.79775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-37.59765625",
    c3: "-12.6953125",
    c4: "18.06640625",
  },
  {
    "": "737",
    time: "1637709676.8016562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-14.16015625",
    c3: "-35.15625",
    c4: "-15.13671875",
  },
  {
    "": "738",
    time: "1637709676.8055625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-7.32421875",
    c3: "-51.26953125",
    c4: "-20.99609375",
  },
  {
    "": "739",
    time: "1637709676.8094687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-16.11328125",
    c3: "1.953125",
    c4: "7.8125",
  },
  {
    "": "740",
    time: "1637709676.813375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-40.0390625",
    c3: "24.4140625",
    c4: "29.296875",
  },
  {
    "": "741",
    time: "1637709676.8172812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-44.921875",
    c3: "-10.25390625",
    c4: "2.44140625",
  },
  {
    "": "742",
    time: "1637709676.8211875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-39.55078125",
    c3: "-33.69140625",
    c4: "-34.66796875",
  },
  {
    "": "743",
    time: "1637709676.8250937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-42.48046875",
    c3: "-21.97265625",
    c4: "-15.625",
  },
  {
    "": "744",
    time: "1637709676.839125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-48.33984375",
    c3: "-17.08984375",
    c4: "24.90234375",
  },
  {
    "": "745",
    time: "1637709676.8430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-44.921875",
    c3: "-45.8984375",
    c4: "-1.46484375",
  },
  {
    "": "746",
    time: "1637709676.8469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-11.71875",
    c3: "-47.8515625",
    c4: "-49.31640625",
  },
  {
    "": "747",
    time: "1637709676.8508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-12.6953125",
    c3: "-26.85546875",
    c4: "-36.1328125",
  },
  {
    "": "748",
    time: "1637709676.85475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-43.45703125",
    c3: "-9.765625",
    c4: "18.06640625",
  },
  {
    "": "749",
    time: "1637709676.8586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-61.03515625",
    c3: "-31.25",
    c4: "23.4375",
  },
  {
    "": "750",
    time: "1637709676.8625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-58.10546875",
    c3: "-104.4921875",
    c4: "-8.7890625",
  },
  {
    "": "751",
    time: "1637709676.8664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-65.4296875",
    c3: "-49.31640625",
    c4: "-22.4609375",
  },
  {
    "": "752",
    time: "1637709676.870375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-67.3828125",
    c3: "27.34375",
    c4: "6.34765625",
  },
  {
    "": "753",
    time: "1637709676.8742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-29.296875",
    c3: "12.20703125",
    c4: "5.37109375",
  },
  {
    "": "754",
    time: "1637709676.8781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-18.06640625",
    c3: "16.11328125",
    c4: "-32.71484375",
  },
  {
    "": "755",
    time: "1637709676.8820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-16.6015625",
    c3: "32.71484375",
    c4: "-49.8046875",
  },
  {
    "": "756",
    time: "1637709676.884125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-24.4140625",
    c3: "12.6953125",
    c4: "-27.83203125",
  },
  {
    "": "757",
    time: "1637709676.8880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-20.99609375",
    c3: "-2.9296875",
    c4: "-4.39453125",
  },
  {
    "": "758",
    time: "1637709676.8919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-27.83203125",
    c3: "1.46484375",
    c4: "-42.48046875",
  },
  {
    "": "759",
    time: "1637709676.8958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-37.59765625",
    c3: "-12.20703125",
    c4: "-80.078125",
  },
  {
    "": "760",
    time: "1637709676.89975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-28.3203125",
    c3: "-11.71875",
    c4: "-55.17578125",
  },
  {
    "": "761",
    time: "1637709676.9036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-44.43359375",
    c3: "-11.23046875",
    c4: "-9.765625",
  },
  {
    "": "762",
    time: "1637709676.9075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-46.38671875",
    c3: "-52.734375",
    c4: "-37.59765625",
  },
  {
    "": "763",
    time: "1637709676.9114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-34.1796875",
    c3: "-52.734375",
    c4: "-77.1484375",
  },
  {
    "": "764",
    time: "1637709676.915375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-53.7109375",
    c3: "-47.8515625",
    c4: "-62.98828125",
  },
  {
    "": "765",
    time: "1637709676.9192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-86.42578125",
    c3: "-62.98828125",
    c4: "-20.99609375",
  },
  {
    "": "766",
    time: "1637709676.9231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-39.55078125",
    c3: "-21.484375",
    c4: "-22.4609375",
  },
  {
    "": "767",
    time: "1637709676.9270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "3.90625",
    c3: "-2.9296875",
    c4: "-59.5703125",
  },
  {
    "": "768",
    time: "1637709676.929125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-16.6015625",
    c3: "-13.18359375",
    c4: "-60.05859375",
  },
  {
    "": "769",
    time: "1637709676.9330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-26.3671875",
    c3: "4.8828125",
    c4: "-28.3203125",
  },
  {
    "": "770",
    time: "1637709676.9369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-18.06640625",
    c3: "23.92578125",
    c4: "-23.92578125",
  },
  {
    "": "771",
    time: "1637709676.9408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-30.2734375",
    c3: "-7.8125",
    c4: "-59.08203125",
  },
  {
    "": "772",
    time: "1637709676.94475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-48.828125",
    c3: "-51.26953125",
    c4: "-72.75390625",
  },
  {
    "": "773",
    time: "1637709676.9486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-42.96875",
    c3: "-46.875",
    c4: "-45.8984375",
  },
  {
    "": "774",
    time: "1637709676.9525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-35.64453125",
    c3: "-3.90625",
    c4: "-25.390625",
  },
  {
    "": "775",
    time: "1637709676.9564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-36.1328125",
    c3: "7.32421875",
    c4: "-51.7578125",
  },
  {
    "": "776",
    time: "1637709676.960375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-54.19921875",
    c3: "-56.15234375",
    c4: "-58.10546875",
  },
  {
    "": "777",
    time: "1637709676.9642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-53.7109375",
    c3: "-60.546875",
    c4: "-12.20703125",
  },
  {
    "": "778",
    time: "1637709676.9681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-41.015625",
    c3: "-2.44140625",
    c4: "-2.9296875",
  },
  {
    "": "779",
    time: "1637709676.9720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-47.36328125",
    c3: "-4.39453125",
    c4: "-36.1328125",
  },
  {
    "": "780",
    time: "1637709676.973125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-45.41015625",
    c3: "-64.453125",
    c4: "-49.31640625",
  },
  {
    "": "781",
    time: "1637709676.9770312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-20.99609375",
    c3: "-73.2421875",
    c4: "-22.94921875",
  },
  {
    "": "782",
    time: "1637709676.9809375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-2.44140625",
    c3: "-26.3671875",
    c4: "18.5546875",
  },
  {
    "": "783",
    time: "1637709676.9848437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-38.57421875",
    c3: "-18.06640625",
    c4: "7.32421875",
  },
  {
    "": "784",
    time: "1637709676.98875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-68.359375",
    c3: "-24.90234375",
    c4: "-47.8515625",
  },
  {
    "": "785",
    time: "1637709676.9926562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-44.43359375",
    c3: "-34.1796875",
    c4: "-60.546875",
  },
  {
    "": "786",
    time: "1637709676.9965625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-18.06640625",
    c3: "-16.6015625",
    c4: "-18.06640625",
  },
  {
    "": "787",
    time: "1637709677.0004687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-6.8359375",
    c3: "-1.46484375",
    c4: "7.8125",
  },
  {
    "": "788",
    time: "1637709677.004375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-13.671875",
    c3: "-31.73828125",
    c4: "-18.06640625",
  },
  {
    "": "789",
    time: "1637709677.0082812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-20.5078125",
    c3: "-21.97265625",
    c4: "-47.36328125",
  },
  {
    "": "790",
    time: "1637709677.0121875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-42.48046875",
    c3: "-9.765625",
    c4: "-10.7421875",
  },
  {
    "": "791",
    time: "1637709677.0160937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-39.55078125",
    c3: "-36.62109375",
    c4: "20.5078125",
  },
  {
    "": "792",
    time: "1637709677.020125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-25.390625",
    c3: "-47.8515625",
    c4: "-23.92578125",
  },
  {
    "": "793",
    time: "1637709677.0240312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-31.25",
    c3: "-41.9921875",
    c4: "-50.29296875",
  },
  {
    "": "794",
    time: "1637709677.0279374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-27.83203125",
    c3: "-45.41015625",
    c4: "-26.85546875",
  },
  {
    "": "795",
    time: "1637709677.0318437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-24.90234375",
    c3: "-64.453125",
    c4: "17.578125",
  },
  {
    "": "796",
    time: "1637709677.03575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-57.6171875",
    c3: "-68.84765625",
    c4: "16.11328125",
  },
  {
    "": "797",
    time: "1637709677.0396562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-67.87109375",
    c3: "-14.16015625",
    c4: "-33.69140625",
  },
  {
    "": "798",
    time: "1637709677.0435624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-20.99609375",
    c3: "10.25390625",
    c4: "-41.9921875",
  },
  {
    "": "799",
    time: "1637709677.0474687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-18.06640625",
    c3: "-24.90234375",
    c4: "3.90625",
  },
  {
    "": "800",
    time: "1637709677.051375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-24.90234375",
    c3: "-23.92578125",
    c4: "40.0390625",
  },
  {
    "": "801",
    time: "1637709677.0552812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-18.06640625",
    c3: "1.953125",
    c4: "2.9296875",
  },
  {
    "": "802",
    time: "1637709677.0591874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-56.15234375",
    c3: "-36.62109375",
    c4: "-39.0625",
  },
  {
    "": "803",
    time: "1637709677.0630937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-68.359375",
    c3: "-33.203125",
    c4: "-12.20703125",
  },
  {
    "": "804",
    time: "1637709677.066125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-41.9921875",
    c3: "6.8359375",
    c4: "22.4609375",
  },
  {
    "": "805",
    time: "1637709677.0700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-30.76171875",
    c3: "4.8828125",
    c4: "0.48828125",
  },
  {
    "": "806",
    time: "1637709677.0739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-24.90234375",
    c3: "-31.73828125",
    c4: "-35.15625",
  },
  {
    "": "807",
    time: "1637709677.0778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-39.0625",
    c3: "-80.078125",
    c4: "-4.8828125",
  },
  {
    "": "808",
    time: "1637709677.08175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "38.57421875",
    c2: "-63.4765625",
    c3: "-64.453125",
    c4: "32.71484375",
  },
  {
    "": "809",
    time: "1637709677.0856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-35.64453125",
    c3: "-16.6015625",
    c4: "16.6015625",
  },
  {
    "": "810",
    time: "1637709677.0895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-27.34375",
    c3: "-20.5078125",
    c4: "-12.6953125",
  },
  {
    "": "811",
    time: "1637709677.0934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-39.55078125",
    c3: "-51.26953125",
    c4: "-20.5078125",
  },
  {
    "": "812",
    time: "1637709677.097375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-35.15625",
    c3: "-2.44140625",
    c4: "13.18359375",
  },
  {
    "": "813",
    time: "1637709677.1012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-33.69140625",
    c3: "25.87890625",
    c4: "1.953125",
  },
  {
    "": "814",
    time: "1637709677.1051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-51.7578125",
    c3: "-42.48046875",
    c4: "-43.45703125",
  },
  {
    "": "815",
    time: "1637709677.1090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-55.6640625",
    c3: "-30.76171875",
    c4: "-30.76171875",
  },
  {
    "": "816",
    time: "1637709677.109125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-33.69140625",
    c3: "17.578125",
    c4: "-10.7421875",
  },
  {
    "": "817",
    time: "1637709677.1130311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-31.73828125",
    c3: "-14.6484375",
    c4: "8.7890625",
  },
  {
    "": "818",
    time: "1637709677.1169374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-22.94921875",
    c3: "-54.6875",
    c4: "-20.5078125",
  },
  {
    "": "819",
    time: "1637709677.1208436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-22.4609375",
    c3: "-38.0859375",
    c4: "-53.22265625",
  },
  {
    "": "820",
    time: "1637709677.12475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-33.69140625",
    c3: "5.859375",
    c4: "0.0",
  },
  {
    "": "821",
    time: "1637709677.1286561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-29.78515625",
    c3: "12.20703125",
    c4: "24.90234375",
  },
  {
    "": "822",
    time: "1637709677.1325624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-57.6171875",
    c3: "-8.30078125",
    c4: "-24.90234375",
  },
  {
    "": "823",
    time: "1637709677.1364686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-85.9375",
    c3: "-7.32421875",
    c4: "-52.734375",
  },
  {
    "": "824",
    time: "1637709677.140375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-65.91796875",
    c3: "23.4375",
    c4: "-50.78125",
  },
  {
    "": "825",
    time: "1637709677.1442811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-46.875",
    c3: "76.171875",
    c4: "-21.97265625",
  },
  {
    "": "826",
    time: "1637709677.1481874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-35.15625",
    c3: "99.609375",
    c4: "-37.59765625",
  },
  {
    "": "827",
    time: "1637709677.1520936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-2.44140625",
    c3: "111.328125",
    c4: "-91.796875",
  },
  {
    "": "828",
    time: "1637709677.155125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "16.6015625",
    c3: "120.60546875",
    c4: "-75.68359375",
  },
  {
    "": "829",
    time: "1637709677.1590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "16.11328125",
    c3: "145.99609375",
    c4: "-20.99609375",
  },
  {
    "": "830",
    time: "1637709677.1629374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-43.9453125",
    c3: "159.66796875",
    c4: "14.16015625",
  },
  {
    "": "831",
    time: "1637709677.1668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-76.171875",
    c3: "147.4609375",
    c4: "-20.01953125",
  },
  {
    "": "832",
    time: "1637709677.17075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-22.94921875",
    c3: "189.94140625",
    c4: "-67.87109375",
  },
  {
    "": "833",
    time: "1637709677.1746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-1.46484375",
    c3: "193.84765625",
    c4: "-26.85546875",
  },
  {
    "": "834",
    time: "1637709677.1785624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "5.859375",
    c3: "213.8671875",
    c4: "2.44140625",
  },
  {
    "": "835",
    time: "1637709677.1824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-12.20703125",
    c3: "271.97265625",
    c4: "-40.0390625",
  },
  {
    "": "836",
    time: "1637709677.186375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-11.23046875",
    c3: "272.94921875",
    c4: "-55.6640625",
  },
  {
    "": "837",
    time: "1637709677.1902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-6.34765625",
    c3: "201.171875",
    c4: "4.8828125",
  },
  {
    "": "838",
    time: "1637709677.1941874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-44.43359375",
    c3: "147.94921875",
    c4: "61.03515625",
  },
  {
    "": "839",
    time: "1637709677.1980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-25.390625",
    c3: "293.9453125",
    c4: "-1.46484375",
  },
  {
    "": "840",
    time: "1637709677.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "22.94921875",
    c3: "385.25390625",
    c4: "-43.9453125",
  },
  {
    "": "841",
    time: "1637709677.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "27.83203125",
    c3: "381.34765625",
    c4: "-4.39453125",
  },
  {
    "": "842",
    time: "1637709677.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "22.4609375",
    c3: "439.94140625",
    c4: "19.53125",
  },
  {
    "": "843",
    time: "1637709677.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "8.30078125",
    c3: "455.56640625",
    c4: "9.27734375",
  },
  {
    "": "844",
    time: "1637709677.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-16.11328125",
    c3: "446.77734375",
    c4: "-10.25390625",
  },
  {
    "": "845",
    time: "1637709677.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-42.48046875",
    c3: "429.19921875",
    c4: "-0.9765625",
  },
  {
    "": "846",
    time: "1637709677.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-65.91796875",
    c3: "462.890625",
    c4: "26.85546875",
  },
  {
    "": "847",
    time: "1637709677.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-42.48046875",
    c3: "570.80078125",
    c4: "11.71875",
  },
  {
    "": "848",
    time: "1637709677.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "20.5078125",
    c3: "539.55078125",
    c4: "-25.87890625",
  },
  {
    "": "849",
    time: "1637709677.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "24.4140625",
    c3: "541.015625",
    c4: "-35.64453125",
  },
  {
    "": "850",
    time: "1637709677.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "21.97265625",
    c3: "676.26953125",
    c4: "-1.46484375",
  },
  {
    "": "851",
    time: "1637709677.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "40.52734375",
    c3: "705.56640625",
    c4: "5.37109375",
  },
  {
    "": "852",
    time: "1637709677.247125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-3.41796875",
    c3: "678.22265625",
    c4: "-36.1328125",
  },
  {
    "": "853",
    time: "1637709677.2510312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-4.8828125",
    c3: "711.9140625",
    c4: "-31.73828125",
  },
  {
    "": "854",
    time: "1637709677.2549374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "6.8359375",
    c3: "786.1328125",
    c4: "3.90625",
  },
  {
    "": "855",
    time: "1637709677.2588437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-61.03515625",
    c3: "832.03125",
    c4: "32.71484375",
  },
  {
    "": "856",
    time: "1637709677.26275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-31.25",
    c3: "784.66796875",
    c4: "16.6015625",
  },
  {
    "": "857",
    time: "1637709677.2666562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "3.41796875",
    c3: "768.5546875",
    c4: "-24.4140625",
  },
  {
    "": "858",
    time: "1637709677.2705624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "12.6953125",
    c3: "860.3515625",
    c4: "-23.4375",
  },
  {
    "": "859",
    time: "1637709677.2744687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "41.50390625",
    c3: "917.96875",
    c4: "7.8125",
  },
  {
    "": "860",
    time: "1637709677.278375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "59.08203125",
    c3: "903.80859375",
    c4: "-0.9765625",
  },
  {
    "": "861",
    time: "1637709677.2822812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "8.7890625",
    c3: "862.79296875",
    c4: "-24.4140625",
  },
  {
    "": "862",
    time: "1637709677.2861874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-116.2109375",
    c3: "873.53515625",
    c4: "-36.1328125",
  },
  {
    "": "863",
    time: "1637709677.2900937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.0078125",
    c2: "-45.8984375",
    c3: "912.59765625",
    c4: "-21.484375",
  },
  {
    "": "864",
    time: "1637709677.304125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "49.8046875",
    c3: "934.08203125",
    c4: "24.4140625",
  },
  {
    "": "865",
    time: "1637709677.3080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-81.54296875",
    c3: "932.6171875",
    c4: "-2.44140625",
  },
  {
    "": "866",
    time: "1637709677.3119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-37.59765625",
    c3: "941.40625",
    c4: "-42.48046875",
  },
  {
    "": "867",
    time: "1637709677.3158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "162.109375",
    c3: "947.75390625",
    c4: "-18.5546875",
  },
  {
    "": "868",
    time: "1637709677.31975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "107.421875",
    c3: "954.58984375",
    c4: "5.859375",
  },
  {
    "": "869",
    time: "1637709677.3236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "22.94921875",
    c3: "956.54296875",
    c4: "-14.16015625",
  },
  {
    "": "870",
    time: "1637709677.3275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "63.4765625",
    c3: "958.49609375",
    c4: "-51.7578125",
  },
  {
    "": "871",
    time: "1637709677.3314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.078125",
    c2: "122.55859375",
    c3: "955.078125",
    c4: "-37.59765625",
  },
  {
    "": "872",
    time: "1637709677.335375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "93.26171875",
    c3: "949.70703125",
    c4: "23.4375",
  },
  {
    "": "873",
    time: "1637709677.3392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "89.35546875",
    c3: "960.9375",
    c4: "19.04296875",
  },
  {
    "": "874",
    time: "1637709677.3431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "111.328125",
    c3: "965.8203125",
    c4: "-43.9453125",
  },
  {
    "": "875",
    time: "1637709677.3470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "110.83984375",
    c3: "964.35546875",
    c4: "-62.98828125",
  },
  {
    "": "876",
    time: "1637709677.350125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "136.23046875",
    c3: "964.35546875",
    c4: "3.41796875",
  },
  {
    "": "877",
    time: "1637709677.3540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "79.1015625",
    c3: "964.84375",
    c4: "20.01953125",
  },
  {
    "": "878",
    time: "1637709677.3579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "79.1015625",
    c3: "965.33203125",
    c4: "-41.50390625",
  },
  {
    "": "879",
    time: "1637709677.3618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "180.17578125",
    c3: "964.84375",
    c4: "-20.01953125",
  },
  {
    "": "880",
    time: "1637709677.36575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "170.41015625",
    c3: "965.8203125",
    c4: "9.27734375",
  },
  {
    "": "881",
    time: "1637709677.3696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "83.984375",
    c3: "965.8203125",
    c4: "-15.625",
  },
  {
    "": "882",
    time: "1637709677.3735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "73.73046875",
    c3: "967.28515625",
    c4: "-35.64453125",
  },
  {
    "": "883",
    time: "1637709677.3774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.1953125",
    c2: "177.24609375",
    c3: "967.28515625",
    c4: "-53.22265625",
  },
  {
    "": "884",
    time: "1637709677.381375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "231.4453125",
    c3: "968.26171875",
    c4: "-25.87890625",
  },
  {
    "": "885",
    time: "1637709677.3852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "232.91015625",
    c3: "969.7265625",
    c4: "9.765625",
  },
  {
    "": "886",
    time: "1637709677.3891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "257.8125",
    c3: "969.23828125",
    c4: "-20.01953125",
  },
  {
    "": "887",
    time: "1637709677.3930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "233.3984375",
    c3: "968.26171875",
    c4: "-53.22265625",
  },
  {
    "": "888",
    time: "1637709677.394125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "196.2890625",
    c3: "968.75",
    c4: "-35.15625",
  },
  {
    "": "889",
    time: "1637709677.3980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "213.8671875",
    c3: "968.75",
    c4: "19.53125",
  },
  {
    "": "890",
    time: "1637709677.4019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "229.98046875",
    c3: "967.7734375",
    c4: "-9.765625",
  },
  {
    "": "891",
    time: "1637709677.4058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "56.15234375",
    c2: "217.7734375",
    c3: "968.75",
    c4: "-31.25",
  },
  {
    "": "892",
    time: "1637709677.40975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "224.12109375",
    c3: "968.75",
    c4: "-12.6953125",
  },
  {
    "": "893",
    time: "1637709677.4136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "241.69921875",
    c3: "967.7734375",
    c4: "10.25390625",
  },
  {
    "": "894",
    time: "1637709677.4175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "40.52734375",
    c2: "244.140625",
    c3: "967.28515625",
    c4: "16.11328125",
  },
  {
    "": "895",
    time: "1637709677.4214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "286.1328125",
    c3: "965.8203125",
    c4: "-16.11328125",
  },
  {
    "": "896",
    time: "1637709677.425375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "283.203125",
    c3: "966.796875",
    c4: "-18.5546875",
  },
  {
    "": "897",
    time: "1637709677.4292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "212.40234375",
    c3: "968.26171875",
    c4: "10.7421875",
  },
  {
    "": "898",
    time: "1637709677.4331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "263.18359375",
    c3: "967.28515625",
    c4: "20.01953125",
  },
  {
    "": "899",
    time: "1637709677.4370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "298.828125",
    c3: "966.30859375",
    c4: "-13.18359375",
  },
  {
    "": "900",
    time: "1637709677.441125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "290.52734375",
    c3: "966.30859375",
    c4: "-24.90234375",
  },
  {
    "": "901",
    time: "1637709677.4450312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "292.96875",
    c3: "966.30859375",
    c4: "21.97265625",
  },
  {
    "": "902",
    time: "1637709677.4489374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "249.0234375",
    c3: "966.30859375",
    c4: "56.15234375",
  },
  {
    "": "903",
    time: "1637709677.4528437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "247.55859375",
    c3: "965.8203125",
    c4: "11.23046875",
  },
  {
    "": "904",
    time: "1637709677.45675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "262.6953125",
    c3: "965.33203125",
    c4: "-36.1328125",
  },
  {
    "": "905",
    time: "1637709677.4606562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "238.76953125",
    c3: "964.84375",
    c4: "-10.7421875",
  },
  {
    "": "906",
    time: "1637709677.4645624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "224.609375",
    c3: "964.35546875",
    c4: "40.52734375",
  },
  {
    "": "907",
    time: "1637709677.4684687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "230.95703125",
    c3: "963.8671875",
    c4: "38.0859375",
  },
  {
    "": "908",
    time: "1637709677.472375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "224.609375",
    c3: "963.8671875",
    c4: "-10.7421875",
  },
  {
    "": "909",
    time: "1637709677.4762812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "217.28515625",
    c3: "962.40234375",
    c4: "-22.94921875",
  },
  {
    "": "910",
    time: "1637709677.4801874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "231.4453125",
    c3: "961.9140625",
    c4: "16.11328125",
  },
  {
    "": "911",
    time: "1637709677.4840937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "229.00390625",
    c3: "961.9140625",
    c4: "34.1796875",
  },
  {
    "": "912",
    time: "1637709677.485125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "220.21484375",
    c3: "959.47265625",
    c4: "-0.48828125",
  },
  {
    "": "913",
    time: "1637709677.4890313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "214.35546875",
    c3: "958.0078125",
    c4: "-27.34375",
  },
  {
    "": "914",
    time: "1637709677.4929376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "204.1015625",
    c3: "955.56640625",
    c4: "-4.39453125",
  },
  {
    "": "915",
    time: "1637709677.4968438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "198.2421875",
    c3: "953.125",
    c4: "23.4375",
  },
  {
    "": "916",
    time: "1637709677.50075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "189.94140625",
    c3: "953.61328125",
    c4: "-7.32421875",
  },
  {
    "": "917",
    time: "1637709677.5046563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "183.10546875",
    c3: "952.63671875",
    c4: "-55.6640625",
  },
  {
    "": "918",
    time: "1637709677.5085626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "175.29296875",
    c3: "947.265625",
    c4: "9.27734375",
  },
  {
    "": "919",
    time: "1637709677.5124688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "153.3203125",
    c3: "948.2421875",
    c4: "23.92578125",
  },
  {
    "": "920",
    time: "1637709677.516375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-92.7734375",
    c2: "145.01953125",
    c3: "949.21875",
    c4: "-86.42578125",
  },
  {
    "": "921",
    time: "1637709677.5202813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-115.72265625",
    c2: "159.1796875",
    c3: "940.91796875",
    c4: "-118.1640625",
  },
  {
    "": "922",
    time: "1637709677.5241876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-94.23828125",
    c2: "159.66796875",
    c3: "936.03515625",
    c4: "-96.6796875",
  },
  {
    "": "923",
    time: "1637709677.5280938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.9140625",
    c2: "128.41796875",
    c3: "931.15234375",
    c4: "-86.9140625",
  },
  {
    "": "924",
    time: "1637709677.531125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-119.62890625",
    c2: "122.55859375",
    c3: "919.921875",
    c4: "-104.00390625",
  },
  {
    "": "925",
    time: "1637709677.5350313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-160.64453125",
    c2: "138.671875",
    c3: "918.9453125",
    c4: "-137.20703125",
  },
  {
    "": "926",
    time: "1637709677.5389376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-158.203125",
    c2: "126.953125",
    c3: "924.8046875",
    c4: "-166.50390625",
  },
  {
    "": "927",
    time: "1637709677.5428438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-161.62109375",
    c2: "129.39453125",
    c3: "917.48046875",
    c4: "-171.38671875",
  },
  {
    "": "928",
    time: "1637709677.54675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-185.546875",
    c2: "131.34765625",
    c3: "918.45703125",
    c4: "-204.58984375",
  },
  {
    "": "929",
    time: "1637709677.5506563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-222.16796875",
    c2: "128.90625",
    c3: "871.58203125",
    c4: "-262.6953125",
  },
  {
    "": "930",
    time: "1637709677.5545626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-241.69921875",
    c2: "134.27734375",
    c3: "819.82421875",
    c4: "-295.41015625",
  },
  {
    "": "931",
    time: "1637709677.5584688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-246.09375",
    c2: "105.95703125",
    c3: "877.9296875",
    c4: "-315.91796875",
  },
  {
    "": "932",
    time: "1637709677.562375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-242.1875",
    c2: "79.58984375",
    c3: "887.20703125",
    c4: "-309.5703125",
  },
  {
    "": "933",
    time: "1637709677.5662813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-274.4140625",
    c2: "89.84375",
    c3: "821.77734375",
    c4: "-351.07421875",
  },
  {
    "": "934",
    time: "1637709677.5701876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-316.89453125",
    c2: "85.9375",
    c3: "782.2265625",
    c4: "-380.859375",
  },
  {
    "": "935",
    time: "1637709677.5740938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-302.24609375",
    c2: "79.58984375",
    c3: "786.62109375",
    c4: "-350.5859375",
  },
  {
    "": "936",
    time: "1637709677.589125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-289.0625",
    c2: "75.68359375",
    c3: "782.71484375",
    c4: "-354.4921875",
  },
  {
    "": "937",
    time: "1637709677.5930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-296.38671875",
    c2: "59.08203125",
    c3: "733.88671875",
    c4: "-368.1640625",
  },
  {
    "": "938",
    time: "1637709677.5969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-326.66015625",
    c2: "44.921875",
    c3: "692.87109375",
    c4: "-395.99609375",
  },
  {
    "": "939",
    time: "1637709677.6008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-252.44140625",
    c2: "45.41015625",
    c3: "648.92578125",
    c4: "-383.7890625",
  },
  {
    "": "940",
    time: "1637709677.60475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-187.5",
    c2: "-20.5078125",
    c3: "539.0625",
    c4: "-317.3828125",
  },
  {
    "": "941",
    time: "1637709677.6086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-247.55859375",
    c2: "-38.57421875",
    c3: "498.53515625",
    c4: "-296.38671875",
  },
  {
    "": "942",
    time: "1637709677.6125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-279.296875",
    c2: "44.43359375",
    c3: "592.28515625",
    c4: "-365.234375",
  },
  {
    "": "943",
    time: "1637709677.6164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-259.765625",
    c2: "85.9375",
    c3: "699.21875",
    c4: "-399.4140625",
  },
  {
    "": "944",
    time: "1637709677.620375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-225.09765625",
    c2: "96.19140625",
    c3: "742.67578125",
    c4: "-325.68359375",
  },
  {
    "": "945",
    time: "1637709677.6242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-225.5859375",
    c2: "79.1015625",
    c3: "702.63671875",
    c4: "-302.734375",
  },
  {
    "": "946",
    time: "1637709677.6281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-219.7265625",
    c2: "66.40625",
    c3: "646.97265625",
    c4: "-341.796875",
  },
  {
    "": "947",
    time: "1637709677.6320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-220.21484375",
    c2: "65.91796875",
    c3: "618.65234375",
    c4: "-351.07421875",
  },
  {
    "": "948",
    time: "1637709677.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-205.56640625",
    c2: "33.69140625",
    c3: "603.515625",
    c4: "-288.0859375",
  },
  {
    "": "949",
    time: "1637709677.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-183.59375",
    c2: "-10.7421875",
    c3: "588.37890625",
    c4: "-256.8359375",
  },
  {
    "": "950",
    time: "1637709677.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-207.51953125",
    c2: "15.13671875",
    c3: "575.68359375",
    c4: "-300.29296875",
  },
  {
    "": "951",
    time: "1637709677.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-212.40234375",
    c2: "59.5703125",
    c3: "546.875",
    c4: "-322.75390625",
  },
  {
    "": "952",
    time: "1637709677.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-172.36328125",
    c2: "66.40625",
    c3: "503.90625",
    c4: "-269.53125",
  },
  {
    "": "953",
    time: "1637709677.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-139.16015625",
    c2: "59.08203125",
    c3: "486.81640625",
    c4: "-192.87109375",
  },
  {
    "": "954",
    time: "1637709677.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-145.5078125",
    c2: "58.59375",
    c3: "504.8828125",
    c4: "-225.09765625",
  },
  {
    "": "955",
    time: "1637709677.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-169.43359375",
    c2: "62.98828125",
    c3: "507.32421875",
    c4: "-273.4375",
  },
  {
    "": "956",
    time: "1637709677.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-144.04296875",
    c2: "55.17578125",
    c3: "438.4765625",
    c4: "-240.72265625",
  },
  {
    "": "957",
    time: "1637709677.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-113.28125",
    c2: "35.64453125",
    c3: "396.484375",
    c4: "-187.98828125",
  },
  {
    "": "958",
    time: "1637709677.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-140.13671875",
    c2: "31.25",
    c3: "461.42578125",
    c4: "-197.75390625",
  },
  {
    "": "959",
    time: "1637709677.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-166.015625",
    c2: "44.43359375",
    c3: "443.359375",
    c4: "-229.4921875",
  },
  {
    "": "960",
    time: "1637709677.679125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-162.59765625",
    c2: "48.33984375",
    c3: "413.57421875",
    c4: "-221.6796875",
  },
  {
    "": "961",
    time: "1637709677.6830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-132.32421875",
    c2: "55.6640625",
    c3: "453.125",
    c4: "-152.34375",
  },
  {
    "": "962",
    time: "1637709677.6869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "44.921875",
    c3: "370.60546875",
    c4: "-104.98046875",
  },
  {
    "": "963",
    time: "1637709677.6908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-117.67578125",
    c2: "38.57421875",
    c3: "306.640625",
    c4: "-168.45703125",
  },
  {
    "": "964",
    time: "1637709677.69475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-148.92578125",
    c2: "41.9921875",
    c3: "348.14453125",
    c4: "-213.37890625",
  },
  {
    "": "965",
    time: "1637709677.6986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-115.234375",
    c2: "51.7578125",
    c3: "385.25390625",
    c4: "-152.34375",
  },
  {
    "": "966",
    time: "1637709677.7025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-88.37890625",
    c2: "38.0859375",
    c3: "470.703125",
    c4: "-95.703125",
  },
  {
    "": "967",
    time: "1637709677.7064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-90.33203125",
    c2: "20.01953125",
    c3: "414.55078125",
    c4: "-125.9765625",
  },
  {
    "": "968",
    time: "1637709677.710375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-113.28125",
    c2: "-10.25390625",
    c3: "340.8203125",
    c4: "-154.78515625",
  },
  {
    "": "969",
    time: "1637709677.7142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-115.72265625",
    c2: "17.08984375",
    c3: "428.22265625",
    c4: "-122.55859375",
  },
  {
    "": "970",
    time: "1637709677.7181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-89.35546875",
    c2: "83.49609375",
    c3: "470.21484375",
    c4: "-101.5625",
  },
  {
    "": "971",
    time: "1637709677.7220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-88.37890625",
    c2: "75.68359375",
    c3: "430.6640625",
    c4: "-124.0234375",
  },
  {
    "": "972",
    time: "1637709677.726125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-99.12109375",
    c2: "51.26953125",
    c3: "412.59765625",
    c4: "-138.18359375",
  },
  {
    "": "973",
    time: "1637709677.7300313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-103.02734375",
    c2: "45.41015625",
    c3: "414.55078125",
    c4: "-121.58203125",
  },
  {
    "": "974",
    time: "1637709677.7339375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "52.24609375",
    c3: "399.90234375",
    c4: "-98.6328125",
  },
  {
    "": "975",
    time: "1637709677.7378438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "46.38671875",
    c3: "360.83984375",
    c4: "-100.5859375",
  },
  {
    "": "976",
    time: "1637709677.74175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.40234375",
    c2: "33.203125",
    c3: "333.49609375",
    c4: "-116.69921875",
  },
  {
    "": "977",
    time: "1637709677.7456563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.61328125",
    c2: "39.55078125",
    c3: "353.02734375",
    c4: "-99.609375",
  },
  {
    "": "978",
    time: "1637709677.7495625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "57.6171875",
    c3: "328.61328125",
    c4: "-79.58984375",
  },
  {
    "": "979",
    time: "1637709677.7534688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "54.19921875",
    c3: "294.43359375",
    c4: "-68.84765625",
  },
  {
    "": "980",
    time: "1637709677.757375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "44.43359375",
    c3: "275.390625",
    c4: "-50.78125",
  },
  {
    "": "981",
    time: "1637709677.7612813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "1.953125",
    c3: "230.46875",
    c4: "-78.61328125",
  },
  {
    "": "982",
    time: "1637709677.7651875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-35.64453125",
    c3: "233.3984375",
    c4: "-83.0078125",
  },
  {
    "": "983",
    time: "1637709677.7690938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-2.44140625",
    c3: "314.453125",
    c4: "-18.5546875",
  },
  {
    "": "984",
    time: "1637709677.769125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "29.296875",
    c3: "381.8359375",
    c4: "-23.92578125",
  },
  {
    "": "985",
    time: "1637709677.7730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-8.7890625",
    c3: "363.28125",
    c4: "-70.3125",
  },
  {
    "": "986",
    time: "1637709677.7769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-13.18359375",
    c3: "324.70703125",
    c4: "-61.03515625",
  },
  {
    "": "987",
    time: "1637709677.7808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "67.87109375",
    c3: "311.5234375",
    c4: "-32.2265625",
  },
  {
    "": "988",
    time: "1637709677.78475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "101.5625",
    c3: "333.49609375",
    c4: "-27.34375",
  },
  {
    "": "989",
    time: "1637709677.7886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "82.51953125",
    c3: "350.09765625",
    c4: "-49.8046875",
  },
  {
    "": "990",
    time: "1637709677.7925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "78.125",
    c3: "372.55859375",
    c4: "-42.96875",
  },
  {
    "": "991",
    time: "1637709677.7964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "40.52734375",
    c3: "379.39453125",
    c4: "16.6015625",
  },
  {
    "": "992",
    time: "1637709677.800375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "1.46484375",
    c3: "315.91796875",
    c4: "29.296875",
  },
  {
    "": "993",
    time: "1637709677.8042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "20.01953125",
    c3: "328.125",
    c4: "-30.76171875",
  },
  {
    "": "994",
    time: "1637709677.8081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "41.50390625",
    c3: "370.1171875",
    c4: "-11.23046875",
  },
  {
    "": "995",
    time: "1637709677.8120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "45.41015625",
    c3: "380.37109375",
    c4: "50.29296875",
  },
  {
    "": "996",
    time: "1637709677.816125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "39.0625",
    c3: "416.9921875",
    c4: "61.03515625",
  },
  {
    "": "997",
    time: "1637709677.8200312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "30.2734375",
    c3: "429.19921875",
    c4: "27.34375",
  },
  {
    "": "998",
    time: "1637709677.8239374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "22.94921875",
    c3: "366.2109375",
    c4: "34.66796875",
  },
  {
    "": "999",
    time: "1637709677.8278437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "22.94921875",
    c3: "368.1640625",
    c4: "66.89453125",
  },
  {
    "": "1000",
    time: "1637709677.83175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "26.85546875",
    c2: "2.44140625",
    c3: "343.26171875",
    c4: "79.1015625",
  },
  {
    "": "1001",
    time: "1637709677.8356562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-19.04296875",
    c3: "219.7265625",
    c4: "68.359375",
  },
  {
    "": "1002",
    time: "1637709677.8395624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "4.8828125",
    c3: "208.984375",
    c4: "33.203125",
  },
  {
    "": "1003",
    time: "1637709677.8434687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "9.27734375",
    c3: "248.53515625",
    c4: "69.3359375",
  },
  {
    "": "1004",
    time: "1637709677.847375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "15.625",
    c2: "2.44140625",
    c3: "321.77734375",
    c4: "104.98046875",
  },
  {
    "": "1005",
    time: "1637709677.8512812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "18.06640625",
    c2: "25.87890625",
    c3: "333.49609375",
    c4: "80.078125",
  },
  {
    "": "1006",
    time: "1637709677.8551874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "39.55078125",
    c2: "28.3203125",
    c3: "267.08984375",
    c4: "52.24609375",
  },
  {
    "": "1007",
    time: "1637709677.8590937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "59.08203125",
    c2: "-3.41796875",
    c3: "294.921875",
    c4: "80.56640625",
  },
  {
    "": "1008",
    time: "1637709677.859125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "85.9375",
    c2: "-21.484375",
    c3: "321.2890625",
    c4: "151.3671875",
  },
  {
    "": "1009",
    time: "1637709677.8630311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "104.4921875",
    c2: "7.32421875",
    c3: "303.7109375",
    c4: "153.80859375",
  },
  {
    "": "1010",
    time: "1637709677.8669374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "71.2890625",
    c2: "22.94921875",
    c3: "333.0078125",
    c4: "96.6796875",
  },
  {
    "": "1011",
    time: "1637709677.8708436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "49.8046875",
    c2: "22.94921875",
    c3: "339.35546875",
    c4: "80.078125",
  },
  {
    "": "1012",
    time: "1637709677.87475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "88.8671875",
    c2: "10.25390625",
    c3: "358.3984375",
    c4: "135.7421875",
  },
  {
    "": "1013",
    time: "1637709677.8786561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "138.18359375",
    c2: "2.44140625",
    c3: "394.53125",
    c4: "181.640625",
  },
  {
    "": "1014",
    time: "1637709677.8825624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "140.13671875",
    c2: "19.04296875",
    c3: "346.6796875",
    c4: "152.83203125",
  },
  {
    "": "1015",
    time: "1637709677.8864686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "124.0234375",
    c2: "23.4375",
    c3: "327.1484375",
    c4: "149.4140625",
  },
  {
    "": "1016",
    time: "1637709677.890375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "136.71875",
    c2: "20.5078125",
    c3: "352.05078125",
    c4: "189.94140625",
  },
  {
    "": "1017",
    time: "1637709677.8942811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "168.9453125",
    c2: "3.90625",
    c3: "321.77734375",
    c4: "230.95703125",
  },
  {
    "": "1018",
    time: "1637709677.8981874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "191.40625",
    c2: "-9.765625",
    c3: "302.24609375",
    c4: "246.09375",
  },
  {
    "": "1019",
    time: "1637709677.9020936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "179.19921875",
    c2: "-2.44140625",
    c3: "306.15234375",
    c4: "218.26171875",
  },
  {
    "": "1020",
    time: "1637709677.906125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "178.7109375",
    c2: "5.859375",
    c3: "296.875",
    c4: "209.47265625",
  },
  {
    "": "1021",
    time: "1637709677.9100313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "203.61328125",
    c2: "12.20703125",
    c3: "267.578125",
    c4: "248.046875",
  },
  {
    "": "1022",
    time: "1637709677.9139376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "218.75",
    c2: "13.671875",
    c3: "252.9296875",
    c4: "265.13671875",
  },
  {
    "": "1023",
    time: "1637709677.9178438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "200.1953125",
    c2: "9.27734375",
    c3: "213.8671875",
    c4: "230.46875",
  },
  {
    "": "1024",
    time: "1637709677.92175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "199.21875",
    c2: "19.04296875",
    c3: "208.49609375",
    c4: "225.09765625",
  },
  {
    "": "1025",
    time: "1637709677.9256563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "229.4921875",
    c2: "20.01953125",
    c3: "223.14453125",
    c4: "281.25",
  },
  {
    "": "1026",
    time: "1637709677.9295626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "231.4453125",
    c2: "17.08984375",
    c3: "210.44921875",
    c4: "310.546875",
  },
  {
    "": "1027",
    time: "1637709677.9334688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "219.23828125",
    c2: "18.5546875",
    c3: "233.3984375",
    c4: "280.76171875",
  },
  {
    "": "1028",
    time: "1637709677.937375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "211.9140625",
    c2: "13.671875",
    c3: "217.7734375",
    c4: "254.8828125",
  },
  {
    "": "1029",
    time: "1637709677.9412813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "222.65625",
    c2: "3.90625",
    c3: "185.05859375",
    c4: "263.18359375",
  },
  {
    "": "1030",
    time: "1637709677.9451876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "239.74609375",
    c2: "0.0",
    c3: "183.59375",
    c4: "296.38671875",
  },
  {
    "": "1031",
    time: "1637709677.9490938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "254.8828125",
    c2: "-5.859375",
    c3: "176.26953125",
    c4: "296.38671875",
  },
  {
    "": "1032",
    time: "1637709677.950125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "219.7265625",
    c2: "-8.7890625",
    c3: "141.11328125",
    c4: "246.58203125",
  },
  {
    "": "1033",
    time: "1637709677.9540312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "176.7578125",
    c2: "5.37109375",
    c3: "91.796875",
    c4: "225.5859375",
  },
  {
    "": "1034",
    time: "1637709677.9579375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "221.6796875",
    c2: "-10.25390625",
    c3: "122.0703125",
    c4: "243.65234375",
  },
  {
    "": "1035",
    time: "1637709677.9618437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "246.09375",
    c2: "-30.2734375",
    c3: "157.71484375",
    c4: "235.83984375",
  },
  {
    "": "1036",
    time: "1637709677.96575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "184.5703125",
    c2: "-18.06640625",
    c3: "124.0234375",
    c4: "213.37890625",
  },
  {
    "": "1037",
    time: "1637709677.9696562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "161.1328125",
    c2: "-0.9765625",
    c3: "72.75390625",
    c4: "216.796875",
  },
  {
    "": "1038",
    time: "1637709677.9735625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "184.08203125",
    c2: "28.3203125",
    c3: "93.75",
    c4: "258.30078125",
  },
  {
    "": "1039",
    time: "1637709677.9774687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "158.203125",
    c2: "15.625",
    c3: "186.03515625",
    c4: "223.6328125",
  },
  {
    "": "1040",
    time: "1637709677.981375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "140.13671875",
    c2: "-6.8359375",
    c3: "153.3203125",
    c4: "169.921875",
  },
  {
    "": "1041",
    time: "1637709677.9852812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "143.5546875",
    c2: "11.71875",
    c3: "125.0",
    c4: "168.9453125",
  },
  {
    "": "1042",
    time: "1637709677.9891875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "137.20703125",
    c2: "8.7890625",
    c3: "142.578125",
    c4: "174.8046875",
  },
  {
    "": "1043",
    time: "1637709677.9930937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "135.25390625",
    c2: "15.625",
    c3: "161.1328125",
    c4: "195.3125",
  },
  {
    "": "1044",
    time: "1637709678.009125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "125.0",
    c2: "12.20703125",
    c3: "133.7890625",
    c4: "154.78515625",
  },
  {
    "": "1045",
    time: "1637709678.0130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "122.55859375",
    c2: "15.13671875",
    c3: "46.875",
    c4: "121.09375",
  },
  {
    "": "1046",
    time: "1637709678.0169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "135.25390625",
    c2: "29.78515625",
    c3: "67.87109375",
    c4: "142.578125",
  },
  {
    "": "1047",
    time: "1637709678.0208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "150.87890625",
    c2: "4.39453125",
    c3: "138.671875",
    c4: "163.57421875",
  },
  {
    "": "1048",
    time: "1637709678.02475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "130.37109375",
    c2: "-2.44140625",
    c3: "89.35546875",
    c4: "137.20703125",
  },
  {
    "": "1049",
    time: "1637709678.0286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "88.8671875",
    c2: "12.20703125",
    c3: "19.53125",
    c4: "90.33203125",
  },
  {
    "": "1050",
    time: "1637709678.0325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "85.9375",
    c2: "-7.8125",
    c3: "73.73046875",
    c4: "102.05078125",
  },
  {
    "": "1051",
    time: "1637709678.0364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "89.35546875",
    c2: "-14.6484375",
    c3: "111.328125",
    c4: "133.7890625",
  },
  {
    "": "1052",
    time: "1637709678.040375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "87.890625",
    c2: "-2.9296875",
    c3: "59.08203125",
    c4: "112.79296875",
  },
  {
    "": "1053",
    time: "1637709678.0442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "77.63671875",
    c2: "-7.32421875",
    c3: "9.27734375",
    c4: "71.2890625",
  },
  {
    "": "1054",
    time: "1637709678.0481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "70.3125",
    c2: "8.7890625",
    c3: "39.55078125",
    c4: "78.125",
  },
  {
    "": "1055",
    time: "1637709678.0520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "83.984375",
    c2: "0.9765625",
    c3: "32.71484375",
    c4: "96.6796875",
  },
  {
    "": "1056",
    time: "1637709678.054125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "73.73046875",
    c2: "11.71875",
    c3: "-3.90625",
    c4: "81.0546875",
  },
  {
    "": "1057",
    time: "1637709678.0580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "48.33984375",
    c2: "0.0",
    c3: "-19.04296875",
    c4: "47.36328125",
  },
  {
    "": "1058",
    time: "1637709678.0619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "39.0625",
    c2: "-26.3671875",
    c3: "-0.9765625",
    c4: "41.015625",
  },
  {
    "": "1059",
    time: "1637709678.0658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "45.41015625",
    c2: "-25.87890625",
    c3: "0.48828125",
    c4: "84.9609375",
  },
  {
    "": "1060",
    time: "1637709678.06975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "64.94140625",
    c2: "-34.1796875",
    c3: "-16.6015625",
    c4: "89.35546875",
  },
  {
    "": "1061",
    time: "1637709678.0736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "35.15625",
    c2: "-34.66796875",
    c3: "-8.30078125",
    c4: "41.9921875",
  },
  {
    "": "1062",
    time: "1637709678.0775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-30.2734375",
    c3: "-20.01953125",
    c4: "9.27734375",
  },
  {
    "": "1063",
    time: "1637709678.0814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.11328125",
    c2: "-23.92578125",
    c3: "-42.96875",
    c4: "26.3671875",
  },
  {
    "": "1064",
    time: "1637709678.085375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "72.265625",
    c2: "-22.94921875",
    c3: "-96.6796875",
    c4: "72.75390625",
  },
  {
    "": "1065",
    time: "1637709678.0892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "54.19921875",
    c2: "-28.3203125",
    c3: "-76.171875",
    c4: "64.453125",
  },
  {
    "": "1066",
    time: "1637709678.0931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-20.01953125",
    c3: "18.5546875",
    c4: "16.6015625",
  },
  {
    "": "1067",
    time: "1637709678.0970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-8.30078125",
    c3: "-29.78515625",
    c4: "27.34375",
  },
  {
    "": "1068",
    time: "1637709678.100125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "1.953125",
    c3: "-89.35546875",
    c4: "57.12890625",
  },
  {
    "": "1069",
    time: "1637709678.1040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "19.53125",
    c3: "-25.87890625",
    c4: "41.50390625",
  },
  {
    "": "1070",
    time: "1637709678.1079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-2.9296875",
    c3: "-17.578125",
    c4: "8.30078125",
  },
  {
    "": "1071",
    time: "1637709678.1118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-26.85546875",
    c3: "-58.10546875",
    c4: "12.20703125",
  },
  {
    "": "1072",
    time: "1637709678.11575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-10.7421875",
    c3: "-51.26953125",
    c4: "64.453125",
  },
  {
    "": "1073",
    time: "1637709678.1196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.578125",
    c2: "-8.30078125",
    c3: "-36.62109375",
    c4: "59.5703125",
  },
  {
    "": "1074",
    time: "1637709678.1235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-6.8359375",
    c3: "-47.36328125",
    c4: "16.11328125",
  },
  {
    "": "1075",
    time: "1637709678.1274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-20.01953125",
    c3: "-114.74609375",
    c4: "0.0",
  },
  {
    "": "1076",
    time: "1637709678.131375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.4609375",
    c2: "-42.96875",
    c3: "-140.625",
    c4: "29.78515625",
  },
  {
    "": "1077",
    time: "1637709678.1352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "33.203125",
    c2: "-20.01953125",
    c3: "-26.3671875",
    c4: "66.40625",
  },
  {
    "": "1078",
    time: "1637709678.1391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "21.484375",
    c2: "-9.765625",
    c3: "27.83203125",
    c4: "34.1796875",
  },
  {
    "": "1079",
    time: "1637709678.1430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-28.80859375",
    c3: "-28.80859375",
    c4: "13.671875",
  },
  {
    "": "1080",
    time: "1637709678.144125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-40.52734375",
    c3: "-31.73828125",
    c4: "18.06640625",
  },
  {
    "": "1081",
    time: "1637709678.1480312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.11328125",
    c2: "-27.83203125",
    c3: "10.25390625",
    c4: "51.26953125",
  },
  {
    "": "1082",
    time: "1637709678.1519375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.11328125",
    c2: "-19.53125",
    c3: "1.46484375",
    c4: "52.734375",
  },
  {
    "": "1083",
    time: "1637709678.1558437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-23.4375",
    c3: "-24.90234375",
    c4: "17.08984375",
  },
  {
    "": "1084",
    time: "1637709678.15975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-32.71484375",
    c3: "-18.5546875",
    c4: "20.99609375",
  },
  {
    "": "1085",
    time: "1637709678.1636562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-37.109375",
    c3: "-24.4140625",
    c4: "58.59375",
  },
  {
    "": "1086",
    time: "1637709678.1675625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.5078125",
    c2: "-31.73828125",
    c3: "-49.31640625",
    c4: "66.89453125",
  },
  {
    "": "1087",
    time: "1637709678.1714687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-28.80859375",
    c3: "-81.54296875",
    c4: "42.96875",
  },
  {
    "": "1088",
    time: "1637709678.175375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "21.484375",
    c2: "-24.4140625",
    c3: "-47.8515625",
    c4: "61.5234375",
  },
  {
    "": "1089",
    time: "1637709678.1792812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "28.80859375",
    c2: "-55.6640625",
    c3: "21.97265625",
    c4: "77.1484375",
  },
  {
    "": "1090",
    time: "1637709678.1831875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-81.54296875",
    c3: "-3.90625",
    c4: "56.640625",
  },
  {
    "": "1091",
    time: "1637709678.1870937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-44.921875",
    c3: "-13.671875",
    c4: "38.0859375",
  },
  {
    "": "1092",
    time: "1637709678.192125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.671875",
    c2: "1.46484375",
    c3: "3.90625",
    c4: "39.0625",
  },
  {
    "": "1093",
    time: "1637709678.1960313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "23.92578125",
    c2: "-11.71875",
    c3: "-23.4375",
    c4: "53.22265625",
  },
  {
    "": "1094",
    time: "1637709678.1999376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "43.9453125",
    c2: "-37.59765625",
    c3: "-46.875",
    c4: "70.3125",
  },
  {
    "": "1095",
    time: "1637709678.2038438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "26.85546875",
    c2: "-15.13671875",
    c3: "-42.48046875",
    c4: "50.78125",
  },
  {
    "": "1096",
    time: "1637709678.20775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-7.32421875",
    c3: "-38.0859375",
    c4: "17.08984375",
  },
  {
    "": "1097",
    time: "1637709678.2116563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-4.39453125",
    c3: "-33.69140625",
    c4: "9.765625",
  },
  {
    "": "1098",
    time: "1637709678.2155626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "12.6953125",
    c3: "-22.4609375",
    c4: "36.62109375",
  },
  {
    "": "1099",
    time: "1637709678.2194688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "9.765625",
    c3: "-30.2734375",
    c4: "51.7578125",
  },
  {
    "": "1100",
    time: "1637709678.223375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-8.7890625",
    c3: "-26.85546875",
    c4: "12.6953125",
  },
  {
    "": "1101",
    time: "1637709678.2272813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-6.8359375",
    c3: "-20.5078125",
    c4: "-5.859375",
  },
  {
    "": "1102",
    time: "1637709678.2311876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.99609375",
    c2: "-16.6015625",
    c3: "-32.71484375",
    c4: "41.015625",
  },
  {
    "": "1103",
    time: "1637709678.2350938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "37.59765625",
    c2: "-54.6875",
    c3: "-52.734375",
    c4: "42.48046875",
  },
  {
    "": "1104",
    time: "1637709678.234125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-48.33984375",
    c3: "-83.0078125",
    c4: "-8.7890625",
  },
  {
    "": "1105",
    time: "1637709678.2380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-13.18359375",
    c3: "-98.14453125",
    c4: "-20.99609375",
  },
  {
    "": "1106",
    time: "1637709678.2419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.11328125",
    c2: "3.90625",
    c3: "-51.7578125",
    c4: "12.20703125",
  },
  {
    "": "1107",
    time: "1637709678.2458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-24.90234375",
    c3: "-37.59765625",
    c4: "44.43359375",
  },
  {
    "": "1108",
    time: "1637709678.24975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-73.73046875",
    c3: "-62.98828125",
    c4: "18.5546875",
  },
  {
    "": "1109",
    time: "1637709678.2536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-67.3828125",
    c3: "-49.31640625",
    c4: "-34.1796875",
  },
  {
    "": "1110",
    time: "1637709678.2575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-26.85546875",
    c3: "-60.546875",
    c4: "-11.71875",
  },
  {
    "": "1111",
    time: "1637709678.2614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-26.85546875",
    c3: "-92.7734375",
    c4: "41.015625",
  },
  {
    "": "1112",
    time: "1637709678.265375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-27.34375",
    c3: "-34.66796875",
    c4: "11.71875",
  },
  {
    "": "1113",
    time: "1637709678.2692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-20.99609375",
    c3: "-35.64453125",
    c4: "-40.0390625",
  },
  {
    "": "1114",
    time: "1637709678.2731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-35.15625",
    c3: "-71.2890625",
    c4: "-25.87890625",
  },
  {
    "": "1115",
    time: "1637709678.2770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-21.484375",
    c3: "-35.64453125",
    c4: "9.765625",
  },
  {
    "": "1116",
    time: "1637709678.281125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-10.7421875",
    c3: "-25.87890625",
    c4: "-17.08984375",
  },
  {
    "": "1117",
    time: "1637709678.2850313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-74.70703125",
    c3: "-63.96484375",
    c4: "-60.05859375",
  },
  {
    "": "1118",
    time: "1637709678.2889376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-100.5859375",
    c3: "-94.7265625",
    c4: "-41.9921875",
  },
  {
    "": "1119",
    time: "1637709678.2928438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-26.85546875",
    c3: "-95.703125",
    c4: "5.37109375",
  },
  {
    "": "1120",
    time: "1637709678.29675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-16.6015625",
    c3: "-95.703125",
    c4: "12.6953125",
  },
  {
    "": "1121",
    time: "1637709678.3006563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-33.69140625",
    c3: "-115.234375",
    c4: "-1.46484375",
  },
  {
    "": "1122",
    time: "1637709678.3045626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-31.25",
    c3: "-135.25390625",
    c4: "-23.4375",
  },
  {
    "": "1123",
    time: "1637709678.3084688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-13.671875",
    c3: "-80.078125",
    c4: "-25.390625",
  },
  {
    "": "1124",
    time: "1637709678.312375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.01953125",
    c2: "10.25390625",
    c3: "-3.90625",
    c4: "3.90625",
  },
  {
    "": "1125",
    time: "1637709678.3162813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-10.7421875",
    c3: "-44.921875",
    c4: "-18.5546875",
  },
  {
    "": "1126",
    time: "1637709678.3201876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-20.01953125",
    c3: "-77.1484375",
    c4: "-36.1328125",
  },
  {
    "": "1127",
    time: "1637709678.3240938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-21.97265625",
    c3: "-38.0859375",
    c4: "-7.32421875",
  },
  {
    "": "1128",
    time: "1637709678.364125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-20.5078125",
    c3: "-37.109375",
    c4: "26.85546875",
  },
  {
    "": "1129",
    time: "1637709678.3680313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-28.3203125",
    c3: "-55.17578125",
    c4: "11.23046875",
  },
  {
    "": "1130",
    time: "1637709678.3719375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-66.89453125",
    c3: "-79.58984375",
    c4: "-21.484375",
  },
  {
    "": "1131",
    time: "1637709678.3758438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-49.31640625",
    c3: "-89.84375",
    c4: "-6.34765625",
  },
  {
    "": "1132",
    time: "1637709678.37975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-29.296875",
    c3: "-62.98828125",
    c4: "31.73828125",
  },
  {
    "": "1133",
    time: "1637709678.3836563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-36.1328125",
    c3: "-85.9375",
    c4: "25.390625",
  },
  {
    "": "1134",
    time: "1637709678.3875625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-20.99609375",
    c3: "-113.28125",
    c4: "-0.9765625",
  },
  {
    "": "1135",
    time: "1637709678.3914688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-6.34765625",
    c3: "-62.5",
    c4: "-12.20703125",
  },
  {
    "": "1136",
    time: "1637709678.395375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-27.34375",
    c3: "-65.91796875",
    c4: "-5.37109375",
  },
  {
    "": "1137",
    time: "1637709678.3992813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-46.38671875",
    c3: "-119.140625",
    c4: "18.5546875",
  },
  {
    "": "1138",
    time: "1637709678.4031875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-24.4140625",
    c3: "-116.69921875",
    c4: "-7.32421875",
  },
  {
    "": "1139",
    time: "1637709678.4070938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-21.97265625",
    c3: "-60.546875",
    c4: "-37.59765625",
  },
  {
    "": "1140",
    time: "1637709678.384125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-32.71484375",
    c3: "-32.2265625",
    c4: "5.859375",
  },
  {
    "": "1141",
    time: "1637709678.3880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-42.96875",
    c3: "-27.83203125",
    c4: "38.0859375",
  },
  {
    "": "1142",
    time: "1637709678.3919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-60.05859375",
    c3: "-40.0390625",
    c4: "-0.48828125",
  },
  {
    "": "1143",
    time: "1637709678.3958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-42.48046875",
    c3: "-62.5",
    c4: "-5.859375",
  },
  {
    "": "1144",
    time: "1637709678.39975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-46.875",
    c3: "-121.58203125",
    c4: "2.9296875",
  },
  {
    "": "1145",
    time: "1637709678.4036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-71.77734375",
    c3: "-134.27734375",
    c4: "9.765625",
  },
  {
    "": "1146",
    time: "1637709678.4075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-57.6171875",
    c3: "-86.42578125",
    c4: "6.8359375",
  },
  {
    "": "1147",
    time: "1637709678.4114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-52.24609375",
    c3: "-79.1015625",
    c4: "-27.34375",
  },
  {
    "": "1148",
    time: "1637709678.415375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-65.91796875",
    c3: "-160.15625",
    c4: "-14.16015625",
  },
  {
    "": "1149",
    time: "1637709678.4192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-62.98828125",
    c3: "-120.60546875",
    c4: "15.625",
  },
  {
    "": "1150",
    time: "1637709678.4231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-14.6484375",
    c3: "17.578125",
    c4: "8.7890625",
  },
  {
    "": "1151",
    time: "1637709678.4270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "17.578125",
    c3: "-13.18359375",
    c4: "-14.16015625",
  },
  {
    "": "1152",
    time: "1637709678.429125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-10.7421875",
    c3: "-81.54296875",
    c4: "-31.73828125",
  },
  {
    "": "1153",
    time: "1637709678.4330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-20.99609375",
    c3: "-75.1953125",
    c4: "-3.90625",
  },
  {
    "": "1154",
    time: "1637709678.4369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-9.27734375",
    c3: "-33.203125",
    c4: "20.01953125",
  },
  {
    "": "1155",
    time: "1637709678.4408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-10.25390625",
    c3: "-44.43359375",
    c4: "-25.390625",
  },
  {
    "": "1156",
    time: "1637709678.44475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-20.01953125",
    c3: "-82.51953125",
    c4: "-53.22265625",
  },
  {
    "": "1157",
    time: "1637709678.4486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-41.9921875",
    c3: "-72.75390625",
    c4: "-0.9765625",
  },
  {
    "": "1158",
    time: "1637709678.4525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-73.73046875",
    c3: "-33.69140625",
    c4: "20.5078125",
  },
  {
    "": "1159",
    time: "1637709678.4564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-86.9140625",
    c3: "-61.03515625",
    c4: "-45.41015625",
  },
  {
    "": "1160",
    time: "1637709678.460375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-74.70703125",
    c3: "-105.95703125",
    c4: "-76.66015625",
  },
  {
    "": "1161",
    time: "1637709678.4642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-48.828125",
    c3: "-68.84765625",
    c4: "-51.7578125",
  },
  {
    "": "1162",
    time: "1637709678.4681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-39.0625",
    c3: "-20.01953125",
    c4: "-21.484375",
  },
  {
    "": "1163",
    time: "1637709678.4720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-56.640625",
    c3: "-82.03125",
    c4: "-26.85546875",
  },
  {
    "": "1164",
    time: "1637709678.475125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-59.08203125",
    c3: "-93.75",
    c4: "-56.15234375",
  },
  {
    "": "1165",
    time: "1637709678.4790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-42.48046875",
    c3: "-46.875",
    c4: "-53.7109375",
  },
  {
    "": "1166",
    time: "1637709678.4829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-37.109375",
    c3: "-43.45703125",
    c4: "-6.8359375",
  },
  {
    "": "1167",
    time: "1637709678.4868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-40.52734375",
    c3: "-62.01171875",
    c4: "-1.953125",
  },
  {
    "": "1168",
    time: "1637709678.49075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-38.57421875",
    c3: "-68.359375",
    c4: "-43.9453125",
  },
  {
    "": "1169",
    time: "1637709678.4946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-39.55078125",
    c3: "-72.75390625",
    c4: "-56.15234375",
  },
  {
    "": "1170",
    time: "1637709678.4985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-51.7578125",
    c3: "-61.5234375",
    c4: "-29.296875",
  },
  {
    "": "1171",
    time: "1637709678.5024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-54.6875",
    c3: "-56.15234375",
    c4: "3.90625",
  },
  {
    "": "1172",
    time: "1637709678.506375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-34.66796875",
    c3: "-68.359375",
    c4: "-27.83203125",
  },
  {
    "": "1173",
    time: "1637709678.5102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-38.0859375",
    c3: "-39.0625",
    c4: "-40.0390625",
  },
  {
    "": "1174",
    time: "1637709678.5141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-50.29296875",
    c3: "-41.9921875",
    c4: "-2.44140625",
  },
  {
    "": "1175",
    time: "1637709678.5180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-67.3828125",
    c3: "-46.875",
    c4: "19.53125",
  },
  {
    "": "1176",
    time: "1637709678.519125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-66.89453125",
    c3: "-25.87890625",
    c4: "-3.41796875",
  },
  {
    "": "1177",
    time: "1637709678.5230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-28.80859375",
    c3: "-52.24609375",
    c4: "-62.5",
  },
  {
    "": "1178",
    time: "1637709678.5269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-23.92578125",
    c3: "-74.70703125",
    c4: "-54.19921875",
  },
  {
    "": "1179",
    time: "1637709678.5308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-35.64453125",
    c3: "-68.84765625",
    c4: "-9.27734375",
  },
  {
    "": "1180",
    time: "1637709678.53475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-40.0390625",
    c3: "-63.96484375",
    c4: "-14.6484375",
  },
  {
    "": "1181",
    time: "1637709678.5386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-46.38671875",
    c3: "-52.734375",
    c4: "-60.05859375",
  },
  {
    "": "1182",
    time: "1637709678.5425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-33.203125",
    c3: "-60.546875",
    c4: "-56.640625",
  },
  {
    "": "1183",
    time: "1637709678.5464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-18.5546875",
    c3: "-98.14453125",
    c4: "3.41796875",
  },
  {
    "": "1184",
    time: "1637709678.550375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-36.1328125",
    c3: "-95.703125",
    c4: "20.5078125",
  },
  {
    "": "1185",
    time: "1637709678.5542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-45.41015625",
    c3: "-42.96875",
    c4: "-29.296875",
  },
  {
    "": "1186",
    time: "1637709678.5581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-30.2734375",
    c3: "-49.31640625",
    c4: "-57.12890625",
  },
  {
    "": "1187",
    time: "1637709678.5620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-18.06640625",
    c3: "-39.55078125",
    c4: "-14.6484375",
  },
  {
    "": "1188",
    time: "1637709678.566125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-45.41015625",
    c3: "-39.55078125",
    c4: "21.97265625",
  },
  {
    "": "1189",
    time: "1637709678.5700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-62.5",
    c3: "-85.44921875",
    c4: "-16.6015625",
  },
  {
    "": "1190",
    time: "1637709678.5739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-63.96484375",
    c3: "-85.9375",
    c4: "-60.546875",
  },
  {
    "": "1191",
    time: "1637709678.5778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-111.81640625",
    c3: "-77.63671875",
    c4: "-49.31640625",
  },
  {
    "": "1192",
    time: "1637709678.58175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-77.63671875",
    c3: "-63.96484375",
    c4: "-13.18359375",
  },
  {
    "": "1193",
    time: "1637709678.5856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-15.13671875",
    c3: "-72.265625",
    c4: "-6.8359375",
  },
  {
    "": "1194",
    time: "1637709678.5895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "1.46484375",
    c3: "-106.4453125",
    c4: "-25.87890625",
  },
  {
    "": "1195",
    time: "1637709678.5934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "1.46484375",
    c3: "-116.2109375",
    c4: "-33.69140625",
  },
  {
    "": "1196",
    time: "1637709678.597375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-6.34765625",
    c3: "-80.56640625",
    c4: "-18.06640625",
  },
  {
    "": "1197",
    time: "1637709678.6012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-21.97265625",
    c3: "-54.19921875",
    c4: "-7.32421875",
  },
  {
    "": "1198",
    time: "1637709678.6051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-42.96875",
    c3: "-68.359375",
    c4: "-18.5546875",
  },
  {
    "": "1199",
    time: "1637709678.6090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-40.0390625",
    c3: "-87.40234375",
    c4: "-26.3671875",
  },
  {
    "": "1200",
    time: "1637709678.609125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-33.203125",
    c3: "-78.61328125",
    c4: "4.8828125",
  },
  {
    "": "1201",
    time: "1637709678.6130311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-28.80859375",
    c3: "-69.3359375",
    c4: "22.94921875",
  },
  {
    "": "1202",
    time: "1637709678.6169374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-24.4140625",
    c3: "-65.91796875",
    c4: "-19.53125",
  },
  {
    "": "1203",
    time: "1637709678.6208436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-21.484375",
    c3: "-70.3125",
    c4: "-24.4140625",
  },
  {
    "": "1204",
    time: "1637709678.62475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-30.2734375",
    c3: "-87.40234375",
    c4: "3.41796875",
  },
  {
    "": "1205",
    time: "1637709678.6286561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-37.59765625",
    c3: "-74.21875",
    c4: "18.06640625",
  },
  {
    "": "1206",
    time: "1637709678.6325624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-39.55078125",
    c3: "-85.44921875",
    c4: "-6.8359375",
  },
  {
    "": "1207",
    time: "1637709678.6364686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-39.55078125",
    c3: "-99.12109375",
    c4: "-38.0859375",
  },
  {
    "": "1208",
    time: "1637709678.640375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-25.390625",
    c3: "-36.62109375",
    c4: "-21.97265625",
  },
  {
    "": "1209",
    time: "1637709678.6442811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-24.90234375",
    c3: "-40.52734375",
    c4: "22.94921875",
  },
  {
    "": "1210",
    time: "1637709678.6481874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-46.38671875",
    c3: "-77.1484375",
    c4: "10.25390625",
  },
  {
    "": "1211",
    time: "1637709678.6520936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-43.9453125",
    c3: "-121.58203125",
    c4: "-29.296875",
  },
  {
    "": "1212",
    time: "1637709678.657125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-47.8515625",
    c3: "-106.4453125",
    c4: "-20.01953125",
  },
  {
    "": "1213",
    time: "1637709678.6610312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-51.7578125",
    c3: "-48.828125",
    c4: "13.671875",
  },
  {
    "": "1214",
    time: "1637709678.6649375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-44.43359375",
    c3: "-69.82421875",
    c4: "-0.48828125",
  },
  {
    "": "1215",
    time: "1637709678.6688437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-30.76171875",
    c3: "-72.75390625",
    c4: "-65.91796875",
  },
  {
    "": "1216",
    time: "1637709678.67275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-40.0390625",
    c3: "-91.796875",
    c4: "-58.10546875",
  },
  {
    "": "1217",
    time: "1637709678.6766562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-65.4296875",
    c3: "-122.0703125",
    c4: "5.859375",
  },
  {
    "": "1218",
    time: "1637709678.6805625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-62.5",
    c3: "-91.30859375",
    c4: "18.5546875",
  },
  {
    "": "1219",
    time: "1637709678.6844687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-46.38671875",
    c3: "-60.05859375",
    c4: "-19.53125",
  },
  {
    "": "1220",
    time: "1637709678.688375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-31.73828125",
    c3: "-54.6875",
    c4: "-52.734375",
  },
  {
    "": "1221",
    time: "1637709678.6922812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-28.80859375",
    c3: "-82.51953125",
    c4: "-10.7421875",
  },
  {
    "": "1222",
    time: "1637709678.6961875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-40.0390625",
    c3: "-86.42578125",
    c4: "32.2265625",
  },
  {
    "": "1223",
    time: "1637709678.7000937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-65.91796875",
    c3: "-45.41015625",
    c4: "-25.87890625",
  },
  {
    "": "1224",
    time: "1637709678.714125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-53.22265625",
    c3: "-68.359375",
    c4: "-60.546875",
  },
  {
    "": "1225",
    time: "1637709678.7180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-41.9921875",
    c3: "-102.05078125",
    c4: "-26.85546875",
  },
  {
    "": "1226",
    time: "1637709678.7219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-59.08203125",
    c3: "-84.47265625",
    c4: "10.7421875",
  },
  {
    "": "1227",
    time: "1637709678.7258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-52.24609375",
    c3: "-68.84765625",
    c4: "-3.90625",
  },
  {
    "": "1228",
    time: "1637709678.72975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-36.62109375",
    c3: "-66.40625",
    c4: "-43.9453125",
  },
  {
    "": "1229",
    time: "1637709678.7336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-42.96875",
    c3: "-100.09765625",
    c4: "-28.80859375",
  },
  {
    "": "1230",
    time: "1637709678.7375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-53.7109375",
    c3: "-125.48828125",
    c4: "14.16015625",
  },
  {
    "": "1231",
    time: "1637709678.7414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-25.390625",
    c3: "-60.05859375",
    c4: "-0.9765625",
  },
  {
    "": "1232",
    time: "1637709678.745375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-19.04296875",
    c3: "-63.4765625",
    c4: "-32.71484375",
  },
  {
    "": "1233",
    time: "1637709678.7492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-54.6875",
    c3: "-108.3984375",
    c4: "-35.15625",
  },
  {
    "": "1234",
    time: "1637709678.7531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-67.87109375",
    c3: "-75.68359375",
    c4: "-13.18359375",
  },
  {
    "": "1235",
    time: "1637709678.7570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-38.57421875",
    c3: "-54.6875",
    c4: "8.30078125",
  },
  {
    "": "1236",
    time: "1637709678.759125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-56.640625",
    c3: "-69.82421875",
    c4: "-16.6015625",
  },
  {
    "": "1237",
    time: "1637709678.7630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-41.9921875",
    c3: "-69.3359375",
    c4: "-41.015625",
  },
  {
    "": "1238",
    time: "1637709678.7669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-31.73828125",
    c3: "-43.45703125",
    c4: "-29.296875",
  },
  {
    "": "1239",
    time: "1637709678.7708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-92.7734375",
    c3: "-68.84765625",
    c4: "5.37109375",
  },
  {
    "": "1240",
    time: "1637709678.77475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-85.9375",
    c3: "-100.09765625",
    c4: "-8.7890625",
  },
  {
    "": "1241",
    time: "1637709678.7786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-43.45703125",
    c3: "-76.66015625",
    c4: "-53.22265625",
  },
  {
    "": "1242",
    time: "1637709678.7825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-26.85546875",
    c3: "-89.84375",
    c4: "-41.015625",
  },
  {
    "": "1243",
    time: "1637709678.7864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-33.203125",
    c3: "-95.703125",
    c4: "1.46484375",
  },
  {
    "": "1244",
    time: "1637709678.790375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-26.85546875",
    c3: "-124.51171875",
    c4: "12.6953125",
  },
  {
    "": "1245",
    time: "1637709678.7942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-37.109375",
    c3: "-151.85546875",
    c4: "-25.87890625",
  },
  {
    "": "1246",
    time: "1637709678.7981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-47.8515625",
    c3: "-79.1015625",
    c4: "-38.0859375",
  },
  {
    "": "1247",
    time: "1637709678.8020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-33.69140625",
    c3: "-42.48046875",
    c4: "6.8359375",
  },
  {
    "": "1248",
    time: "1637709678.804125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-46.38671875",
    c3: "-56.640625",
    c4: "25.87890625",
  },
  {
    "": "1249",
    time: "1637709678.8080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-60.546875",
    c3: "-68.84765625",
    c4: "-19.04296875",
  },
  {
    "": "1250",
    time: "1637709678.8119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-54.6875",
    c3: "-77.63671875",
    c4: "-47.36328125",
  },
  {
    "": "1251",
    time: "1637709678.8158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-70.80078125",
    c3: "-86.9140625",
    c4: "-16.11328125",
  },
  {
    "": "1252",
    time: "1637709678.81975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-43.9453125",
    c3: "-134.27734375",
    c4: "17.08984375",
  },
  {
    "": "1253",
    time: "1637709678.8236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-42.48046875",
    c3: "-111.328125",
    c4: "-21.97265625",
  },
  {
    "": "1254",
    time: "1637709678.8275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-60.05859375",
    c3: "-47.8515625",
    c4: "-60.546875",
  },
  {
    "": "1255",
    time: "1637709678.8314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-27.83203125",
    c3: "-42.96875",
    c4: "-21.97265625",
  },
  {
    "": "1256",
    time: "1637709678.835375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-32.2265625",
    c3: "-89.35546875",
    c4: "33.203125",
  },
  {
    "": "1257",
    time: "1637709678.8392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-47.36328125",
    c3: "-84.9609375",
    c4: "12.20703125",
  },
  {
    "": "1258",
    time: "1637709678.8431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-35.15625",
    c3: "-25.87890625",
    c4: "-46.875",
  },
  {
    "": "1259",
    time: "1637709678.8470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-46.875",
    c3: "-41.50390625",
    c4: "-29.78515625",
  },
  {
    "": "1260",
    time: "1637709678.849125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-74.70703125",
    c3: "-49.8046875",
    c4: "20.99609375",
  },
  {
    "": "1261",
    time: "1637709678.8530312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-56.640625",
    c3: "-26.85546875",
    c4: "22.4609375",
  },
  {
    "": "1262",
    time: "1637709678.8569374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-54.6875",
    c3: "-55.17578125",
    c4: "-25.390625",
  },
  {
    "": "1263",
    time: "1637709678.8608437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-85.44921875",
    c3: "-105.46875",
    c4: "-34.66796875",
  },
  {
    "": "1264",
    time: "1637709678.86475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-61.5234375",
    c3: "-78.125",
    c4: "1.46484375",
  },
  {
    "": "1265",
    time: "1637709678.8686562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-14.16015625",
    c3: "-59.08203125",
    c4: "22.94921875",
  },
  {
    "": "1266",
    time: "1637709678.8725624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-21.97265625",
    c3: "-84.9609375",
    c4: "-17.578125",
  },
  {
    "": "1267",
    time: "1637709678.8764687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-63.4765625",
    c3: "-125.48828125",
    c4: "-35.15625",
  },
  {
    "": "1268",
    time: "1637709678.880375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-59.5703125",
    c3: "-110.3515625",
    c4: "17.578125",
  },
  {
    "": "1269",
    time: "1637709678.8842812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-29.296875",
    c3: "-34.66796875",
    c4: "25.390625",
  },
  {
    "": "1270",
    time: "1637709678.8881874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-39.55078125",
    c3: "-22.94921875",
    c4: "-12.6953125",
  },
  {
    "": "1271",
    time: "1637709678.8920937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-28.3203125",
    c3: "-71.77734375",
    c4: "-34.66796875",
  },
  {
    "": "1272",
    time: "1637709678.894125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-13.18359375",
    c3: "-67.87109375",
    c4: "-35.64453125",
  },
  {
    "": "1273",
    time: "1637709678.8980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-30.2734375",
    c3: "-21.484375",
    c4: "-8.7890625",
  },
  {
    "": "1274",
    time: "1637709678.9019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-33.203125",
    c3: "-25.390625",
    c4: "-11.23046875",
  },
  {
    "": "1275",
    time: "1637709678.9058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-31.73828125",
    c3: "-102.5390625",
    c4: "-43.9453125",
  },
  {
    "": "1276",
    time: "1637709678.90975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-40.0390625",
    c3: "-99.12109375",
    c4: "-24.90234375",
  },
  {
    "": "1277",
    time: "1637709678.9136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-54.6875",
    c3: "-57.12890625",
    c4: "15.13671875",
  },
  {
    "": "1278",
    time: "1637709678.9175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-42.48046875",
    c3: "-68.84765625",
    c4: "11.23046875",
  },
  {
    "": "1279",
    time: "1637709678.9214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-40.0390625",
    c3: "-115.72265625",
    c4: "-30.76171875",
  },
  {
    "": "1280",
    time: "1637709678.925375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-62.98828125",
    c3: "-161.1328125",
    c4: "-51.7578125",
  },
  {
    "": "1281",
    time: "1637709678.9292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-45.41015625",
    c3: "-84.9609375",
    c4: "-10.7421875",
  },
  {
    "": "1282",
    time: "1637709678.9331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-41.015625",
    c3: "-51.26953125",
    c4: "22.94921875",
  },
  {
    "": "1283",
    time: "1637709678.9370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-57.6171875",
    c3: "-98.6328125",
    c4: "-15.13671875",
  },
  {
    "": "1284",
    time: "1637709678.940125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-38.57421875",
    c3: "-85.9375",
    c4: "-56.640625",
  },
  {
    "": "1285",
    time: "1637709678.9440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-35.64453125",
    c3: "-57.6171875",
    c4: "-28.3203125",
  },
  {
    "": "1286",
    time: "1637709678.9479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-56.640625",
    c3: "-82.03125",
    c4: "14.6484375",
  },
  {
    "": "1287",
    time: "1637709678.9518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-49.8046875",
    c3: "-120.60546875",
    c4: "-15.625",
  },
  {
    "": "1288",
    time: "1637709678.95575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-83.0078125",
    c3: "-121.09375",
    c4: "-63.4765625",
  },
  {
    "": "1289",
    time: "1637709678.9596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-78.125",
    c3: "-105.95703125",
    c4: "-25.390625",
  },
  {
    "": "1290",
    time: "1637709678.9635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-59.5703125",
    c3: "-109.86328125",
    c4: "20.99609375",
  },
  {
    "": "1291",
    time: "1637709678.9674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-69.3359375",
    c3: "-119.62890625",
    c4: "9.27734375",
  },
  {
    "": "1292",
    time: "1637709678.971375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-35.15625",
    c3: "-85.9375",
    c4: "-39.0625",
  },
  {
    "": "1293",
    time: "1637709678.9752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-37.59765625",
    c3: "-63.96484375",
    c4: "-35.64453125",
  },
  {
    "": "1294",
    time: "1637709678.9791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-53.22265625",
    c3: "-83.49609375",
    c4: "29.78515625",
  },
  {
    "": "1295",
    time: "1637709678.9830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-49.31640625",
    c3: "-102.05078125",
    c4: "1.953125",
  },
  {
    "": "1296",
    time: "1637709678.984125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-38.0859375",
    c3: "-92.7734375",
    c4: "-64.453125",
  },
  {
    "": "1297",
    time: "1637709678.9880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-61.03515625",
    c3: "-70.3125",
    c4: "-68.359375",
  },
  {
    "": "1298",
    time: "1637709678.9919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-65.91796875",
    c3: "-64.94140625",
    c4: "-26.3671875",
  },
  {
    "": "1299",
    time: "1637709678.9958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.578125",
    c2: "-27.83203125",
    c3: "-65.91796875",
    c4: "3.41796875",
  },
  {
    "": "1300",
    time: "1637709678.99975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-28.80859375",
    c3: "-59.5703125",
    c4: "-22.4609375",
  },
  {
    "": "1301",
    time: "1637709679.0036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-42.96875",
    c3: "-69.3359375",
    c4: "-76.66015625",
  },
  {
    "": "1302",
    time: "1637709679.0075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-36.1328125",
    c3: "-115.234375",
    c4: "-56.640625",
  },
  {
    "": "1303",
    time: "1637709679.0114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-51.7578125",
    c3: "-155.76171875",
    c4: "8.7890625",
  },
  {
    "": "1304",
    time: "1637709679.015375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-62.98828125",
    c3: "-93.75",
    c4: "-19.04296875",
  },
  {
    "": "1305",
    time: "1637709679.0192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-45.8984375",
    c3: "-57.6171875",
    c4: "-85.9375",
  },
  {
    "": "1306",
    time: "1637709679.0231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-30.76171875",
    c3: "-76.66015625",
    c4: "-57.6171875",
  },
  {
    "": "1307",
    time: "1637709679.0270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-25.87890625",
    c3: "-48.33984375",
    c4: "-2.9296875",
  },
  {
    "": "1308",
    time: "1637709679.044125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-45.8984375",
    c3: "-45.41015625",
    c4: "-9.27734375",
  },
  {
    "": "1309",
    time: "1637709679.0480313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-49.8046875",
    c3: "-67.87109375",
    c4: "-43.9453125",
  },
  {
    "": "1310",
    time: "1637709679.0519376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-36.1328125",
    c3: "-85.44921875",
    c4: "-43.9453125",
  },
  {
    "": "1311",
    time: "1637709679.0558438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-33.203125",
    c3: "-91.30859375",
    c4: "-7.8125",
  },
  {
    "": "1312",
    time: "1637709679.05975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-24.4140625",
    c3: "-68.359375",
    c4: "-12.20703125",
  },
  {
    "": "1313",
    time: "1637709679.0636563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-26.3671875",
    c3: "-79.58984375",
    c4: "-46.38671875",
  },
  {
    "": "1314",
    time: "1637709679.0675626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-24.4140625",
    c3: "-98.14453125",
    c4: "-61.5234375",
  },
  {
    "": "1315",
    time: "1637709679.0714688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-16.11328125",
    c3: "-52.734375",
    c4: "-29.296875",
  },
  {
    "": "1316",
    time: "1637709679.075375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-9.27734375",
    c3: "-29.78515625",
    c4: "31.73828125",
  },
  {
    "": "1317",
    time: "1637709679.0792813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-41.015625",
    c3: "-69.82421875",
    c4: "5.37109375",
  },
  {
    "": "1318",
    time: "1637709679.0831876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-74.70703125",
    c3: "-76.66015625",
    c4: "-57.6171875",
  },
  {
    "": "1319",
    time: "1637709679.0870938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-70.80078125",
    c3: "-50.78125",
    c4: "-45.41015625",
  },
  {
    "": "1320",
    time: "1637709679.089125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-38.57421875",
    c3: "-63.96484375",
    c4: "-1.953125",
  },
  {
    "": "1321",
    time: "1637709679.0930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-1.953125",
    c3: "-74.70703125",
    c4: "-7.32421875",
  },
  {
    "": "1322",
    time: "1637709679.0969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-19.53125",
    c3: "-51.26953125",
    c4: "-40.52734375",
  },
  {
    "": "1323",
    time: "1637709679.1008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-47.8515625",
    c3: "-69.3359375",
    c4: "-48.828125",
  },
  {
    "": "1324",
    time: "1637709679.10475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-35.64453125",
    c3: "-80.078125",
    c4: "-1.953125",
  },
  {
    "": "1325",
    time: "1637709679.1086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-13.671875",
    c3: "-95.703125",
    c4: "16.6015625",
  },
  {
    "": "1326",
    time: "1637709679.1125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-21.97265625",
    c3: "-113.28125",
    c4: "-45.8984375",
  },
  {
    "": "1327",
    time: "1637709679.1164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-37.59765625",
    c3: "-88.8671875",
    c4: "-67.87109375",
  },
  {
    "": "1328",
    time: "1637709679.120375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-33.69140625",
    c3: "-79.1015625",
    c4: "-26.85546875",
  },
  {
    "": "1329",
    time: "1637709679.1242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-36.62109375",
    c3: "-116.2109375",
    c4: "26.85546875",
  },
  {
    "": "1330",
    time: "1637709679.1281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-41.50390625",
    c3: "-94.7265625",
    c4: "2.44140625",
  },
  {
    "": "1331",
    time: "1637709679.1320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-54.19921875",
    c3: "-43.9453125",
    c4: "-49.31640625",
  },
  {
    "": "1332",
    time: "1637709679.122125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-55.17578125",
    c3: "-71.77734375",
    c4: "-14.6484375",
  },
  {
    "": "1333",
    time: "1637709679.1260312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-36.62109375",
    c3: "-59.5703125",
    c4: "6.34765625",
  },
  {
    "": "1334",
    time: "1637709679.1299374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-46.38671875",
    c3: "-26.3671875",
    c4: "-16.11328125",
  },
  {
    "": "1335",
    time: "1637709679.1338437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-51.7578125",
    c3: "-35.15625",
    c4: "-45.41015625",
  },
  {
    "": "1336",
    time: "1637709679.13775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-40.52734375",
    c3: "-66.89453125",
    c4: "-28.80859375",
  },
  {
    "": "1337",
    time: "1637709679.1416562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-32.71484375",
    c3: "-70.3125",
    c4: "23.4375",
  },
  {
    "": "1338",
    time: "1637709679.1455624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-31.73828125",
    c3: "-57.12890625",
    c4: "17.578125",
  },
  {
    "": "1339",
    time: "1637709679.1494687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-28.3203125",
    c3: "-43.45703125",
    c4: "-26.85546875",
  },
  {
    "": "1340",
    time: "1637709679.153375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-28.80859375",
    c3: "-76.171875",
    c4: "-23.4375",
  },
  {
    "": "1341",
    time: "1637709679.1572812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-33.203125",
    c3: "-88.37890625",
    c4: "27.34375",
  },
  {
    "": "1342",
    time: "1637709679.1611874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "38.57421875",
    c2: "-43.9453125",
    c3: "-33.69140625",
    c4: "22.94921875",
  },
  {
    "": "1343",
    time: "1637709679.1650937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-57.6171875",
    c3: "-37.59765625",
    c4: "-20.99609375",
  },
  {
    "": "1344",
    time: "1637709679.179125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-45.41015625",
    c3: "-74.21875",
    c4: "-30.76171875",
  },
  {
    "": "1345",
    time: "1637709679.1830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-28.80859375",
    c3: "-64.453125",
    c4: "2.9296875",
  },
  {
    "": "1346",
    time: "1637709679.1869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "37.109375",
    c2: "-25.87890625",
    c3: "-36.62109375",
    c4: "27.34375",
  },
  {
    "": "1347",
    time: "1637709679.1908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "24.4140625",
    c2: "-26.85546875",
    c3: "-37.109375",
    c4: "-14.16015625",
  },
  {
    "": "1348",
    time: "1637709679.19475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-38.0859375",
    c3: "-84.9609375",
    c4: "-29.296875",
  },
  {
    "": "1349",
    time: "1637709679.1986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-57.12890625",
    c3: "-111.328125",
    c4: "21.97265625",
  },
  {
    "": "1350",
    time: "1637709679.2025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-63.96484375",
    c3: "-49.31640625",
    c4: "27.83203125",
  },
  {
    "": "1351",
    time: "1637709679.2064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-70.3125",
    c3: "-24.4140625",
    c4: "-6.8359375",
  },
  {
    "": "1352",
    time: "1637709679.210375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-63.4765625",
    c3: "-67.87109375",
    c4: "-39.55078125",
  },
  {
    "": "1353",
    time: "1637709679.2142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-27.83203125",
    c3: "-88.8671875",
    c4: "-20.99609375",
  },
  {
    "": "1354",
    time: "1637709679.2181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-38.0859375",
    c3: "-64.94140625",
    c4: "17.08984375",
  },
  {
    "": "1355",
    time: "1637709679.2220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-61.5234375",
    c3: "-69.3359375",
    c4: "-10.25390625",
  },
  {
    "": "1356",
    time: "1637709679.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-41.015625",
    c3: "-63.4765625",
    c4: "-36.62109375",
  },
  {
    "": "1357",
    time: "1637709679.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-49.8046875",
    c3: "-27.34375",
    c4: "-10.7421875",
  },
  {
    "": "1358",
    time: "1637709679.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-73.2421875",
    c3: "-48.33984375",
    c4: "24.90234375",
  },
  {
    "": "1359",
    time: "1637709679.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.578125",
    c2: "-56.640625",
    c3: "-103.02734375",
    c4: "27.34375",
  },
  {
    "": "1360",
    time: "1637709679.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-26.3671875",
    c3: "-112.3046875",
    c4: "-6.8359375",
  },
  {
    "": "1361",
    time: "1637709679.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-33.203125",
    c3: "-93.26171875",
    c4: "-38.0859375",
  },
  {
    "": "1362",
    time: "1637709679.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-28.3203125",
    c3: "-58.59375",
    c4: "-38.57421875",
  },
  {
    "": "1363",
    time: "1637709679.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-12.6953125",
    c3: "-53.7109375",
    c4: "0.9765625",
  },
  {
    "": "1364",
    time: "1637709679.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-22.94921875",
    c3: "-99.609375",
    c4: "6.34765625",
  },
  {
    "": "1365",
    time: "1637709679.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-16.11328125",
    c3: "-63.4765625",
    c4: "-20.01953125",
  },
  {
    "": "1366",
    time: "1637709679.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-0.48828125",
    c3: "-26.3671875",
    c4: "0.0",
  },
  {
    "": "1367",
    time: "1637709679.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-16.11328125",
    c3: "-58.59375",
    c4: "27.34375",
  },
  {
    "": "1368",
    time: "1637709679.269125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "-27.83203125",
    c3: "-57.6171875",
    c4: "22.94921875",
  },
  {
    "": "1369",
    time: "1637709679.2730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-16.6015625",
    c3: "-48.828125",
    c4: "-13.671875",
  },
  {
    "": "1370",
    time: "1637709679.2769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-30.76171875",
    c3: "-83.0078125",
    c4: "-35.64453125",
  },
  {
    "": "1371",
    time: "1637709679.2808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-51.7578125",
    c3: "-126.46484375",
    c4: "11.23046875",
  },
  {
    "": "1372",
    time: "1637709679.28475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-53.22265625",
    c3: "-91.796875",
    c4: "20.5078125",
  },
  {
    "": "1373",
    time: "1637709679.2886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-58.10546875",
    c3: "-34.1796875",
    c4: "-33.69140625",
  },
  {
    "": "1374",
    time: "1637709679.2925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-41.9921875",
    c3: "-69.3359375",
    c4: "-47.36328125",
  },
  {
    "": "1375",
    time: "1637709679.2964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-13.18359375",
    c3: "-120.60546875",
    c4: "-1.953125",
  },
  {
    "": "1376",
    time: "1637709679.300375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-16.11328125",
    c3: "-101.07421875",
    c4: "12.6953125",
  },
  {
    "": "1377",
    time: "1637709679.3042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-19.04296875",
    c3: "-57.6171875",
    c4: "-46.38671875",
  },
  {
    "": "1378",
    time: "1637709679.3081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-16.11328125",
    c3: "-62.01171875",
    c4: "-65.4296875",
  },
  {
    "": "1379",
    time: "1637709679.3120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-20.99609375",
    c3: "-71.2890625",
    c4: "-25.390625",
  },
  {
    "": "1380",
    time: "1637709679.316125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-35.64453125",
    c3: "-54.6875",
    c4: "4.39453125",
  },
  {
    "": "1381",
    time: "1637709679.3200312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-65.91796875",
    c3: "-70.80078125",
    c4: "-43.9453125",
  },
  {
    "": "1382",
    time: "1637709679.3239374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-68.359375",
    c3: "-94.7265625",
    c4: "-82.51953125",
  },
  {
    "": "1383",
    time: "1637709679.3278437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-28.3203125",
    c3: "-65.91796875",
    c4: "-49.8046875",
  },
  {
    "": "1384",
    time: "1637709679.33175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-23.92578125",
    c3: "-32.71484375",
    c4: "0.48828125",
  },
  {
    "": "1385",
    time: "1637709679.3356562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-35.64453125",
    c3: "-56.640625",
    c4: "-0.9765625",
  },
  {
    "": "1386",
    time: "1637709679.3395624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-33.203125",
    c3: "-101.5625",
    c4: "-50.78125",
  },
  {
    "": "1387",
    time: "1637709679.3434687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-45.8984375",
    c3: "-107.91015625",
    c4: "-61.5234375",
  },
  {
    "": "1388",
    time: "1637709679.347375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-44.921875",
    c3: "-57.6171875",
    c4: "-13.18359375",
  },
  {
    "": "1389",
    time: "1637709679.3512812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-56.15234375",
    c3: "-33.69140625",
    c4: "7.8125",
  },
  {
    "": "1390",
    time: "1637709679.3551874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-49.31640625",
    c3: "-60.546875",
    c4: "-56.15234375",
  },
  {
    "": "1391",
    time: "1637709679.3590937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-27.34375",
    c3: "-101.5625",
    c4: "-72.265625",
  },
  {
    "": "1392",
    time: "1637709679.360125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-10.25390625",
    c3: "-66.40625",
    c4: "-26.3671875",
  },
  {
    "": "1393",
    time: "1637709679.3640313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-13.18359375",
    c3: "-16.6015625",
    c4: "-12.6953125",
  },
  {
    "": "1394",
    time: "1637709679.3679376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-49.8046875",
    c3: "-62.98828125",
    c4: "-11.71875",
  },
  {
    "": "1395",
    time: "1637709679.3718438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-34.1796875",
    c3: "-79.1015625",
    c4: "-25.87890625",
  },
  {
    "": "1396",
    time: "1637709679.37575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-11.23046875",
    c3: "-44.43359375",
    c4: "-32.2265625",
  },
  {
    "": "1397",
    time: "1637709679.3796563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-12.6953125",
    c3: "-43.9453125",
    c4: "-17.578125",
  },
  {
    "": "1398",
    time: "1637709679.3835626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-12.20703125",
    c3: "-88.37890625",
    c4: "-18.5546875",
  },
  {
    "": "1399",
    time: "1637709679.3874688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-20.5078125",
    c3: "-105.46875",
    c4: "-46.875",
  },
  {
    "": "1400",
    time: "1637709679.391375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-41.50390625",
    c3: "-59.08203125",
    c4: "-62.98828125",
  },
  {
    "": "1401",
    time: "1637709679.3952813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-50.78125",
    c3: "-61.5234375",
    c4: "-4.39453125",
  },
  {
    "": "1402",
    time: "1637709679.3991876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-46.875",
    c3: "-64.94140625",
    c4: "5.859375",
  },
  {
    "": "1403",
    time: "1637709679.4030938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-34.66796875",
    c3: "-35.15625",
    c4: "-48.33984375",
  },
  {
    "": "1404",
    time: "1637709679.405125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-21.97265625",
    c3: "-51.26953125",
    c4: "-56.15234375",
  },
  {
    "": "1405",
    time: "1637709679.4090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-21.484375",
    c3: "-85.9375",
    c4: "-5.37109375",
  },
  {
    "": "1406",
    time: "1637709679.4129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-25.390625",
    c3: "-69.82421875",
    c4: "8.7890625",
  },
  {
    "": "1407",
    time: "1637709679.4168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-30.76171875",
    c3: "-36.1328125",
    c4: "-39.0625",
  },
  {
    "": "1408",
    time: "1637709679.42075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-29.78515625",
    c3: "-57.6171875",
    c4: "-46.38671875",
  },
  {
    "": "1409",
    time: "1637709679.4246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-42.96875",
    c3: "-91.796875",
    c4: "-1.953125",
  },
  {
    "": "1410",
    time: "1637709679.4285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-55.6640625",
    c3: "-110.3515625",
    c4: "40.52734375",
  },
  {
    "": "1411",
    time: "1637709679.4324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-44.921875",
    c3: "-60.05859375",
    c4: "3.41796875",
  },
  {
    "": "1412",
    time: "1637709679.436375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-36.1328125",
    c3: "-24.90234375",
    c4: "-55.6640625",
  },
  {
    "": "1413",
    time: "1637709679.4402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-33.69140625",
    c3: "-60.546875",
    c4: "-34.1796875",
  },
  {
    "": "1414",
    time: "1637709679.4441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-36.1328125",
    c3: "-63.96484375",
    c4: "25.390625",
  },
  {
    "": "1415",
    time: "1637709679.4480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-37.59765625",
    c3: "-39.0625",
    c4: "14.16015625",
  },
  {
    "": "1416",
    time: "1637709679.464125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-54.19921875",
    c3: "-42.96875",
    c4: "-43.45703125",
  },
  {
    "": "1417",
    time: "1637709679.4680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-83.984375",
    c3: "-78.125",
    c4: "-25.390625",
  },
  {
    "": "1418",
    time: "1637709679.4719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-77.63671875",
    c3: "-44.43359375",
    c4: "28.80859375",
  },
  {
    "": "1419",
    time: "1637709679.4758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-39.55078125",
    c3: "-26.3671875",
    c4: "26.3671875",
  },
  {
    "": "1420",
    time: "1637709679.47975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-44.43359375",
    c3: "-85.9375",
    c4: "-34.1796875",
  },
  {
    "": "1421",
    time: "1637709679.4836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-57.12890625",
    c3: "-118.65234375",
    c4: "-45.41015625",
  },
  {
    "": "1422",
    time: "1637709679.4875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-24.90234375",
    c3: "-92.28515625",
    c4: "8.7890625",
  },
  {
    "": "1423",
    time: "1637709679.4914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "24.90234375",
    c2: "-3.90625",
    c3: "-20.99609375",
    c4: "19.53125",
  },
  {
    "": "1424",
    time: "1637709679.495375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-4.39453125",
    c3: "-10.7421875",
    c4: "-8.7890625",
  },
  {
    "": "1425",
    time: "1637709679.4992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-28.80859375",
    c3: "-51.7578125",
    c4: "-20.5078125",
  },
  {
    "": "1426",
    time: "1637709679.5031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-35.64453125",
    c3: "-41.9921875",
    c4: "13.18359375",
  },
  {
    "": "1427",
    time: "1637709679.5070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-31.73828125",
    c3: "-4.8828125",
    c4: "40.0390625",
  },
  {
    "": "1428",
    time: "1637709679.509125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-40.0390625",
    c3: "-11.71875",
    c4: "23.4375",
  },
  {
    "": "1429",
    time: "1637709679.5130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-64.94140625",
    c3: "-62.5",
    c4: "-21.97265625",
  },
  {
    "": "1430",
    time: "1637709679.5169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-42.96875",
    c3: "-74.70703125",
    c4: "-20.5078125",
  },
  {
    "": "1431",
    time: "1637709679.5208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-30.2734375",
    c3: "-69.82421875",
    c4: "33.203125",
  },
  {
    "": "1432",
    time: "1637709679.52475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "21.484375",
    c2: "-39.55078125",
    c3: "-76.171875",
    c4: "19.53125",
  },
  {
    "": "1433",
    time: "1637709679.5286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-21.97265625",
    c3: "-80.56640625",
    c4: "-36.62109375",
  },
  {
    "": "1434",
    time: "1637709679.5325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-24.4140625",
    c3: "-61.03515625",
    c4: "-41.50390625",
  },
  {
    "": "1435",
    time: "1637709679.5364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-43.45703125",
    c3: "-2.9296875",
    c4: "-0.48828125",
  },
  {
    "": "1436",
    time: "1637709679.540375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-53.22265625",
    c3: "-61.5234375",
    c4: "19.04296875",
  },
  {
    "": "1437",
    time: "1637709679.5442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-29.78515625",
    c3: "-129.8828125",
    c4: "-11.23046875",
  },
  {
    "": "1438",
    time: "1637709679.5481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-22.94921875",
    c3: "-63.4765625",
    c4: "-49.8046875",
  },
  {
    "": "1439",
    time: "1637709679.5520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-31.73828125",
    c3: "-17.578125",
    c4: "-19.53125",
  },
  {
    "": "1440",
    time: "1637709679.554125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-26.85546875",
    c3: "-38.0859375",
    c4: "6.8359375",
  },
  {
    "": "1441",
    time: "1637709679.5580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-21.97265625",
    c3: "-67.3828125",
    c4: "-28.3203125",
  },
  {
    "": "1442",
    time: "1637709679.5619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-62.01171875",
    c3: "-88.37890625",
    c4: "-55.6640625",
  },
  {
    "": "1443",
    time: "1637709679.5658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-112.79296875",
    c3: "-86.42578125",
    c4: "-32.71484375",
  },
  {
    "": "1444",
    time: "1637709679.56975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-90.33203125",
    c3: "-100.09765625",
    c4: "20.5078125",
  },
  {
    "": "1445",
    time: "1637709679.5736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-71.2890625",
    c3: "-110.3515625",
    c4: "0.9765625",
  },
  {
    "": "1446",
    time: "1637709679.5775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-65.4296875",
    c3: "-99.12109375",
    c4: "-54.19921875",
  },
  {
    "": "1447",
    time: "1637709679.5814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-42.48046875",
    c3: "-101.07421875",
    c4: "-27.83203125",
  },
  {
    "": "1448",
    time: "1637709679.585375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-25.87890625",
    c3: "-85.9375",
    c4: "25.390625",
  },
  {
    "": "1449",
    time: "1637709679.5892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-17.578125",
    c3: "-68.84765625",
    c4: "10.7421875",
  },
  {
    "": "1450",
    time: "1637709679.5931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-36.1328125",
    c3: "-54.19921875",
    c4: "-44.921875",
  },
  {
    "": "1451",
    time: "1637709679.5970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-51.7578125",
    c3: "-87.890625",
    c4: "-60.546875",
  },
  {
    "": "1452",
    time: "1637709679.599125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-38.0859375",
    c3: "-118.65234375",
    c4: "-16.11328125",
  },
  {
    "": "1453",
    time: "1637709679.6030312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-28.80859375",
    c3: "-72.265625",
    c4: "0.0",
  },
  {
    "": "1454",
    time: "1637709679.6069374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-51.7578125",
    c3: "-55.6640625",
    c4: "-49.31640625",
  },
  {
    "": "1455",
    time: "1637709679.6108437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-61.5234375",
    c3: "-105.95703125",
    c4: "-63.96484375",
  },
  {
    "": "1456",
    time: "1637709679.61475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-57.6171875",
    c3: "-91.30859375",
    c4: "-23.92578125",
  },
  {
    "": "1457",
    time: "1637709679.6186562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-53.7109375",
    c3: "-53.22265625",
    c4: "3.90625",
  },
  {
    "": "1458",
    time: "1637709679.6225624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-44.43359375",
    c3: "-66.40625",
    c4: "-9.27734375",
  },
  {
    "": "1459",
    time: "1637709679.6264687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-44.921875",
    c3: "-96.19140625",
    c4: "-27.83203125",
  },
  {
    "": "1460",
    time: "1637709679.630375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-35.64453125",
    c3: "-108.88671875",
    c4: "-18.5546875",
  },
  {
    "": "1461",
    time: "1637709679.6342812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-21.484375",
    c3: "-102.5390625",
    c4: "8.7890625",
  },
  {
    "": "1462",
    time: "1637709679.6381874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-54.6875",
    c3: "-116.2109375",
    c4: "-2.9296875",
  },
  {
    "": "1463",
    time: "1637709679.6420937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-77.1484375",
    c3: "-102.5390625",
    c4: "-41.015625",
  },
  {
    "": "1464",
    time: "1637709679.644125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-39.0625",
    c3: "-83.984375",
    c4: "-20.5078125",
  },
  {
    "": "1465",
    time: "1637709679.6480312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-16.6015625",
    c3: "-41.015625",
    c4: "22.94921875",
  },
  {
    "": "1466",
    time: "1637709679.6519375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-35.64453125",
    c3: "-33.203125",
    c4: "6.8359375",
  },
  {
    "": "1467",
    time: "1637709679.6558437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-45.41015625",
    c3: "-96.19140625",
    c4: "-28.80859375",
  },
  {
    "": "1468",
    time: "1637709679.65975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-38.0859375",
    c3: "-111.328125",
    c4: "-36.1328125",
  },
  {
    "": "1469",
    time: "1637709679.6636562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-43.45703125",
    c3: "-67.87109375",
    c4: "1.46484375",
  },
  {
    "": "1470",
    time: "1637709679.6675625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-51.26953125",
    c3: "-60.05859375",
    c4: "31.73828125",
  },
  {
    "": "1471",
    time: "1637709679.6714687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-50.78125",
    c3: "-121.58203125",
    c4: "1.953125",
  },
  {
    "": "1472",
    time: "1637709679.675375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-50.78125",
    c3: "-137.6953125",
    c4: "-26.85546875",
  },
  {
    "": "1473",
    time: "1637709679.6792812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-67.87109375",
    c3: "-74.21875",
    c4: "-9.27734375",
  },
  {
    "": "1474",
    time: "1637709679.6831875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-53.22265625",
    c3: "-66.89453125",
    c4: "8.7890625",
  },
  {
    "": "1475",
    time: "1637709679.6870937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-19.04296875",
    c3: "-89.84375",
    c4: "-12.20703125",
  },
  {
    "": "1476",
    time: "1637709679.690125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-15.625",
    c3: "-87.40234375",
    c4: "-56.15234375",
  },
  {
    "": "1477",
    time: "1637709679.6940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-26.85546875",
    c3: "-92.7734375",
    c4: "-57.6171875",
  },
  {
    "": "1478",
    time: "1637709679.6979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-42.96875",
    c3: "-123.53515625",
    c4: "10.25390625",
  },
  {
    "": "1479",
    time: "1637709679.7018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-40.52734375",
    c3: "-85.9375",
    c4: "1.46484375",
  },
  {
    "": "1480",
    time: "1637709679.70575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-33.69140625",
    c3: "-73.2421875",
    c4: "-56.15234375",
  },
  {
    "": "1481",
    time: "1637709679.7096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-48.33984375",
    c3: "-94.7265625",
    c4: "-61.5234375",
  },
  {
    "": "1482",
    time: "1637709679.7135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-48.33984375",
    c3: "-81.54296875",
    c4: "-21.97265625",
  },
  {
    "": "1483",
    time: "1637709679.7174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-43.45703125",
    c3: "-111.328125",
    c4: "-3.90625",
  },
  {
    "": "1484",
    time: "1637709679.721375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-45.41015625",
    c3: "-78.61328125",
    c4: "-44.921875",
  },
  {
    "": "1485",
    time: "1637709679.7252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-60.546875",
    c3: "-36.1328125",
    c4: "-61.03515625",
  },
  {
    "": "1486",
    time: "1637709679.7291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-65.4296875",
    c3: "-60.546875",
    c4: "-16.11328125",
  },
  {
    "": "1487",
    time: "1637709679.7330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-63.4765625",
    c3: "-62.01171875",
    c4: "-2.9296875",
  },
  {
    "": "1488",
    time: "1637709679.734125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-62.01171875",
    c3: "-80.078125",
    c4: "-38.0859375",
  },
  {
    "": "1489",
    time: "1637709679.7380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-30.76171875",
    c3: "-104.00390625",
    c4: "-59.08203125",
  },
  {
    "": "1490",
    time: "1637709679.7419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-29.296875",
    c3: "-90.8203125",
    c4: "-26.3671875",
  },
  {
    "": "1491",
    time: "1637709679.7458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-41.9921875",
    c3: "-85.9375",
    c4: "4.8828125",
  },
  {
    "": "1492",
    time: "1637709679.74975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-44.921875",
    c3: "-92.7734375",
    c4: "-12.20703125",
  },
  {
    "": "1493",
    time: "1637709679.7536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-57.12890625",
    c3: "-93.26171875",
    c4: "-47.36328125",
  },
  {
    "": "1494",
    time: "1637709679.7575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-56.15234375",
    c3: "-139.16015625",
    c4: "-30.76171875",
  },
  {
    "": "1495",
    time: "1637709679.7614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-52.24609375",
    c3: "-163.0859375",
    c4: "26.3671875",
  },
  {
    "": "1496",
    time: "1637709679.765375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-53.7109375",
    c3: "-69.82421875",
    c4: "10.25390625",
  },
  {
    "": "1497",
    time: "1637709679.7692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-52.24609375",
    c3: "-22.4609375",
    c4: "-37.59765625",
  },
  {
    "": "1498",
    time: "1637709679.7731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-62.5",
    c3: "-61.03515625",
    c4: "-40.52734375",
  },
  {
    "": "1499",
    time: "1637709679.7770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-66.89453125",
    c3: "-58.10546875",
    c4: "-16.11328125",
  },
  {
    "": "1500",
    time: "1637709679.781125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-45.8984375",
    c3: "-32.2265625",
    c4: "-5.37109375",
  },
  {
    "": "1501",
    time: "1637709679.7850313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-26.3671875",
    c3: "-70.80078125",
    c4: "-35.15625",
  },
  {
    "": "1502",
    time: "1637709679.7889376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-48.828125",
    c3: "-100.09765625",
    c4: "-53.7109375",
  },
  {
    "": "1503",
    time: "1637709679.7928438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-66.40625",
    c3: "-65.4296875",
    c4: "-2.9296875",
  },
  {
    "": "1504",
    time: "1637709679.79675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-75.1953125",
    c3: "-73.73046875",
    c4: "37.59765625",
  },
  {
    "": "1505",
    time: "1637709679.8006563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-65.91796875",
    c3: "-91.30859375",
    c4: "8.30078125",
  },
  {
    "": "1506",
    time: "1637709679.8045626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-37.109375",
    c3: "-57.12890625",
    c4: "-42.48046875",
  },
  {
    "": "1507",
    time: "1637709679.8084688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-53.22265625",
    c3: "-34.66796875",
    c4: "-64.94140625",
  },
  {
    "": "1508",
    time: "1637709679.812375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-56.15234375",
    c3: "-62.98828125",
    c4: "-44.43359375",
  },
  {
    "": "1509",
    time: "1637709679.8162813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-35.15625",
    c3: "-85.44921875",
    c4: "-51.7578125",
  },
  {
    "": "1510",
    time: "1637709679.8201876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-41.50390625",
    c3: "-73.2421875",
    c4: "-90.8203125",
  },
  {
    "": "1511",
    time: "1637709679.8240938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-71.77734375",
    c3: "-46.38671875",
    c4: "-79.58984375",
  },
  {
    "": "1512",
    time: "1637709679.825125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-56.15234375",
    c3: "-16.6015625",
    c4: "-23.92578125",
  },
  {
    "": "1513",
    time: "1637709679.8290312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-26.85546875",
    c3: "-34.1796875",
    c4: "-25.390625",
  },
  {
    "": "1514",
    time: "1637709679.8329375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-38.0859375",
    c3: "-123.046875",
    c4: "-60.546875",
  },
  {
    "": "1515",
    time: "1637709679.8368437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-57.6171875",
    c3: "-122.0703125",
    c4: "-68.359375",
  },
  {
    "": "1516",
    time: "1637709679.84075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-40.52734375",
    c3: "-58.10546875",
    c4: "-28.80859375",
  },
  {
    "": "1517",
    time: "1637709679.8446562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-36.62109375",
    c3: "-66.40625",
    c4: "5.859375",
  },
  {
    "": "1518",
    time: "1637709679.8485625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-67.3828125",
    c3: "-111.81640625",
    c4: "-38.0859375",
  },
  {
    "": "1519",
    time: "1637709679.8524687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-75.68359375",
    c3: "-99.609375",
    c4: "-74.70703125",
  },
  {
    "": "1520",
    time: "1637709679.856375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-43.9453125",
    c3: "-30.76171875",
    c4: "-43.45703125",
  },
  {
    "": "1521",
    time: "1637709679.8602812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-28.3203125",
    c3: "-10.25390625",
    c4: "-19.04296875",
  },
  {
    "": "1522",
    time: "1637709679.8641875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-65.4296875",
    c3: "-29.296875",
    c4: "-41.015625",
  },
  {
    "": "1523",
    time: "1637709679.8680937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-62.01171875",
    c3: "-28.3203125",
    c4: "-66.40625",
  },
  {
    "": "1524",
    time: "1637709679.884125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-29.296875",
    c3: "-37.59765625",
    c4: "-36.62109375",
  },
  {
    "": "1525",
    time: "1637709679.8880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-16.6015625",
    c3: "-41.9921875",
    c4: "6.8359375",
  },
  {
    "": "1526",
    time: "1637709679.8919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-24.90234375",
    c3: "-25.87890625",
    c4: "-11.23046875",
  },
  {
    "": "1527",
    time: "1637709679.8958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-43.45703125",
    c3: "-39.55078125",
    c4: "-52.734375",
  },
  {
    "": "1528",
    time: "1637709679.89975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-44.43359375",
    c3: "-86.42578125",
    c4: "-36.1328125",
  },
  {
    "": "1529",
    time: "1637709679.9036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-38.57421875",
    c3: "-95.21484375",
    c4: "19.04296875",
  },
  {
    "": "1530",
    time: "1637709679.9075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-33.203125",
    c3: "-33.69140625",
    c4: "17.578125",
  },
  {
    "": "1531",
    time: "1637709679.9114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-45.41015625",
    c3: "-4.8828125",
    c4: "-31.73828125",
  },
  {
    "": "1532",
    time: "1637709679.915375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-70.3125",
    c3: "-45.8984375",
    c4: "-38.57421875",
  },
  {
    "": "1533",
    time: "1637709679.9192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-72.75390625",
    c3: "-28.80859375",
    c4: "-8.7890625",
  },
  {
    "": "1534",
    time: "1637709679.9231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-28.80859375",
    c3: "9.765625",
    c4: "-6.34765625",
  },
  {
    "": "1535",
    time: "1637709679.9270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-13.671875",
    c3: "-21.97265625",
    c4: "-31.73828125",
  },
  {
    "": "1536",
    time: "1637709679.929125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-41.015625",
    c3: "-62.98828125",
    c4: "-64.453125",
  },
  {
    "": "1537",
    time: "1637709679.9330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-45.8984375",
    c3: "-57.12890625",
    c4: "-60.546875",
  },
  {
    "": "1538",
    time: "1637709679.9369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "25.390625",
    c2: "-31.25",
    c3: "-31.73828125",
    c4: "-20.01953125",
  },
  {
    "": "1539",
    time: "1637709679.9408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-34.1796875",
    c3: "-52.734375",
    c4: "-13.18359375",
  },
  {
    "": "1540",
    time: "1637709679.94475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-42.48046875",
    c3: "-105.95703125",
    c4: "-45.41015625",
  },
  {
    "": "1541",
    time: "1637709679.9486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-45.8984375",
    c3: "-99.12109375",
    c4: "-33.69140625",
  },
  {
    "": "1542",
    time: "1637709679.9525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "-34.1796875",
    c3: "-52.734375",
    c4: "10.25390625",
  },
  {
    "": "1543",
    time: "1637709679.9564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-37.109375",
    c3: "-21.484375",
    c4: "-12.20703125",
  },
  {
    "": "1544",
    time: "1637709679.960375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-52.24609375",
    c3: "-62.98828125",
    c4: "-53.22265625",
  },
  {
    "": "1545",
    time: "1637709679.9642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-78.125",
    c3: "-74.21875",
    c4: "-54.6875",
  },
  {
    "": "1546",
    time: "1637709679.9681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-75.68359375",
    c3: "-0.9765625",
    c4: "-10.25390625",
  },
  {
    "": "1547",
    time: "1637709679.9720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-52.734375",
    c3: "-31.73828125",
    c4: "18.06640625",
  },
  {
    "": "1548",
    time: "1637709679.975125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-45.41015625",
    c3: "-67.3828125",
    c4: "-23.4375",
  },
  {
    "": "1549",
    time: "1637709679.9790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-29.296875",
    c3: "-59.5703125",
    c4: "-58.10546875",
  },
  {
    "": "1550",
    time: "1637709679.9829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-56.15234375",
    c3: "-41.50390625",
    c4: "-29.78515625",
  },
  {
    "": "1551",
    time: "1637709679.9868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-89.84375",
    c3: "-27.34375",
    c4: "6.34765625",
  },
  {
    "": "1552",
    time: "1637709679.99075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-55.6640625",
    c3: "-68.84765625",
    c4: "-21.484375",
  },
  {
    "": "1553",
    time: "1637709679.9946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-12.6953125",
    c3: "-98.14453125",
    c4: "-42.96875",
  },
  {
    "": "1554",
    time: "1637709679.9985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "11.71875",
    c3: "-78.61328125",
    c4: "8.30078125",
  },
  {
    "": "1555",
    time: "1637709680.0024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-13.18359375",
    c3: "-56.15234375",
    c4: "30.2734375",
  },
  {
    "": "1556",
    time: "1637709680.006375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-21.97265625",
    c3: "-81.0546875",
    c4: "-1.953125",
  },
  {
    "": "1557",
    time: "1637709680.0102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-11.23046875",
    c3: "-74.21875",
    c4: "-38.57421875",
  },
  {
    "": "1558",
    time: "1637709680.0141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-59.08203125",
    c3: "-66.40625",
    c4: "-21.97265625",
  },
  {
    "": "1559",
    time: "1637709680.0180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-88.8671875",
    c3: "-96.19140625",
    c4: "40.0390625",
  },
  {
    "": "1560",
    time: "1637709680.019125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-53.22265625",
    c3: "-75.68359375",
    c4: "20.5078125",
  },
  {
    "": "1561",
    time: "1637709680.0230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-22.4609375",
    c3: "-30.76171875",
    c4: "-34.1796875",
  },
  {
    "": "1562",
    time: "1637709680.0269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-33.203125",
    c3: "-54.6875",
    c4: "-44.921875",
  },
  {
    "": "1563",
    time: "1637709680.0308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-41.50390625",
    c3: "-96.19140625",
    c4: "16.11328125",
  },
  {
    "": "1564",
    time: "1637709680.03475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-36.62109375",
    c3: "-71.77734375",
    c4: "26.85546875",
  },
  {
    "": "1565",
    time: "1637709680.0386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-41.015625",
    c3: "-47.8515625",
    c4: "-30.2734375",
  },
  {
    "": "1566",
    time: "1637709680.0425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-33.203125",
    c3: "-54.6875",
    c4: "-25.390625",
  },
  {
    "": "1567",
    time: "1637709680.0464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-22.4609375",
    c3: "-83.49609375",
    c4: "24.90234375",
  },
  {
    "": "1568",
    time: "1637709680.050375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "-36.62109375",
    c3: "-91.796875",
    c4: "35.15625",
  },
  {
    "": "1569",
    time: "1637709680.0542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-63.96484375",
    c3: "-37.109375",
    c4: "14.16015625",
  },
  {
    "": "1570",
    time: "1637709680.0581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-62.5",
    c3: "-62.01171875",
    c4: "-0.48828125",
  },
  {
    "": "1571",
    time: "1637709680.0620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-21.484375",
    c3: "-74.21875",
    c4: "6.8359375",
  },
  {
    "": "1572",
    time: "1637709680.066125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-12.20703125",
    c3: "-11.71875",
    c4: "26.85546875",
  },
  {
    "": "1573",
    time: "1637709680.0700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-24.90234375",
    c3: "-1.953125",
    c4: "-3.90625",
  },
  {
    "": "1574",
    time: "1637709680.0739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-23.92578125",
    c3: "-63.96484375",
    c4: "-34.66796875",
  },
  {
    "": "1575",
    time: "1637709680.0778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-20.01953125",
    c3: "-87.40234375",
    c4: "-23.92578125",
  },
  {
    "": "1576",
    time: "1637709680.08175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-36.1328125",
    c3: "-42.96875",
    c4: "36.62109375",
  },
  {
    "": "1577",
    time: "1637709680.0856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-59.5703125",
    c3: "-53.22265625",
    c4: "23.4375",
  },
  {
    "": "1578",
    time: "1637709680.0895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-55.17578125",
    c3: "-78.125",
    c4: "-38.0859375",
  },
  {
    "": "1579",
    time: "1637709680.0934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-48.33984375",
    c3: "-87.890625",
    c4: "-32.71484375",
  },
  {
    "": "1580",
    time: "1637709680.097375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-31.25",
    c3: "-56.640625",
    c4: "2.44140625",
  },
  {
    "": "1581",
    time: "1637709680.1012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-15.13671875",
    c3: "-29.296875",
    c4: "24.90234375",
  },
  {
    "": "1582",
    time: "1637709680.1051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-29.296875",
    c3: "-66.89453125",
    c4: "-10.25390625",
  },
  {
    "": "1583",
    time: "1637709680.1090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-53.7109375",
    c3: "-91.30859375",
    c4: "-42.48046875",
  },
  {
    "": "1584",
    time: "1637709680.110125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-60.546875",
    c3: "-72.75390625",
    c4: "1.953125",
  },
  {
    "": "1585",
    time: "1637709680.1140313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-35.64453125",
    c3: "-44.921875",
    c4: "33.203125",
  },
  {
    "": "1586",
    time: "1637709680.1179376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-7.8125",
    c3: "-48.33984375",
    c4: "-16.11328125",
  },
  {
    "": "1587",
    time: "1637709680.1218438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-19.53125",
    c3: "-63.4765625",
    c4: "-40.52734375",
  },
  {
    "": "1588",
    time: "1637709680.12575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-26.85546875",
    c3: "-57.12890625",
    c4: "-18.06640625",
  },
  {
    "": "1589",
    time: "1637709680.1296563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-31.73828125",
    c3: "-55.6640625",
    c4: "15.625",
  },
  {
    "": "1590",
    time: "1637709680.1335626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-47.8515625",
    c3: "-80.56640625",
    c4: "14.6484375",
  },
  {
    "": "1591",
    time: "1637709680.1374688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-36.62109375",
    c3: "-113.76953125",
    c4: "-15.625",
  },
  {
    "": "1592",
    time: "1637709680.141375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-61.03515625",
    c3: "-56.15234375",
    c4: "-23.92578125",
  },
  {
    "": "1593",
    time: "1637709680.1452813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-76.66015625",
    c3: "-32.2265625",
    c4: "11.23046875",
  },
  {
    "": "1594",
    time: "1637709680.1491876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-42.48046875",
    c3: "-74.70703125",
    c4: "27.83203125",
  },
  {
    "": "1595",
    time: "1637709680.1530938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-44.921875",
    c3: "-101.5625",
    c4: "-7.32421875",
  },
  {
    "": "1596",
    time: "1637709680.156125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-46.875",
    c3: "-115.72265625",
    c4: "-30.76171875",
  },
  {
    "": "1597",
    time: "1637709680.1600313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-20.5078125",
    c3: "-114.74609375",
    c4: "10.25390625",
  },
  {
    "": "1598",
    time: "1637709680.1639376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-20.99609375",
    c3: "-60.05859375",
    c4: "35.64453125",
  },
  {
    "": "1599",
    time: "1637709680.1678438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-38.57421875",
    c3: "-15.625",
    c4: "-29.296875",
  },
  {
    "": "1600",
    time: "1637709680.17175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-52.24609375",
    c3: "-41.9921875",
    c4: "-89.35546875",
  },
  {
    "": "1601",
    time: "1637709680.1756563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-46.38671875",
    c3: "-67.87109375",
    c4: "-47.36328125",
  },
  {
    "": "1602",
    time: "1637709680.1795626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-26.3671875",
    c3: "-73.2421875",
    c4: "17.578125",
  },
  {
    "": "1603",
    time: "1637709680.1834688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-27.34375",
    c3: "-48.33984375",
    c4: "-1.953125",
  },
  {
    "": "1604",
    time: "1637709680.187375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-41.50390625",
    c3: "-29.296875",
    c4: "-39.0625",
  },
  {
    "": "1605",
    time: "1637709680.1912813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-56.15234375",
    c3: "-87.40234375",
    c4: "-21.97265625",
  },
  {
    "": "1606",
    time: "1637709680.1951876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.671875",
    c2: "-53.7109375",
    c3: "-94.7265625",
    c4: "18.06640625",
  },
  {
    "": "1607",
    time: "1637709680.1990938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-48.33984375",
    c3: "-38.57421875",
    c4: "1.953125",
  },
  {
    "": "1608",
    time: "1637709680.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-43.45703125",
    c3: "-81.0546875",
    c4: "-32.71484375",
  },
  {
    "": "1609",
    time: "1637709680.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-35.64453125",
    c3: "-100.09765625",
    c4: "-27.34375",
  },
  {
    "": "1610",
    time: "1637709680.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-22.94921875",
    c3: "-76.66015625",
    c4: "9.765625",
  },
  {
    "": "1611",
    time: "1637709680.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-18.06640625",
    c3: "-60.546875",
    c4: "19.53125",
  },
  {
    "": "1612",
    time: "1637709680.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-23.92578125",
    c3: "-46.875",
    c4: "-24.90234375",
  },
  {
    "": "1613",
    time: "1637709680.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-31.25",
    c3: "-83.984375",
    c4: "-36.1328125",
  },
  {
    "": "1614",
    time: "1637709680.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-45.8984375",
    c3: "-74.21875",
    c4: "5.37109375",
  },
  {
    "": "1615",
    time: "1637709680.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-54.19921875",
    c3: "-5.859375",
    c4: "20.99609375",
  },
  {
    "": "1616",
    time: "1637709680.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-75.1953125",
    c3: "-42.96875",
    c4: "5.37109375",
  },
  {
    "": "1617",
    time: "1637709680.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-62.01171875",
    c3: "-79.58984375",
    c4: "-27.34375",
  },
  {
    "": "1618",
    time: "1637709680.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-39.55078125",
    c3: "-70.3125",
    c4: "-30.76171875",
  },
  {
    "": "1619",
    time: "1637709680.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-37.109375",
    c3: "-34.1796875",
    c4: "0.48828125",
  },
  {
    "": "1620",
    time: "1637709680.268125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-13.671875",
    c3: "-41.015625",
    c4: "-9.27734375",
  },
  {
    "": "1621",
    time: "1637709680.2720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-51.26953125",
    c3: "-80.56640625",
    c4: "-38.0859375",
  },
  {
    "": "1622",
    time: "1637709680.2759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-80.078125",
    c3: "-46.875",
    c4: "-42.48046875",
  },
  {
    "": "1623",
    time: "1637709680.2798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-27.83203125",
    c3: "-27.83203125",
    c4: "0.9765625",
  },
  {
    "": "1624",
    time: "1637709680.28375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.5078125",
    c2: "2.9296875",
    c3: "-75.1953125",
    c4: "11.23046875",
  },
  {
    "": "1625",
    time: "1637709680.2876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-2.44140625",
    c3: "-69.82421875",
    c4: "-15.13671875",
  },
  {
    "": "1626",
    time: "1637709680.2915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-15.625",
    c3: "-42.48046875",
    c4: "-14.16015625",
  },
  {
    "": "1627",
    time: "1637709680.2954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-29.296875",
    c3: "-66.89453125",
    c4: "6.8359375",
  },
  {
    "": "1628",
    time: "1637709680.299375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-32.71484375",
    c3: "-81.54296875",
    c4: "22.4609375",
  },
  {
    "": "1629",
    time: "1637709680.3032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-45.8984375",
    c3: "-76.171875",
    c4: "3.41796875",
  },
  {
    "": "1630",
    time: "1637709680.3071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-48.828125",
    c3: "-42.48046875",
    c4: "-29.78515625",
  },
  {
    "": "1631",
    time: "1637709680.3110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-26.85546875",
    c3: "-34.1796875",
    c4: "-7.32421875",
  },
  {
    "": "1632",
    time: "1637709680.304125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-39.55078125",
    c3: "-66.40625",
    c4: "17.578125",
  },
  {
    "": "1633",
    time: "1637709680.3080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-91.30859375",
    c3: "-51.26953125",
    c4: "4.39453125",
  },
  {
    "": "1634",
    time: "1637709680.3119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-85.44921875",
    c3: "-22.4609375",
    c4: "-8.7890625",
  },
  {
    "": "1635",
    time: "1637709680.3158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-27.83203125",
    c3: "-44.921875",
    c4: "1.953125",
  },
  {
    "": "1636",
    time: "1637709680.31975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-23.92578125",
    c3: "-70.80078125",
    c4: "22.94921875",
  },
  {
    "": "1637",
    time: "1637709680.3236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-43.9453125",
    c3: "-106.4453125",
    c4: "12.20703125",
  },
  {
    "": "1638",
    time: "1637709680.3275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-28.3203125",
    c3: "-74.21875",
    c4: "-30.2734375",
  },
  {
    "": "1639",
    time: "1637709680.3314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-20.5078125",
    c3: "-38.0859375",
    c4: "-37.59765625",
  },
  {
    "": "1640",
    time: "1637709680.335375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-30.76171875",
    c3: "-72.265625",
    c4: "11.71875",
  },
  {
    "": "1641",
    time: "1637709680.3392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-59.5703125",
    c3: "-90.33203125",
    c4: "-1.953125",
  },
  {
    "": "1642",
    time: "1637709680.3431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-77.63671875",
    c3: "-50.29296875",
    c4: "-33.69140625",
  },
  {
    "": "1643",
    time: "1637709680.3470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-55.17578125",
    c3: "-53.22265625",
    c4: "-33.203125",
  },
  {
    "": "1644",
    time: "1637709680.352125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-32.2265625",
    c3: "-55.17578125",
    c4: "-5.859375",
  },
  {
    "": "1645",
    time: "1637709680.3560312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-48.33984375",
    c3: "-37.59765625",
    c4: "6.8359375",
  },
  {
    "": "1646",
    time: "1637709680.3599374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-50.29296875",
    c3: "-62.01171875",
    c4: "-28.3203125",
  },
  {
    "": "1647",
    time: "1637709680.3638437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-55.6640625",
    c3: "-78.61328125",
    c4: "-42.96875",
  },
  {
    "": "1648",
    time: "1637709680.36775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-63.96484375",
    c3: "-91.30859375",
    c4: "-10.7421875",
  },
  {
    "": "1649",
    time: "1637709680.3716562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-30.76171875",
    c3: "-60.546875",
    c4: "11.71875",
  },
  {
    "": "1650",
    time: "1637709680.3755624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-36.62109375",
    c3: "-49.31640625",
    c4: "-21.97265625",
  },
  {
    "": "1651",
    time: "1637709680.3794687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-44.921875",
    c3: "-107.91015625",
    c4: "-57.6171875",
  },
  {
    "": "1652",
    time: "1637709680.383375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-37.109375",
    c3: "-140.625",
    c4: "-25.390625",
  },
  {
    "": "1653",
    time: "1637709680.3872812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-55.17578125",
    c3: "-56.640625",
    c4: "2.9296875",
  },
  {
    "": "1654",
    time: "1637709680.3911874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-69.82421875",
    c3: "-11.23046875",
    c4: "-16.6015625",
  },
  {
    "": "1655",
    time: "1637709680.3950937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-58.59375",
    c3: "-50.78125",
    c4: "-42.48046875",
  },
  {
    "": "1656",
    time: "1637709680.394125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-25.87890625",
    c3: "-76.171875",
    c4: "-29.296875",
  },
  {
    "": "1657",
    time: "1637709680.3980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-23.92578125",
    c3: "-38.57421875",
    c4: "11.71875",
  },
  {
    "": "1658",
    time: "1637709680.4019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-62.98828125",
    c3: "-26.85546875",
    c4: "22.4609375",
  },
  {
    "": "1659",
    time: "1637709680.4058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-48.828125",
    c3: "-83.984375",
    c4: "-14.16015625",
  },
  {
    "": "1660",
    time: "1637709680.40975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-34.66796875",
    c3: "-86.42578125",
    c4: "-30.2734375",
  },
  {
    "": "1661",
    time: "1637709680.4136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-44.921875",
    c3: "-34.1796875",
    c4: "-2.9296875",
  },
  {
    "": "1662",
    time: "1637709680.4175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-57.6171875",
    c3: "-38.0859375",
    c4: "10.7421875",
  },
  {
    "": "1663",
    time: "1637709680.4214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-71.2890625",
    c3: "-137.20703125",
    c4: "3.41796875",
  },
  {
    "": "1664",
    time: "1637709680.425375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-50.78125",
    c3: "-174.31640625",
    c4: "-16.6015625",
  },
  {
    "": "1665",
    time: "1637709680.4292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-17.578125",
    c3: "-75.1953125",
    c4: "-7.32421875",
  },
  {
    "": "1666",
    time: "1637709680.4331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-4.8828125",
    c3: "-33.203125",
    c4: "14.16015625",
  },
  {
    "": "1667",
    time: "1637709680.4370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-32.71484375",
    c3: "-49.31640625",
    c4: "1.46484375",
  },
  {
    "": "1668",
    time: "1637709680.440125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-51.26953125",
    c3: "-63.96484375",
    c4: "-30.2734375",
  },
  {
    "": "1669",
    time: "1637709680.4440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-32.71484375",
    c3: "-45.8984375",
    c4: "-12.20703125",
  },
  {
    "": "1670",
    time: "1637709680.4479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-76.66015625",
    c3: "-38.57421875",
    c4: "34.1796875",
  },
  {
    "": "1671",
    time: "1637709680.4518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-93.75",
    c3: "-57.6171875",
    c4: "21.97265625",
  },
  {
    "": "1672",
    time: "1637709680.45575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-46.38671875",
    c3: "-50.78125",
    c4: "-10.25390625",
  },
  {
    "": "1673",
    time: "1637709680.4596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-32.2265625",
    c3: "-76.66015625",
    c4: "-3.41796875",
  },
  {
    "": "1674",
    time: "1637709680.4635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-33.69140625",
    c3: "-90.33203125",
    c4: "40.0390625",
  },
  {
    "": "1675",
    time: "1637709680.4674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "27.34375",
    c2: "-40.52734375",
    c3: "-103.515625",
    c4: "44.43359375",
  },
  {
    "": "1676",
    time: "1637709680.471375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-40.52734375",
    c3: "-71.2890625",
    c4: "-8.7890625",
  },
  {
    "": "1677",
    time: "1637709680.4752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-28.80859375",
    c3: "-42.48046875",
    c4: "-42.48046875",
  },
  {
    "": "1678",
    time: "1637709680.4791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-38.57421875",
    c3: "-69.82421875",
    c4: "3.90625",
  },
  {
    "": "1679",
    time: "1637709680.4830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-59.5703125",
    c3: "-83.0078125",
    c4: "42.96875",
  },
  {
    "": "1680",
    time: "1637709680.484125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-40.0390625",
    c3: "-62.01171875",
    c4: "8.7890625",
  },
  {
    "": "1681",
    time: "1637709680.4880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-41.50390625",
    c3: "-30.2734375",
    c4: "-26.3671875",
  },
  {
    "": "1682",
    time: "1637709680.4919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-46.875",
    c3: "-33.69140625",
    c4: "-2.9296875",
  },
  {
    "": "1683",
    time: "1637709680.4958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-28.80859375",
    c3: "-64.94140625",
    c4: "7.8125",
  },
  {
    "": "1684",
    time: "1637709680.49975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-30.76171875",
    c3: "-68.359375",
    c4: "-18.06640625",
  },
  {
    "": "1685",
    time: "1637709680.5036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-29.296875",
    c3: "-61.5234375",
    c4: "-41.9921875",
  },
  {
    "": "1686",
    time: "1637709680.5075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-45.41015625",
    c3: "-93.75",
    c4: "-34.66796875",
  },
  {
    "": "1687",
    time: "1637709680.5114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-52.734375",
    c3: "-105.46875",
    c4: "9.27734375",
  },
  {
    "": "1688",
    time: "1637709680.515375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-84.9609375",
    c3: "-44.43359375",
    c4: "17.578125",
  },
  {
    "": "1689",
    time: "1637709680.5192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-97.65625",
    c3: "-49.8046875",
    c4: "-9.27734375",
  },
  {
    "": "1690",
    time: "1637709680.5231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-40.0390625",
    c3: "-76.171875",
    c4: "-12.20703125",
  },
  {
    "": "1691",
    time: "1637709680.5270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-16.6015625",
    c3: "-36.1328125",
    c4: "15.625",
  },
  {
    "": "1692",
    time: "1637709680.532125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-20.5078125",
    c3: "-41.9921875",
    c4: "19.53125",
  },
  {
    "": "1693",
    time: "1637709680.5360312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-23.92578125",
    c3: "-93.75",
    c4: "-8.30078125",
  },
  {
    "": "1694",
    time: "1637709680.5399375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-42.48046875",
    c3: "-92.7734375",
    c4: "-27.34375",
  },
  {
    "": "1695",
    time: "1637709680.5438437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-62.5",
    c3: "-44.43359375",
    c4: "-2.44140625",
  },
  {
    "": "1696",
    time: "1637709680.54775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-62.98828125",
    c3: "-3.90625",
    c4: "15.13671875",
  },
  {
    "": "1697",
    time: "1637709680.5516562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-60.546875",
    c3: "-56.15234375",
    c4: "-12.6953125",
  },
  {
    "": "1698",
    time: "1637709680.5555625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-57.6171875",
    c3: "-105.46875",
    c4: "-20.5078125",
  },
  {
    "": "1699",
    time: "1637709680.5594687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-47.36328125",
    c3: "-63.4765625",
    c4: "-10.25390625",
  },
  {
    "": "1700",
    time: "1637709680.563375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-28.80859375",
    c3: "-50.29296875",
    c4: "19.53125",
  },
  {
    "": "1701",
    time: "1637709680.5672812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-30.2734375",
    c3: "-53.22265625",
    c4: "14.6484375",
  },
  {
    "": "1702",
    time: "1637709680.5711875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-67.87109375",
    c3: "-43.9453125",
    c4: "-29.78515625",
  },
  {
    "": "1703",
    time: "1637709680.5750937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-62.5",
    c3: "-46.875",
    c4: "-40.0390625",
  },
  {
    "": "1704",
    time: "1637709680.589125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-28.3203125",
    c3: "-58.10546875",
    c4: "17.578125",
  },
  {
    "": "1705",
    time: "1637709680.5930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-46.38671875",
    c3: "-92.7734375",
    c4: "28.3203125",
  },
  {
    "": "1706",
    time: "1637709680.5969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-71.2890625",
    c3: "-84.9609375",
    c4: "-29.78515625",
  },
  {
    "": "1707",
    time: "1637709680.6008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-71.2890625",
    c3: "-45.41015625",
    c4: "-38.57421875",
  },
  {
    "": "1708",
    time: "1637709680.60475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-34.66796875",
    c3: "-68.359375",
    c4: "-2.44140625",
  },
  {
    "": "1709",
    time: "1637709680.6086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-6.8359375",
    c3: "-93.75",
    c4: "26.3671875",
  },
  {
    "": "1710",
    time: "1637709680.6125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-31.25",
    c3: "-105.46875",
    c4: "9.765625",
  },
  {
    "": "1711",
    time: "1637709680.6164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-41.015625",
    c3: "-55.6640625",
    c4: "-24.90234375",
  },
  {
    "": "1712",
    time: "1637709680.620375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-39.0625",
    c3: "-31.25",
    c4: "-8.7890625",
  },
  {
    "": "1713",
    time: "1637709680.6242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-49.8046875",
    c3: "-17.578125",
    c4: "20.5078125",
  },
  {
    "": "1714",
    time: "1637709680.6281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-58.59375",
    c3: "-29.78515625",
    c4: "5.37109375",
  },
  {
    "": "1715",
    time: "1637709680.6320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-62.5",
    c3: "-68.359375",
    c4: "-19.53125",
  },
  {
    "": "1716",
    time: "1637709680.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-66.40625",
    c3: "-74.70703125",
    c4: "2.44140625",
  },
  {
    "": "1717",
    time: "1637709680.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-64.94140625",
    c3: "-88.8671875",
    c4: "38.0859375",
  },
  {
    "": "1718",
    time: "1637709680.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-36.1328125",
    c3: "-65.91796875",
    c4: "7.32421875",
  },
  {
    "": "1719",
    time: "1637709680.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-11.23046875",
    c3: "-30.76171875",
    c4: "-30.2734375",
  },
  {
    "": "1720",
    time: "1637709680.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-22.4609375",
    c3: "-44.921875",
    c4: "-28.80859375",
  },
  {
    "": "1721",
    time: "1637709680.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-32.71484375",
    c3: "-69.82421875",
    c4: "-1.953125",
  },
  {
    "": "1722",
    time: "1637709680.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-45.41015625",
    c3: "-60.05859375",
    c4: "18.5546875",
  },
  {
    "": "1723",
    time: "1637709680.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-62.01171875",
    c3: "-35.15625",
    c4: "-11.71875",
  },
  {
    "": "1724",
    time: "1637709680.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-75.68359375",
    c3: "-56.640625",
    c4: "-15.13671875",
  },
  {
    "": "1725",
    time: "1637709680.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-59.5703125",
    c3: "-101.07421875",
    c4: "28.3203125",
  },
  {
    "": "1726",
    time: "1637709680.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-24.4140625",
    c3: "-46.875",
    c4: "36.1328125",
  },
  {
    "": "1727",
    time: "1637709680.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-36.62109375",
    c3: "-16.11328125",
    c4: "1.953125",
  },
  {
    "": "1728",
    time: "1637709680.679125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-35.64453125",
    c3: "-44.43359375",
    c4: "-34.66796875",
  },
  {
    "": "1729",
    time: "1637709680.6830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-20.01953125",
    c3: "-59.08203125",
    c4: "-12.20703125",
  },
  {
    "": "1730",
    time: "1637709680.6869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-49.31640625",
    c3: "-63.4765625",
    c4: "23.4375",
  },
  {
    "": "1731",
    time: "1637709680.6908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-80.078125",
    c3: "-89.84375",
    c4: "3.41796875",
  },
  {
    "": "1732",
    time: "1637709680.69475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-64.94140625",
    c3: "-112.3046875",
    c4: "-33.69140625",
  },
  {
    "": "1733",
    time: "1637709680.6986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-26.85546875",
    c3: "-74.70703125",
    c4: "-28.80859375",
  },
  {
    "": "1734",
    time: "1637709680.7025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-35.15625",
    c3: "-21.484375",
    c4: "-5.37109375",
  },
  {
    "": "1735",
    time: "1637709680.7064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-44.921875",
    c3: "-21.484375",
    c4: "-24.90234375",
  },
  {
    "": "1736",
    time: "1637709680.710375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-26.85546875",
    c3: "-105.95703125",
    c4: "-53.7109375",
  },
  {
    "": "1737",
    time: "1637709680.7142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-30.2734375",
    c3: "-111.81640625",
    c4: "-50.29296875",
  },
  {
    "": "1738",
    time: "1637709680.7181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-45.8984375",
    c3: "-27.83203125",
    c4: "-27.34375",
  },
  {
    "": "1739",
    time: "1637709680.7220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-56.640625",
    c3: "-35.15625",
    c4: "-19.04296875",
  },
  {
    "": "1740",
    time: "1637709680.725125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-61.03515625",
    c3: "-75.68359375",
    c4: "-48.828125",
  },
  {
    "": "1741",
    time: "1637709680.7290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-50.78125",
    c3: "-78.125",
    c4: "-59.08203125",
  },
  {
    "": "1742",
    time: "1637709680.7329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-42.96875",
    c3: "-49.31640625",
    c4: "-19.04296875",
  },
  {
    "": "1743",
    time: "1637709680.7368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-43.45703125",
    c3: "-50.78125",
    c4: "6.34765625",
  },
  {
    "": "1744",
    time: "1637709680.74075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-32.2265625",
    c3: "-71.2890625",
    c4: "-12.20703125",
  },
  {
    "": "1745",
    time: "1637709680.7446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-35.15625",
    c3: "-100.5859375",
    c4: "-56.640625",
  },
  {
    "": "1746",
    time: "1637709680.7485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-36.62109375",
    c3: "-89.84375",
    c4: "-51.7578125",
  },
  {
    "": "1747",
    time: "1637709680.7524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-41.015625",
    c3: "-68.359375",
    c4: "-1.46484375",
  },
  {
    "": "1748",
    time: "1637709680.756375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-65.91796875",
    c3: "-104.00390625",
    c4: "-8.30078125",
  },
  {
    "": "1749",
    time: "1637709680.7602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-79.1015625",
    c3: "-95.703125",
    c4: "-70.80078125",
  },
  {
    "": "1750",
    time: "1637709680.7641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-57.6171875",
    c3: "-70.80078125",
    c4: "-61.5234375",
  },
  {
    "": "1751",
    time: "1637709680.7680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-51.7578125",
    c3: "-70.80078125",
    c4: "-12.20703125",
  },
  {
    "": "1752",
    time: "1637709680.769125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-75.1953125",
    c3: "-63.4765625",
    c4: "-13.671875",
  },
  {
    "": "1753",
    time: "1637709680.7730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-78.61328125",
    c3: "-34.1796875",
    c4: "-49.8046875",
  },
  {
    "": "1754",
    time: "1637709680.7769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-71.2890625",
    c3: "-43.45703125",
    c4: "-57.12890625",
  },
  {
    "": "1755",
    time: "1637709680.7808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-56.15234375",
    c3: "-92.28515625",
    c4: "-12.6953125",
  },
  {
    "": "1756",
    time: "1637709680.78475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-35.15625",
    c3: "-72.75390625",
    c4: "-0.48828125",
  },
  {
    "": "1757",
    time: "1637709680.7886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-54.6875",
    c3: "-38.57421875",
    c4: "-40.52734375",
  },
  {
    "": "1758",
    time: "1637709680.7925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-52.24609375",
    c3: "-76.66015625",
    c4: "-61.03515625",
  },
  {
    "": "1759",
    time: "1637709680.7964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-32.71484375",
    c3: "-164.0625",
    c4: "-7.8125",
  },
  {
    "": "1760",
    time: "1637709680.800375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-45.8984375",
    c3: "-143.5546875",
    c4: "26.3671875",
  },
  {
    "": "1761",
    time: "1637709680.8042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-59.5703125",
    c3: "-51.7578125",
    c4: "-38.0859375",
  },
  {
    "": "1762",
    time: "1637709680.8081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-51.26953125",
    c3: "-59.08203125",
    c4: "-74.70703125",
  },
  {
    "": "1763",
    time: "1637709680.8120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-44.43359375",
    c3: "-64.453125",
    c4: "-41.015625",
  },
  {
    "": "1764",
    time: "1637709680.817125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-50.29296875",
    c3: "-49.31640625",
    c4: "-9.765625",
  },
  {
    "": "1765",
    time: "1637709680.8210313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-36.62109375",
    c3: "-48.33984375",
    c4: "-13.671875",
  },
  {
    "": "1766",
    time: "1637709680.8249376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-22.4609375",
    c3: "-92.28515625",
    c4: "-43.9453125",
  },
  {
    "": "1767",
    time: "1637709680.8288438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-41.9921875",
    c3: "-90.33203125",
    c4: "-46.38671875",
  },
  {
    "": "1768",
    time: "1637709680.83275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-58.59375",
    c3: "-36.1328125",
    c4: "-12.6953125",
  },
  {
    "": "1769",
    time: "1637709680.8366563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-38.57421875",
    c3: "-48.828125",
    c4: "-2.9296875",
  },
  {
    "": "1770",
    time: "1637709680.8405626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-47.36328125",
    c3: "-90.8203125",
    c4: "-37.109375",
  },
  {
    "": "1771",
    time: "1637709680.8444688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-54.19921875",
    c3: "-118.65234375",
    c4: "-48.33984375",
  },
  {
    "": "1772",
    time: "1637709680.848375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-18.06640625",
    c3: "-79.58984375",
    c4: "-11.71875",
  },
  {
    "": "1773",
    time: "1637709680.8522813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-26.3671875",
    c3: "-34.66796875",
    c4: "20.5078125",
  },
  {
    "": "1774",
    time: "1637709680.8561876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-26.85546875",
    c3: "-66.40625",
    c4: "-3.90625",
  },
  {
    "": "1775",
    time: "1637709680.8600938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-46.38671875",
    c3: "-97.65625",
    c4: "-39.0625",
  },
  {
    "": "1776",
    time: "1637709680.859125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-83.49609375",
    c3: "-81.0546875",
    c4: "-28.3203125",
  },
  {
    "": "1777",
    time: "1637709680.8630311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-43.45703125",
    c3: "-27.34375",
    c4: "8.7890625",
  },
  {
    "": "1778",
    time: "1637709680.8669374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-29.296875",
    c3: "-2.9296875",
    c4: "3.41796875",
  },
  {
    "": "1779",
    time: "1637709680.8708436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-37.109375",
    c3: "-47.36328125",
    c4: "-18.06640625",
  },
  {
    "": "1780",
    time: "1637709680.87475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-20.01953125",
    c3: "-101.5625",
    c4: "8.30078125",
  },
  {
    "": "1781",
    time: "1637709680.8786561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-6.8359375",
    c3: "-83.49609375",
    c4: "29.296875",
  },
  {
    "": "1782",
    time: "1637709680.8825624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-19.53125",
    c3: "-82.03125",
    c4: "5.859375",
  },
  {
    "": "1783",
    time: "1637709680.8864686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-33.69140625",
    c3: "-144.53125",
    c4: "-26.3671875",
  },
  {
    "": "1784",
    time: "1637709680.890375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-35.64453125",
    c3: "-79.1015625",
    c4: "-35.64453125",
  },
  {
    "": "1785",
    time: "1637709680.8942811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-32.2265625",
    c3: "-10.7421875",
    c4: "7.8125",
  },
  {
    "": "1786",
    time: "1637709680.8981874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-7.8125",
    c3: "-29.78515625",
    c4: "6.8359375",
  },
  {
    "": "1787",
    time: "1637709680.9020936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-16.11328125",
    c3: "-58.10546875",
    c4: "-25.87890625",
  },
  {
    "": "1788",
    time: "1637709680.905125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-21.97265625",
    c3: "-59.5703125",
    c4: "-32.71484375",
  },
  {
    "": "1789",
    time: "1637709680.9090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-35.15625",
    c3: "-23.4375",
    c4: "-9.27734375",
  },
  {
    "": "1790",
    time: "1637709680.9129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "21.484375",
    c2: "-49.8046875",
    c3: "-4.8828125",
    c4: "30.76171875",
  },
  {
    "": "1791",
    time: "1637709680.9168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-30.76171875",
    c3: "-33.69140625",
    c4: "20.5078125",
  },
  {
    "": "1792",
    time: "1637709680.92075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-38.0859375",
    c3: "-44.43359375",
    c4: "5.37109375",
  },
  {
    "": "1793",
    time: "1637709680.9246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-35.64453125",
    c3: "-38.57421875",
    c4: "8.7890625",
  },
  {
    "": "1794",
    time: "1637709680.9285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-30.76171875",
    c3: "-53.7109375",
    c4: "29.78515625",
  },
  {
    "": "1795",
    time: "1637709680.9324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-60.05859375",
    c3: "-34.66796875",
    c4: "24.4140625",
  },
  {
    "": "1796",
    time: "1637709680.936375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-51.26953125",
    c3: "-23.4375",
    c4: "-32.2265625",
  },
  {
    "": "1797",
    time: "1637709680.9402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-18.06640625",
    c3: "-67.87109375",
    c4: "-15.625",
  },
  {
    "": "1798",
    time: "1637709680.9441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-28.3203125",
    c3: "-69.3359375",
    c4: "52.24609375",
  },
  {
    "": "1799",
    time: "1637709680.9480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-57.6171875",
    c3: "-41.015625",
    c4: "41.50390625",
  },
  {
    "": "1800",
    time: "1637709680.949125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-63.4765625",
    c3: "-57.12890625",
    c4: "-3.90625",
  },
  {
    "": "1801",
    time: "1637709680.9530313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-46.875",
    c3: "-36.62109375",
    c4: "-14.16015625",
  },
  {
    "": "1802",
    time: "1637709680.9569376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-23.4375",
    c3: "-29.78515625",
    c4: "12.20703125",
  },
  {
    "": "1803",
    time: "1637709680.9608438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-7.32421875",
    c3: "-48.828125",
    c4: "36.62109375",
  },
  {
    "": "1804",
    time: "1637709680.96475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-23.92578125",
    c3: "-58.59375",
    c4: "10.25390625",
  },
  {
    "": "1805",
    time: "1637709680.9686563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-32.71484375",
    c3: "-87.40234375",
    c4: "-10.7421875",
  },
  {
    "": "1806",
    time: "1637709680.9725626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-25.390625",
    c3: "-84.47265625",
    c4: "22.94921875",
  },
  {
    "": "1807",
    time: "1637709680.9764688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "15.625",
    c2: "-9.765625",
    c3: "-12.6953125",
    c4: "24.90234375",
  },
  {
    "": "1808",
    time: "1637709680.980375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-21.484375",
    c3: "-12.20703125",
    c4: "0.0",
  },
  {
    "": "1809",
    time: "1637709680.9842813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-28.80859375",
    c3: "-36.1328125",
    c4: "-27.83203125",
  },
  {
    "": "1810",
    time: "1637709680.9881876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-20.01953125",
    c3: "-54.6875",
    c4: "-8.7890625",
  },
  {
    "": "1811",
    time: "1637709680.9920938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-30.76171875",
    c3: "-35.15625",
    c4: "41.015625",
  },
  {
    "": "1812",
    time: "1637709680.997125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-31.73828125",
    c3: "-30.76171875",
    c4: "21.97265625",
  },
  {
    "": "1813",
    time: "1637709681.0010312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-58.59375",
    c3: "-86.42578125",
    c4: "-15.625",
  },
  {
    "": "1814",
    time: "1637709681.0049374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-85.9375",
    c3: "-58.59375",
    c4: "-10.25390625",
  },
  {
    "": "1815",
    time: "1637709681.0088437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-51.26953125",
    c3: "-7.8125",
    c4: "29.296875",
  },
  {
    "": "1816",
    time: "1637709681.01275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-16.6015625",
    c3: "-25.87890625",
    c4: "37.109375",
  },
  {
    "": "1817",
    time: "1637709681.0166562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-34.1796875",
    c3: "-66.89453125",
    c4: "-26.3671875",
  },
  {
    "": "1818",
    time: "1637709681.0205624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-43.45703125",
    c3: "-70.3125",
    c4: "-52.734375",
  },
  {
    "": "1819",
    time: "1637709681.0244687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-33.203125",
    c3: "-45.8984375",
    c4: "-19.53125",
  },
  {
    "": "1820",
    time: "1637709681.028375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-27.83203125",
    c3: "-67.87109375",
    c4: "13.18359375",
  },
  {
    "": "1821",
    time: "1637709681.0322812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-30.2734375",
    c3: "-104.98046875",
    c4: "-4.39453125",
  },
  {
    "": "1822",
    time: "1637709681.0361874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-32.71484375",
    c3: "-57.12890625",
    c4: "-25.87890625",
  },
  {
    "": "1823",
    time: "1637709681.0400937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-47.8515625",
    c3: "-17.08984375",
    c4: "-8.7890625",
  },
  {
    "": "1824",
    time: "1637709681.055125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-48.33984375",
    c3: "-38.57421875",
    c4: "-7.8125",
  },
  {
    "": "1825",
    time: "1637709681.0590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-23.92578125",
    c3: "-81.0546875",
    c4: "-17.578125",
  },
  {
    "": "1826",
    time: "1637709681.0629375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-40.52734375",
    c3: "-80.078125",
    c4: "-31.25",
  },
  {
    "": "1827",
    time: "1637709681.0668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-51.26953125",
    c3: "-50.78125",
    c4: "-18.06640625",
  },
  {
    "": "1828",
    time: "1637709681.07075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-25.87890625",
    c3: "-59.08203125",
    c4: "18.06640625",
  },
  {
    "": "1829",
    time: "1637709681.0746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-5.859375",
    c3: "-96.6796875",
    c4: "-3.41796875",
  },
  {
    "": "1830",
    time: "1637709681.0785625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-7.8125",
    c3: "-89.35546875",
    c4: "-56.640625",
  },
  {
    "": "1831",
    time: "1637709681.0824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-32.2265625",
    c3: "-71.77734375",
    c4: "-61.5234375",
  },
  {
    "": "1832",
    time: "1637709681.086375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-45.41015625",
    c3: "-70.80078125",
    c4: "-3.90625",
  },
  {
    "": "1833",
    time: "1637709681.0902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.4609375",
    c2: "-51.26953125",
    c3: "-92.7734375",
    c4: "12.20703125",
  },
  {
    "": "1834",
    time: "1637709681.0941875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-28.3203125",
    c3: "-74.70703125",
    c4: "-29.78515625",
  },
  {
    "": "1835",
    time: "1637709681.0980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-5.859375",
    c3: "-39.55078125",
    c4: "-51.26953125",
  },
  {
    "": "1836",
    time: "1637709681.100125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-9.765625",
    c3: "-57.12890625",
    c4: "-1.46484375",
  },
  {
    "": "1837",
    time: "1637709681.1040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-2.9296875",
    c3: "-27.83203125",
    c4: "46.875",
  },
  {
    "": "1838",
    time: "1637709681.1079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-34.1796875",
    c3: "-14.6484375",
    c4: "-20.01953125",
  },
  {
    "": "1839",
    time: "1637709681.1118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-54.6875",
    c3: "-63.4765625",
    c4: "-59.08203125",
  },
  {
    "": "1840",
    time: "1637709681.11575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-21.484375",
    c3: "-95.21484375",
    c4: "-18.06640625",
  },
  {
    "": "1841",
    time: "1637709681.1196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-17.08984375",
    c3: "-59.08203125",
    c4: "31.25",
  },
  {
    "": "1842",
    time: "1637709681.1235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-26.85546875",
    c3: "-58.59375",
    c4: "17.08984375",
  },
  {
    "": "1843",
    time: "1637709681.1274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-20.99609375",
    c3: "-96.6796875",
    c4: "-22.94921875",
  },
  {
    "": "1844",
    time: "1637709681.131375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-9.765625",
    c3: "-137.20703125",
    c4: "-22.94921875",
  },
  {
    "": "1845",
    time: "1637709681.1352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-33.69140625",
    c3: "-74.21875",
    c4: "-3.41796875",
  },
  {
    "": "1846",
    time: "1637709681.1391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-67.3828125",
    c3: "-33.69140625",
    c4: "-11.23046875",
  },
  {
    "": "1847",
    time: "1637709681.1430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-63.4765625",
    c3: "-85.44921875",
    c4: "-56.15234375",
  },
  {
    "": "1848",
    time: "1637709681.144125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-75.68359375",
    c3: "-79.1015625",
    c4: "-49.31640625",
  },
  {
    "": "1849",
    time: "1637709681.1480312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-56.15234375",
    c3: "-45.41015625",
    c4: "13.18359375",
  },
  {
    "": "1850",
    time: "1637709681.1519375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-24.90234375",
    c3: "-27.83203125",
    c4: "21.97265625",
  },
  {
    "": "1851",
    time: "1637709681.1558437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-47.36328125",
    c3: "-54.6875",
    c4: "-20.99609375",
  },
  {
    "": "1852",
    time: "1637709681.15975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-41.50390625",
    c3: "-88.37890625",
    c4: "-43.45703125",
  },
  {
    "": "1853",
    time: "1637709681.1636562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-23.92578125",
    c3: "-78.125",
    c4: "-19.04296875",
  },
  {
    "": "1854",
    time: "1637709681.1675625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-24.4140625",
    c3: "-67.3828125",
    c4: "6.8359375",
  },
  {
    "": "1855",
    time: "1637709681.1714687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-35.64453125",
    c3: "-105.95703125",
    c4: "-13.671875",
  },
  {
    "": "1856",
    time: "1637709681.175375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-32.71484375",
    c3: "-111.81640625",
    c4: "-36.1328125",
  },
  {
    "": "1857",
    time: "1637709681.1792812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-16.11328125",
    c3: "-37.109375",
    c4: "-18.5546875",
  },
  {
    "": "1858",
    time: "1637709681.1831875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-22.94921875",
    c3: "-45.8984375",
    c4: "27.83203125",
  },
  {
    "": "1859",
    time: "1637709681.1870937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-52.24609375",
    c3: "-89.35546875",
    c4: "9.27734375",
  },
  {
    "": "1860",
    time: "1637709681.190125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-69.3359375",
    c3: "-62.98828125",
    c4: "-32.2265625",
  },
  {
    "": "1861",
    time: "1637709681.1940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-60.546875",
    c3: "-41.015625",
    c4: "-31.25",
  },
  {
    "": "1862",
    time: "1637709681.1979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-39.0625",
    c3: "-43.9453125",
    c4: "-6.34765625",
  },
  {
    "": "1863",
    time: "1637709681.2018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-22.4609375",
    c3: "-46.875",
    c4: "-7.32421875",
  },
  {
    "": "1864",
    time: "1637709681.20575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-20.99609375",
    c3: "-49.31640625",
    c4: "-37.109375",
  },
  {
    "": "1865",
    time: "1637709681.2096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-25.390625",
    c3: "-52.734375",
    c4: "-40.52734375",
  },
  {
    "": "1866",
    time: "1637709681.2135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-5.37109375",
    c3: "-61.5234375",
    c4: "-7.32421875",
  },
  {
    "": "1867",
    time: "1637709681.2174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-12.20703125",
    c3: "-83.984375",
    c4: "20.5078125",
  },
  {
    "": "1868",
    time: "1637709681.221375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-58.59375",
    c3: "-56.640625",
    c4: "-15.13671875",
  },
  {
    "": "1869",
    time: "1637709681.2252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-57.12890625",
    c3: "-54.6875",
    c4: "-57.12890625",
  },
  {
    "": "1870",
    time: "1637709681.2291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-34.66796875",
    c3: "-64.94140625",
    c4: "-21.97265625",
  },
  {
    "": "1871",
    time: "1637709681.2330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-27.34375",
    c3: "-52.734375",
    c4: "8.30078125",
  },
  {
    "": "1872",
    time: "1637709681.234125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-49.31640625",
    c3: "-59.08203125",
    c4: "-25.390625",
  },
  {
    "": "1873",
    time: "1637709681.2380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-51.7578125",
    c3: "-56.15234375",
    c4: "-55.6640625",
  },
  {
    "": "1874",
    time: "1637709681.2419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-51.7578125",
    c3: "-75.1953125",
    c4: "-17.08984375",
  },
  {
    "": "1875",
    time: "1637709681.2458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.5078125",
    c2: "-76.66015625",
    c3: "-93.26171875",
    c4: "35.64453125",
  },
  {
    "": "1876",
    time: "1637709681.24975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-25.87890625",
    c3: "-71.77734375",
    c4: "16.11328125",
  },
  {
    "": "1877",
    time: "1637709681.2536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "9.765625",
    c3: "-45.8984375",
    c4: "-33.203125",
  },
  {
    "": "1878",
    time: "1637709681.2575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-3.90625",
    c3: "-83.0078125",
    c4: "-38.57421875",
  },
  {
    "": "1879",
    time: "1637709681.2614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-14.16015625",
    c3: "-93.75",
    c4: "12.20703125",
  },
  {
    "": "1880",
    time: "1637709681.265375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-27.34375",
    c3: "-51.26953125",
    c4: "7.8125",
  },
  {
    "": "1881",
    time: "1637709681.2692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-29.296875",
    c3: "-75.68359375",
    c4: "-39.0625",
  },
  {
    "": "1882",
    time: "1637709681.2731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-39.0625",
    c3: "-75.1953125",
    c4: "-50.29296875",
  },
  {
    "": "1883",
    time: "1637709681.2770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-49.31640625",
    c3: "-3.90625",
    c4: "-2.44140625",
  },
  {
    "": "1884",
    time: "1637709681.282125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-34.66796875",
    c3: "-21.97265625",
    c4: "14.6484375",
  },
  {
    "": "1885",
    time: "1637709681.2860312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-23.92578125",
    c3: "-79.58984375",
    c4: "-39.0625",
  },
  {
    "": "1886",
    time: "1637709681.2899375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-32.71484375",
    c3: "-41.50390625",
    c4: "-27.34375",
  },
  {
    "": "1887",
    time: "1637709681.2938437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-43.9453125",
    c3: "-35.15625",
    c4: "22.4609375",
  },
  {
    "": "1888",
    time: "1637709681.29775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-57.6171875",
    c3: "-55.17578125",
    c4: "21.97265625",
  },
  {
    "": "1889",
    time: "1637709681.3016562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-49.8046875",
    c3: "-60.05859375",
    c4: "-14.16015625",
  },
  {
    "": "1890",
    time: "1637709681.3055625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-41.50390625",
    c3: "-73.2421875",
    c4: "-40.52734375",
  },
  {
    "": "1891",
    time: "1637709681.3094687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-27.34375",
    c3: "-69.3359375",
    c4: "-23.4375",
  },
  {
    "": "1892",
    time: "1637709681.313375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-53.22265625",
    c3: "-55.17578125",
    c4: "0.0",
  },
  {
    "": "1893",
    time: "1637709681.3172812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-93.75",
    c3: "-101.07421875",
    c4: "-20.5078125",
  },
  {
    "": "1894",
    time: "1637709681.3211875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-49.8046875",
    c3: "-120.60546875",
    c4: "-21.97265625",
  },
  {
    "": "1895",
    time: "1637709681.3250937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-45.41015625",
    c3: "-71.2890625",
    c4: "10.7421875",
  },
  {
    "": "1896",
    time: "1637709681.339125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-52.24609375",
    c3: "-24.90234375",
    c4: "13.671875",
  },
  {
    "": "1897",
    time: "1637709681.3430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-18.5546875",
    c3: "-23.92578125",
    c4: "-19.04296875",
  },
  {
    "": "1898",
    time: "1637709681.3469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-9.27734375",
    c3: "-55.17578125",
    c4: "-57.12890625",
  },
  {
    "": "1899",
    time: "1637709681.3508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-31.25",
    c3: "-55.6640625",
    c4: "-46.875",
  },
  {
    "": "1900",
    time: "1637709681.35475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-45.8984375",
    c3: "-29.296875",
    c4: "12.20703125",
  },
  {
    "": "1901",
    time: "1637709681.3586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-37.109375",
    c3: "-93.75",
    c4: "23.4375",
  },
  {
    "": "1902",
    time: "1637709681.3625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-44.921875",
    c3: "-101.5625",
    c4: "-27.34375",
  },
  {
    "": "1903",
    time: "1637709681.3664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-46.38671875",
    c3: "-45.41015625",
    c4: "-31.73828125",
  },
  {
    "": "1904",
    time: "1637709681.370375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-58.59375",
    c3: "-61.5234375",
    c4: "7.8125",
  },
  {
    "": "1905",
    time: "1637709681.3742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-73.2421875",
    c3: "-24.90234375",
    c4: "4.39453125",
  },
  {
    "": "1906",
    time: "1637709681.3781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-54.6875",
    c3: "-25.87890625",
    c4: "-50.29296875",
  },
  {
    "": "1907",
    time: "1637709681.3820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-38.57421875",
    c3: "-60.546875",
    c4: "-76.171875",
  },
  {
    "": "1908",
    time: "1637709681.384125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-40.0390625",
    c3: "-74.21875",
    c4: "-32.2265625",
  },
  {
    "": "1909",
    time: "1637709681.3880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-44.43359375",
    c3: "-87.40234375",
    c4: "-7.32421875",
  },
  {
    "": "1910",
    time: "1637709681.3919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-35.15625",
    c3: "-70.80078125",
    c4: "-21.97265625",
  },
  {
    "": "1911",
    time: "1637709681.3958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-36.1328125",
    c3: "-41.015625",
    c4: "-42.96875",
  },
  {
    "": "1912",
    time: "1637709681.39975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-41.50390625",
    c3: "-48.33984375",
    c4: "-30.76171875",
  },
  {
    "": "1913",
    time: "1637709681.4036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-49.8046875",
    c3: "-44.43359375",
    c4: "1.46484375",
  },
  {
    "": "1914",
    time: "1637709681.4075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-46.875",
    c3: "-34.1796875",
    c4: "-12.6953125",
  },
  {
    "": "1915",
    time: "1637709681.4114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-42.48046875",
    c3: "-83.0078125",
    c4: "-48.33984375",
  },
  {
    "": "1916",
    time: "1637709681.415375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-53.22265625",
    c3: "-129.39453125",
    c4: "-28.3203125",
  },
  {
    "": "1917",
    time: "1637709681.4192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-41.015625",
    c3: "-98.14453125",
    c4: "30.2734375",
  },
  {
    "": "1918",
    time: "1637709681.4231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-37.59765625",
    c3: "-21.97265625",
    c4: "21.484375",
  },
  {
    "": "1919",
    time: "1637709681.4270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-40.0390625",
    c3: "-41.9921875",
    c4: "-35.64453125",
  },
  {
    "": "1920",
    time: "1637709681.429125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-25.87890625",
    c3: "-81.54296875",
    c4: "-45.8984375",
  },
  {
    "": "1921",
    time: "1637709681.4330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-21.484375",
    c3: "-60.05859375",
    c4: "0.0",
  },
  {
    "": "1922",
    time: "1637709681.4369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-23.92578125",
    c3: "-22.4609375",
    c4: "11.71875",
  },
  {
    "": "1923",
    time: "1637709681.4408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-41.9921875",
    c3: "-46.875",
    c4: "-23.4375",
  },
  {
    "": "1924",
    time: "1637709681.44475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-46.38671875",
    c3: "-97.16796875",
    c4: "-32.71484375",
  },
  {
    "": "1925",
    time: "1637709681.4486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-41.50390625",
    c3: "-64.453125",
    c4: "5.37109375",
  },
  {
    "": "1926",
    time: "1637709681.4525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-42.48046875",
    c3: "-20.99609375",
    c4: "34.1796875",
  },
  {
    "": "1927",
    time: "1637709681.4564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-36.1328125",
    c3: "-76.66015625",
    c4: "6.8359375",
  },
  {
    "": "1928",
    time: "1637709681.460375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-42.48046875",
    c3: "-125.0",
    c4: "-30.2734375",
  },
  {
    "": "1929",
    time: "1637709681.4642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-59.08203125",
    c3: "-65.4296875",
    c4: "-23.92578125",
  },
  {
    "": "1930",
    time: "1637709681.4681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-43.9453125",
    c3: "-39.0625",
    c4: "17.08984375",
  },
  {
    "": "1931",
    time: "1637709681.4720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-40.0390625",
    c3: "-68.359375",
    c4: "16.11328125",
  },
  {
    "": "1932",
    time: "1637709681.474125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-48.33984375",
    c3: "-55.17578125",
    c4: "-33.69140625",
  },
  {
    "": "1933",
    time: "1637709681.4780312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-31.25",
    c3: "-23.92578125",
    c4: "-44.921875",
  },
  {
    "": "1934",
    time: "1637709681.4819374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-17.578125",
    c3: "-36.1328125",
    c4: "13.671875",
  },
  {
    "": "1935",
    time: "1637709681.4858437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-44.43359375",
    c3: "-61.03515625",
    c4: "10.7421875",
  },
  {
    "": "1936",
    time: "1637709681.48975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-40.52734375",
    c3: "-32.71484375",
    c4: "-35.15625",
  },
  {
    "": "1937",
    time: "1637709681.4936562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-31.25",
    c3: "-46.38671875",
    c4: "-23.4375",
  },
  {
    "": "1938",
    time: "1637709681.4975624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-40.52734375",
    c3: "-62.98828125",
    c4: "8.7890625",
  },
  {
    "": "1939",
    time: "1637709681.5014687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-35.64453125",
    c3: "-83.49609375",
    c4: "34.1796875",
  },
  {
    "": "1940",
    time: "1637709681.505375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-19.53125",
    c3: "-73.2421875",
    c4: "7.32421875",
  },
  {
    "": "1941",
    time: "1637709681.5092812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-22.4609375",
    c3: "-29.296875",
    c4: "-28.3203125",
  },
  {
    "": "1942",
    time: "1637709681.5131874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-23.4375",
    c3: "-15.13671875",
    c4: "-13.671875",
  },
  {
    "": "1943",
    time: "1637709681.5170937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-29.78515625",
    c3: "-4.39453125",
    c4: "12.6953125",
  },
  {
    "": "1944",
    time: "1637709681.520125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-21.484375",
    c3: "-38.57421875",
    c4: "-8.7890625",
  },
  {
    "": "1945",
    time: "1637709681.5240312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-15.13671875",
    c3: "-69.82421875",
    c4: "-38.57421875",
  },
  {
    "": "1946",
    time: "1637709681.5279374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-11.23046875",
    c3: "-75.1953125",
    c4: "-16.11328125",
  },
  {
    "": "1947",
    time: "1637709681.5318437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-22.4609375",
    c3: "-99.12109375",
    c4: "29.78515625",
  },
  {
    "": "1948",
    time: "1637709681.53575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-52.734375",
    c3: "-41.9921875",
    c4: "20.01953125",
  },
  {
    "": "1949",
    time: "1637709681.5396562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-58.59375",
    c3: "-39.0625",
    c4: "-33.203125",
  },
  {
    "": "1950",
    time: "1637709681.5435624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-37.109375",
    c3: "-77.63671875",
    c4: "-30.76171875",
  },
  {
    "": "1951",
    time: "1637709681.5474687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-29.296875",
    c3: "-63.96484375",
    c4: "5.37109375",
  },
  {
    "": "1952",
    time: "1637709681.551375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-44.921875",
    c3: "-58.10546875",
    c4: "0.48828125",
  },
  {
    "": "1953",
    time: "1637709681.5552812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-55.6640625",
    c3: "-38.57421875",
    c4: "-18.06640625",
  },
  {
    "": "1954",
    time: "1637709681.5591874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-39.0625",
    c3: "-55.17578125",
    c4: "-13.671875",
  },
  {
    "": "1955",
    time: "1637709681.5630937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-28.3203125",
    c3: "-50.29296875",
    c4: "14.16015625",
  },
  {
    "": "1956",
    time: "1637709681.566125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.5078125",
    c2: "-45.8984375",
    c3: "10.7421875",
    c4: "15.625",
  },
  {
    "": "1957",
    time: "1637709681.5700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.20703125",
    c2: "-57.6171875",
    c3: "0.48828125",
    c4: "-15.625",
  },
  {
    "": "1958",
    time: "1637709681.5739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-41.50390625",
    c3: "-34.66796875",
    c4: "-31.25",
  },
  {
    "": "1959",
    time: "1637709681.5778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-16.11328125",
    c3: "-46.875",
    c4: "-7.32421875",
  },
  {
    "": "1960",
    time: "1637709681.58175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-9.765625",
    c3: "-60.05859375",
    c4: "35.64453125",
  },
  {
    "": "1961",
    time: "1637709681.5856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-14.16015625",
    c3: "-61.03515625",
    c4: "11.23046875",
  },
  {
    "": "1962",
    time: "1637709681.5895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-17.578125",
    c3: "-79.58984375",
    c4: "-21.97265625",
  },
  {
    "": "1963",
    time: "1637709681.5934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-29.296875",
    c3: "-78.125",
    c4: "1.46484375",
  },
  {
    "": "1964",
    time: "1637709681.597375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-44.921875",
    c3: "-29.78515625",
    c4: "38.0859375",
  },
  {
    "": "1965",
    time: "1637709681.6012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-41.015625",
    c3: "-60.05859375",
    c4: "34.1796875",
  },
  {
    "": "1966",
    time: "1637709681.6051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-35.15625",
    c3: "-126.46484375",
    c4: "-11.71875",
  },
  {
    "": "1967",
    time: "1637709681.6090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-52.24609375",
    c3: "-71.77734375",
    c4: "-33.203125",
  },
  {
    "": "1968",
    time: "1637709681.609125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-41.50390625",
    c3: "-13.671875",
    c4: "2.44140625",
  },
  {
    "": "1969",
    time: "1637709681.6130311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-18.5546875",
    c3: "-23.92578125",
    c4: "10.7421875",
  },
  {
    "": "1970",
    time: "1637709681.6169374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-25.390625",
    c3: "-34.1796875",
    c4: "-29.296875",
  },
  {
    "": "1971",
    time: "1637709681.6208436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-35.64453125",
    c3: "-41.9921875",
    c4: "-42.96875",
  },
  {
    "": "1972",
    time: "1637709681.62475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-55.17578125",
    c3: "-43.9453125",
    c4: "-7.8125",
  },
  {
    "": "1973",
    time: "1637709681.6286561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.6015625",
    c2: "-45.41015625",
    c3: "-69.82421875",
    c4: "31.73828125",
  },
  {
    "": "1974",
    time: "1637709681.6325624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-37.109375",
    c3: "-110.83984375",
    c4: "13.18359375",
  },
  {
    "": "1975",
    time: "1637709681.6364686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-41.9921875",
    c3: "-96.19140625",
    c4: "-17.08984375",
  },
  {
    "": "1976",
    time: "1637709681.640375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-25.87890625",
    c3: "-72.265625",
    c4: "0.48828125",
  },
  {
    "": "1977",
    time: "1637709681.6442811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-56.15234375",
    c3: "-48.33984375",
    c4: "50.29296875",
  },
  {
    "": "1978",
    time: "1637709681.6481874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-70.80078125",
    c3: "-19.04296875",
    c4: "16.11328125",
  },
  {
    "": "1979",
    time: "1637709681.6520936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-39.55078125",
    c3: "-4.8828125",
    c4: "-52.24609375",
  },
  {
    "": "1980",
    time: "1637709681.656125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-12.6953125",
    c3: "-15.13671875",
    c4: "-51.7578125",
  },
  {
    "": "1981",
    time: "1637709681.6600313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-10.7421875",
    c3: "-51.7578125",
    c4: "-5.859375",
  },
  {
    "": "1982",
    time: "1637709681.6639376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-16.11328125",
    c3: "-70.3125",
    c4: "6.8359375",
  },
  {
    "": "1983",
    time: "1637709681.6678438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-22.4609375",
    c3: "-56.15234375",
    c4: "-20.01953125",
  },
  {
    "": "1984",
    time: "1637709681.67175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-30.76171875",
    c3: "-62.98828125",
    c4: "-39.55078125",
  },
  {
    "": "1985",
    time: "1637709681.6756563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-24.4140625",
    c3: "-67.87109375",
    c4: "-1.953125",
  },
  {
    "": "1986",
    time: "1637709681.6795626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-23.92578125",
    c3: "-36.62109375",
    c4: "24.90234375",
  },
  {
    "": "1987",
    time: "1637709681.6834688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-50.29296875",
    c3: "-36.62109375",
    c4: "-24.90234375",
  },
  {
    "": "1988",
    time: "1637709681.687375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-48.828125",
    c3: "-42.48046875",
    c4: "-44.921875",
  },
  {
    "": "1989",
    time: "1637709681.6912813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-30.76171875",
    c3: "-84.9609375",
    c4: "-0.48828125",
  },
  {
    "": "1990",
    time: "1637709681.6951876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "25.390625",
    c2: "-50.78125",
    c3: "-94.7265625",
    c4: "23.4375",
  },
  {
    "": "1991",
    time: "1637709681.6990938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-52.734375",
    c3: "-22.94921875",
    c4: "-16.6015625",
  },
  {
    "": "1992",
    time: "1637709681.714125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-15.625",
    c3: "-36.62109375",
    c4: "-32.71484375",
  },
  {
    "": "1993",
    time: "1637709681.7180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-0.48828125",
    c3: "-106.4453125",
    c4: "0.9765625",
  },
  {
    "": "1994",
    time: "1637709681.7219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "1.46484375",
    c3: "-81.54296875",
    c4: "32.2265625",
  },
  {
    "": "1995",
    time: "1637709681.7258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-37.59765625",
    c3: "-73.2421875",
    c4: "-8.7890625",
  },
  {
    "": "1996",
    time: "1637709681.72975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-80.078125",
    c3: "-92.28515625",
    c4: "-48.828125",
  },
  {
    "": "1997",
    time: "1637709681.7336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-60.05859375",
    c3: "-97.65625",
    c4: "-15.625",
  },
  {
    "": "1998",
    time: "1637709681.7375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-31.73828125",
    c3: "-53.7109375",
    c4: "24.4140625",
  },
  {
    "": "1999",
    time: "1637709681.7414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-33.69140625",
    c3: "-18.06640625",
    c4: "12.20703125",
  },
  {
    "": "2000",
    time: "1637709681.745375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-55.6640625",
    c3: "-40.52734375",
    c4: "-25.390625",
  },
  {
    "": "2001",
    time: "1637709681.7492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-47.36328125",
    c3: "-58.59375",
    c4: "-30.2734375",
  },
  {
    "": "2002",
    time: "1637709681.7531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-32.71484375",
    c3: "-56.15234375",
    c4: "6.34765625",
  },
  {
    "": "2003",
    time: "1637709681.7570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-42.96875",
    c3: "-47.36328125",
    c4: "22.94921875",
  },
  {
    "": "2004",
    time: "1637709681.759125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-32.2265625",
    c3: "-41.9921875",
    c4: "-10.7421875",
  },
  {
    "": "2005",
    time: "1637709681.7630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-39.0625",
    c3: "-36.62109375",
    c4: "-48.33984375",
  },
  {
    "": "2006",
    time: "1637709681.7669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-53.7109375",
    c3: "-6.8359375",
    c4: "-23.92578125",
  },
  {
    "": "2007",
    time: "1637709681.7708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.20703125",
    c2: "-29.296875",
    c3: "-13.671875",
    c4: "23.4375",
  },
  {
    "": "2008",
    time: "1637709681.77475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-32.2265625",
    c3: "-92.7734375",
    c4: "16.6015625",
  },
  {
    "": "2009",
    time: "1637709681.7786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-65.91796875",
    c3: "-107.421875",
    c4: "-20.99609375",
  },
  {
    "": "2010",
    time: "1637709681.7825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-54.19921875",
    c3: "-48.33984375",
    c4: "-34.1796875",
  },
  {
    "": "2011",
    time: "1637709681.7864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-26.3671875",
    c3: "-25.87890625",
    c4: "5.859375",
  },
  {
    "": "2012",
    time: "1637709681.790375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-27.34375",
    c3: "-39.55078125",
    c4: "10.25390625",
  },
  {
    "": "2013",
    time: "1637709681.7942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-24.90234375",
    c3: "-37.59765625",
    c4: "-30.2734375",
  },
  {
    "": "2014",
    time: "1637709681.7981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-26.3671875",
    c3: "-7.8125",
    c4: "-43.45703125",
  },
  {
    "": "2015",
    time: "1637709681.8020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-37.59765625",
    c3: "-8.30078125",
    c4: "-0.9765625",
  },
  {
    "": "2016",
    time: "1637709681.804125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-43.45703125",
    c3: "-26.85546875",
    c4: "23.92578125",
  },
  {
    "": "2017",
    time: "1637709681.8080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-34.66796875",
    c3: "-45.41015625",
    c4: "7.32421875",
  },
  {
    "": "2018",
    time: "1637709681.8119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-19.53125",
    c3: "-50.78125",
    c4: "-6.34765625",
  },
  {
    "": "2019",
    time: "1637709681.8158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.99609375",
    c2: "-24.4140625",
    c3: "-36.1328125",
    c4: "5.859375",
  },
  {
    "": "2020",
    time: "1637709681.81975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.671875",
    c2: "-39.0625",
    c3: "-49.8046875",
    c4: "30.76171875",
  },
  {
    "": "2021",
    time: "1637709681.8236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-35.64453125",
    c3: "-37.109375",
    c4: "7.32421875",
  },
  {
    "": "2022",
    time: "1637709681.8275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-71.77734375",
    c3: "-24.90234375",
    c4: "-28.3203125",
  },
  {
    "": "2023",
    time: "1637709681.8314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-77.63671875",
    c3: "-38.57421875",
    c4: "-7.32421875",
  },
  {
    "": "2024",
    time: "1637709681.835375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-32.71484375",
    c3: "-50.29296875",
    c4: "41.50390625",
  },
  {
    "": "2025",
    time: "1637709681.8392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-12.6953125",
    c3: "-28.3203125",
    c4: "12.6953125",
  },
  {
    "": "2026",
    time: "1637709681.8431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-15.13671875",
    c3: "-34.66796875",
    c4: "-38.0859375",
  },
  {
    "": "2027",
    time: "1637709681.8470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-20.99609375",
    c3: "-30.2734375",
    c4: "-48.828125",
  },
  {
    "": "2028",
    time: "1637709681.850125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-32.2265625",
    c3: "-8.7890625",
    c4: "-15.13671875",
  },
  {
    "": "2029",
    time: "1637709681.8540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-54.6875",
    c3: "-40.52734375",
    c4: "-12.6953125",
  },
  {
    "": "2030",
    time: "1637709681.8579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-47.8515625",
    c3: "-60.546875",
    c4: "-52.734375",
  },
  {
    "": "2031",
    time: "1637709681.8618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-27.83203125",
    c3: "-49.31640625",
    c4: "-62.01171875",
  },
  {
    "": "2032",
    time: "1637709681.86575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-31.25",
    c3: "-26.85546875",
    c4: "-29.78515625",
  },
  {
    "": "2033",
    time: "1637709681.8696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-43.45703125",
    c3: "-3.90625",
    c4: "-12.20703125",
  },
  {
    "": "2034",
    time: "1637709681.8735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-38.0859375",
    c3: "-45.8984375",
    c4: "-32.2265625",
  },
  {
    "": "2035",
    time: "1637709681.8774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-40.0390625",
    c3: "-112.3046875",
    c4: "-32.2265625",
  },
  {
    "": "2036",
    time: "1637709681.881375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-43.45703125",
    c3: "-75.1953125",
    c4: "-2.9296875",
  },
  {
    "": "2037",
    time: "1637709681.8852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-45.41015625",
    c3: "24.90234375",
    c4: "7.32421875",
  },
  {
    "": "2038",
    time: "1637709681.8891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-39.55078125",
    c3: "5.37109375",
    c4: "-15.625",
  },
  {
    "": "2039",
    time: "1637709681.8930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-29.78515625",
    c3: "-53.7109375",
    c4: "-42.48046875",
  },
  {
    "": "2040",
    time: "1637709681.896125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-43.9453125",
    c3: "-37.59765625",
    c4: "-20.5078125",
  },
  {
    "": "2041",
    time: "1637709681.9000313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-56.640625",
    c3: "-8.7890625",
    c4: "21.97265625",
  },
  {
    "": "2042",
    time: "1637709681.9039376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-61.5234375",
    c3: "-8.30078125",
    c4: "-0.48828125",
  },
  {
    "": "2043",
    time: "1637709681.9078438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-39.55078125",
    c3: "-39.0625",
    c4: "-37.59765625",
  },
  {
    "": "2044",
    time: "1637709681.91175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-43.45703125",
    c3: "-27.34375",
    c4: "-32.2265625",
  },
  {
    "": "2045",
    time: "1637709681.9156563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-70.80078125",
    c3: "-24.4140625",
    c4: "-3.41796875",
  },
  {
    "": "2046",
    time: "1637709681.9195626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-37.59765625",
    c3: "-51.7578125",
    c4: "-0.48828125",
  },
  {
    "": "2047",
    time: "1637709681.9234688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-12.6953125",
    c3: "-94.23828125",
    c4: "-13.18359375",
  },
  {
    "": "2048",
    time: "1637709681.927375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-37.109375",
    c3: "-32.71484375",
    c4: "-29.78515625",
  },
  {
    "": "2049",
    time: "1637709681.9312813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-39.55078125",
    c3: "22.94921875",
    c4: "-10.7421875",
  },
  {
    "": "2050",
    time: "1637709681.9351876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-43.9453125",
    c3: "8.30078125",
    c4: "15.625",
  },
  {
    "": "2051",
    time: "1637709681.9390938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-28.80859375",
    c3: "-8.7890625",
    c4: "-21.484375",
  },
  {
    "": "2052",
    time: "1637709681.941125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-16.6015625",
    c3: "-34.1796875",
    c4: "-37.109375",
  },
  {
    "": "2053",
    time: "1637709681.9450312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-50.29296875",
    c3: "-48.33984375",
    c4: "1.46484375",
  },
  {
    "": "2054",
    time: "1637709681.9489374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-59.5703125",
    c3: "-30.2734375",
    c4: "27.83203125",
  },
  {
    "": "2055",
    time: "1637709681.9528437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-71.2890625",
    c3: "5.859375",
    c4: "0.48828125",
  },
  {
    "": "2056",
    time: "1637709681.95675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-63.4765625",
    c3: "1.953125",
    c4: "-37.59765625",
  },
  {
    "": "2057",
    time: "1637709681.9606562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-25.390625",
    c3: "-27.83203125",
    c4: "-25.87890625",
  },
  {
    "": "2058",
    time: "1637709681.9645624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-10.25390625",
    c3: "-62.01171875",
    c4: "6.34765625",
  },
  {
    "": "2059",
    time: "1637709681.9684687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-11.23046875",
    c3: "-50.29296875",
    c4: "5.37109375",
  },
  {
    "": "2060",
    time: "1637709681.972375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-28.80859375",
    c3: "-7.8125",
    c4: "-36.62109375",
  },
  {
    "": "2061",
    time: "1637709681.9762812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-29.296875",
    c3: "-21.97265625",
    c4: "-52.734375",
  },
  {
    "": "2062",
    time: "1637709681.9801874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-20.5078125",
    c3: "-32.71484375",
    c4: "-5.859375",
  },
  {
    "": "2063",
    time: "1637709681.9840937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-33.69140625",
    c3: "-21.484375",
    c4: "2.44140625",
  },
  {
    "": "2064",
    time: "1637709681.985125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-38.0859375",
    c3: "-25.87890625",
    c4: "-56.15234375",
  },
  {
    "": "2065",
    time: "1637709681.9890313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-52.24609375",
    c3: "-53.22265625",
    c4: "-64.453125",
  },
  {
    "": "2066",
    time: "1637709681.9929376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-52.24609375",
    c3: "-45.41015625",
    c4: "2.44140625",
  },
  {
    "": "2067",
    time: "1637709681.9968438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-50.29296875",
    c3: "-55.17578125",
    c4: "38.57421875",
  },
  {
    "": "2068",
    time: "1637709682.00075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-48.33984375",
    c3: "-78.125",
    c4: "14.6484375",
  },
  {
    "": "2069",
    time: "1637709682.0046563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-49.8046875",
    c3: "-53.7109375",
    c4: "-7.8125",
  },
  {
    "": "2070",
    time: "1637709682.0085626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-75.1953125",
    c3: "-79.58984375",
    c4: "32.2265625",
  },
  {
    "": "2071",
    time: "1637709682.0124688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-41.50390625",
    c3: "-36.1328125",
    c4: "52.24609375",
  },
  {
    "": "2072",
    time: "1637709682.016375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "5.37109375",
    c3: "15.13671875",
    c4: "-17.578125",
  },
  {
    "": "2073",
    time: "1637709682.0202813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-1.46484375",
    c3: "-52.734375",
    c4: "-55.6640625",
  },
  {
    "": "2074",
    time: "1637709682.0241876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-9.27734375",
    c3: "-49.31640625",
    c4: "-15.625",
  },
  {
    "": "2075",
    time: "1637709682.0280938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-9.765625",
    c3: "12.20703125",
    c4: "26.85546875",
  },
  {
    "": "2076",
    time: "1637709682.031125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-83.984375",
    c3: "15.625",
    c4: "25.87890625",
  },
  {
    "": "2077",
    time: "1637709682.0350313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-84.9609375",
    c3: "-29.296875",
    c4: "-5.859375",
  },
  {
    "": "2078",
    time: "1637709682.0389376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-18.5546875",
    c3: "-55.6640625",
    c4: "-28.80859375",
  },
  {
    "": "2079",
    time: "1637709682.0428438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-14.6484375",
    c3: "-36.62109375",
    c4: "8.7890625",
  },
  {
    "": "2080",
    time: "1637709682.04675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "1.953125",
    c3: "-26.85546875",
    c4: "21.484375",
  },
  {
    "": "2081",
    time: "1637709682.0506563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-4.39453125",
    c3: "-82.03125",
    c4: "-18.06640625",
  },
  {
    "": "2082",
    time: "1637709682.0545626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-33.69140625",
    c3: "-97.65625",
    c4: "-24.90234375",
  },
  {
    "": "2083",
    time: "1637709682.0584688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "-16.11328125",
    c3: "-16.6015625",
    c4: "14.16015625",
  },
  {
    "": "2084",
    time: "1637709682.062375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "19.04296875",
    c2: "-2.9296875",
    c3: "-5.37109375",
    c4: "36.1328125",
  },
  {
    "": "2085",
    time: "1637709682.0662813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-29.78515625",
    c3: "-34.66796875",
    c4: "0.48828125",
  },
  {
    "": "2086",
    time: "1637709682.0701876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-41.50390625",
    c3: "-24.4140625",
    c4: "-39.0625",
  },
  {
    "": "2087",
    time: "1637709682.0740938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-51.26953125",
    c3: "-20.01953125",
    c4: "-12.6953125",
  },
  {
    "": "2088",
    time: "1637709682.089125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-56.15234375",
    c3: "-19.04296875",
    c4: "29.296875",
  },
  {
    "": "2089",
    time: "1637709682.0930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-43.45703125",
    c3: "-27.34375",
    c4: "3.90625",
  },
  {
    "": "2090",
    time: "1637709682.0969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-26.3671875",
    c3: "-22.4609375",
    c4: "-23.92578125",
  },
  {
    "": "2091",
    time: "1637709682.1008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-12.6953125",
    c3: "-39.55078125",
    c4: "-7.8125",
  },
  {
    "": "2092",
    time: "1637709682.10475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-40.0390625",
    c3: "-53.22265625",
    c4: "19.04296875",
  },
  {
    "": "2093",
    time: "1637709682.1086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-41.50390625",
    c3: "-87.890625",
    c4: "25.390625",
  },
  {
    "": "2094",
    time: "1637709682.1125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-35.64453125",
    c3: "-84.47265625",
    c4: "-20.01953125",
  },
  {
    "": "2095",
    time: "1637709682.1164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-53.22265625",
    c3: "-26.85546875",
    c4: "-33.69140625",
  },
  {
    "": "2096",
    time: "1637709682.120375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-49.31640625",
    c3: "-30.76171875",
    c4: "1.46484375",
  },
  {
    "": "2097",
    time: "1637709682.1242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-18.06640625",
    c3: "-75.68359375",
    c4: "17.08984375",
  },
  {
    "": "2098",
    time: "1637709682.1281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-41.50390625",
    c3: "-44.921875",
    c4: "-29.296875",
  },
  {
    "": "2099",
    time: "1637709682.1320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-60.05859375",
    c3: "-4.8828125",
    c4: "-53.22265625",
  },
  {
    "": "2100",
    time: "1637709682.134125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-33.69140625",
    c3: "-40.0390625",
    c4: "-13.18359375",
  },
  {
    "": "2101",
    time: "1637709682.1380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-27.83203125",
    c3: "-98.6328125",
    c4: "14.16015625",
  },
  {
    "": "2102",
    time: "1637709682.1419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-46.38671875",
    c3: "-78.125",
    c4: "-3.90625",
  },
  {
    "": "2103",
    time: "1637709682.1458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-60.05859375",
    c3: "-22.94921875",
    c4: "-27.34375",
  },
  {
    "": "2104",
    time: "1637709682.14975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-41.9921875",
    c3: "-34.1796875",
    c4: "-17.578125",
  },
  {
    "": "2105",
    time: "1637709682.1536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-11.23046875",
    c3: "-52.734375",
    c4: "9.27734375",
  },
  {
    "": "2106",
    time: "1637709682.1575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-5.859375",
    c3: "-52.734375",
    c4: "-19.04296875",
  },
  {
    "": "2107",
    time: "1637709682.1614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-17.08984375",
    c3: "-39.0625",
    c4: "-58.10546875",
  },
  {
    "": "2108",
    time: "1637709682.165375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-37.59765625",
    c3: "-58.59375",
    c4: "-28.80859375",
  },
  {
    "": "2109",
    time: "1637709682.1692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-57.12890625",
    c3: "-62.01171875",
    c4: "3.41796875",
  },
  {
    "": "2110",
    time: "1637709682.1731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-53.22265625",
    c3: "-22.94921875",
    c4: "-7.32421875",
  },
  {
    "": "2111",
    time: "1637709682.1770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-37.59765625",
    c3: "-26.85546875",
    c4: "-46.38671875",
  },
  {
    "": "2112",
    time: "1637709682.179125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-39.55078125",
    c3: "-35.64453125",
    c4: "-55.17578125",
  },
  {
    "": "2113",
    time: "1637709682.1830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-14.16015625",
    c3: "-17.578125",
    c4: "-11.71875",
  },
  {
    "": "2114",
    time: "1637709682.1869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-27.34375",
    c3: "-29.296875",
    c4: "5.859375",
  },
  {
    "": "2115",
    time: "1637709682.1908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-62.01171875",
    c3: "-82.51953125",
    c4: "-27.83203125",
  },
  {
    "": "2116",
    time: "1637709682.19475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-41.9921875",
    c3: "-109.86328125",
    c4: "-30.76171875",
  },
  {
    "": "2117",
    time: "1637709682.1986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-27.34375",
    c3: "-63.96484375",
    c4: "-6.34765625",
  },
  {
    "": "2118",
    time: "1637709682.2025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.71875",
    c2: "-46.38671875",
    c3: "-25.390625",
    c4: "2.9296875",
  },
  {
    "": "2119",
    time: "1637709682.2064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-62.01171875",
    c3: "-18.06640625",
    c4: "-21.484375",
  },
  {
    "": "2120",
    time: "1637709682.210375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-40.0390625",
    c3: "-43.45703125",
    c4: "-36.1328125",
  },
  {
    "": "2121",
    time: "1637709682.2142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-33.203125",
    c3: "-0.48828125",
    c4: "-23.92578125",
  },
  {
    "": "2122",
    time: "1637709682.2181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-62.5",
    c3: "27.83203125",
    c4: "15.13671875",
  },
  {
    "": "2123",
    time: "1637709682.2220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-55.6640625",
    c3: "-1.953125",
    c4: "10.7421875",
  },
  {
    "": "2124",
    time: "1637709682.226125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-41.50390625",
    c3: "-45.8984375",
    c4: "-36.62109375",
  },
  {
    "": "2125",
    time: "1637709682.2300313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-18.06640625",
    c3: "-70.3125",
    c4: "-39.0625",
  },
  {
    "": "2126",
    time: "1637709682.2339375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-11.23046875",
    c3: "-19.04296875",
    c4: "-6.8359375",
  },
  {
    "": "2127",
    time: "1637709682.2378438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-19.04296875",
    c3: "4.39453125",
    c4: "-7.32421875",
  },
  {
    "": "2128",
    time: "1637709682.24175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-42.48046875",
    c3: "-13.671875",
    c4: "-54.19921875",
  },
  {
    "": "2129",
    time: "1637709682.2456563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-57.12890625",
    c3: "-58.10546875",
    c4: "-69.82421875",
  },
  {
    "": "2130",
    time: "1637709682.2495625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-37.109375",
    c3: "-79.58984375",
    c4: "-8.7890625",
  },
  {
    "": "2131",
    time: "1637709682.2534688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-29.78515625",
    c3: "-34.1796875",
    c4: "25.87890625",
  },
  {
    "": "2132",
    time: "1637709682.257375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-29.296875",
    c3: "-6.34765625",
    c4: "-10.7421875",
  },
  {
    "": "2133",
    time: "1637709682.2612813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-28.80859375",
    c3: "3.41796875",
    c4: "-44.43359375",
  },
  {
    "": "2134",
    time: "1637709682.2651875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-26.3671875",
    c3: "-14.6484375",
    c4: "-20.01953125",
  },
  {
    "": "2135",
    time: "1637709682.2690938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-41.015625",
    c3: "-33.203125",
    c4: "20.5078125",
  },
  {
    "": "2136",
    time: "1637709682.269125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-39.0625",
    c3: "-30.76171875",
    c4: "6.34765625",
  },
  {
    "": "2137",
    time: "1637709682.2730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-37.59765625",
    c3: "-22.94921875",
    c4: "-25.87890625",
  },
  {
    "": "2138",
    time: "1637709682.2769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-51.26953125",
    c3: "-26.3671875",
    c4: "-14.16015625",
  },
  {
    "": "2139",
    time: "1637709682.2808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-47.36328125",
    c3: "-31.73828125",
    c4: "29.78515625",
  },
  {
    "": "2140",
    time: "1637709682.28475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-23.4375",
    c3: "-41.50390625",
    c4: "10.25390625",
  },
  {
    "": "2141",
    time: "1637709682.2886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-20.01953125",
    c3: "-55.6640625",
    c4: "-22.4609375",
  },
  {
    "": "2142",
    time: "1637709682.2925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-35.64453125",
    c3: "-41.015625",
    c4: "-23.92578125",
  },
  {
    "": "2143",
    time: "1637709682.2964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-29.78515625",
    c3: "-65.91796875",
    c4: "1.953125",
  },
  {
    "": "2144",
    time: "1637709682.300375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-20.01953125",
    c3: "-27.83203125",
    c4: "9.27734375",
  },
  {
    "": "2145",
    time: "1637709682.3042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-18.06640625",
    c3: "19.53125",
    c4: "-43.9453125",
  },
  {
    "": "2146",
    time: "1637709682.3081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-24.4140625",
    c3: "-20.5078125",
    c4: "-56.640625",
  },
  {
    "": "2147",
    time: "1637709682.3120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-45.8984375",
    c3: "-21.484375",
    c4: "-9.765625",
  },
  {
    "": "2148",
    time: "1637709682.316125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-35.64453125",
    c3: "15.13671875",
    c4: "23.4375",
  },
  {
    "": "2149",
    time: "1637709682.3200312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-34.1796875",
    c3: "-13.18359375",
    c4: "-7.8125",
  },
  {
    "": "2150",
    time: "1637709682.3239374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-72.75390625",
    c3: "-51.7578125",
    c4: "-46.875",
  },
  {
    "": "2151",
    time: "1637709682.3278437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-59.08203125",
    c3: "14.6484375",
    c4: "-17.578125",
  },
  {
    "": "2152",
    time: "1637709682.33175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-33.69140625",
    c3: "13.671875",
    c4: "0.48828125",
  },
  {
    "": "2153",
    time: "1637709682.3356562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-13.671875",
    c3: "-55.17578125",
    c4: "-22.4609375",
  },
  {
    "": "2154",
    time: "1637709682.3395624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-19.04296875",
    c3: "-78.125",
    c4: "-27.34375",
  },
  {
    "": "2155",
    time: "1637709682.3434687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-39.55078125",
    c3: "-62.01171875",
    c4: "-11.23046875",
  },
  {
    "": "2156",
    time: "1637709682.347375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-15.625",
    c3: "-18.5546875",
    c4: "14.16015625",
  },
  {
    "": "2157",
    time: "1637709682.3512812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-6.34765625",
    c3: "-8.7890625",
    c4: "8.7890625",
  },
  {
    "": "2158",
    time: "1637709682.3551874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-15.13671875",
    c3: "-21.484375",
    c4: "-32.71484375",
  },
  {
    "": "2159",
    time: "1637709682.3590937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-40.0390625",
    c3: "-5.859375",
    c4: "-42.48046875",
  },
  {
    "": "2160",
    time: "1637709682.359125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-58.10546875",
    c3: "-15.13671875",
    c4: "-21.484375",
  },
  {
    "": "2161",
    time: "1637709682.3630311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-46.38671875",
    c3: "-44.921875",
    c4: "-2.9296875",
  },
  {
    "": "2162",
    time: "1637709682.3669374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-49.8046875",
    c3: "-43.45703125",
    c4: "-9.27734375",
  },
  {
    "": "2163",
    time: "1637709682.3708436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-60.05859375",
    c3: "-35.15625",
    c4: "-26.3671875",
  },
  {
    "": "2164",
    time: "1637709682.37475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-40.0390625",
    c3: "12.20703125",
    c4: "-5.37109375",
  },
  {
    "": "2165",
    time: "1637709682.3786561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-29.296875",
    c3: "15.13671875",
    c4: "24.4140625",
  },
  {
    "": "2166",
    time: "1637709682.3825624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-30.2734375",
    c3: "-61.03515625",
    c4: "1.46484375",
  },
  {
    "": "2167",
    time: "1637709682.3864686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-52.734375",
    c3: "-57.12890625",
    c4: "-37.59765625",
  },
  {
    "": "2168",
    time: "1637709682.390375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-55.6640625",
    c3: "-21.97265625",
    c4: "-16.11328125",
  },
  {
    "": "2169",
    time: "1637709682.3942811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-24.4140625",
    c3: "-10.25390625",
    c4: "23.4375",
  },
  {
    "": "2170",
    time: "1637709682.3981874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-19.53125",
    c3: "24.90234375",
    c4: "5.37109375",
  },
  {
    "": "2171",
    time: "1637709682.4020936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-58.10546875",
    c3: "14.6484375",
    c4: "-49.31640625",
  },
  {
    "": "2172",
    time: "1637709682.406125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-60.05859375",
    c3: "-10.7421875",
    c4: "-29.296875",
  },
  {
    "": "2173",
    time: "1637709682.4100313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-30.2734375",
    c3: "-4.8828125",
    c4: "29.78515625",
  },
  {
    "": "2174",
    time: "1637709682.4139376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-41.50390625",
    c3: "9.765625",
    c4: "2.44140625",
  },
  {
    "": "2175",
    time: "1637709682.4178438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-52.734375",
    c3: "-8.30078125",
    c4: "-47.36328125",
  },
  {
    "": "2176",
    time: "1637709682.42175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-36.1328125",
    c3: "-22.94921875",
    c4: "-40.0390625",
  },
  {
    "": "2177",
    time: "1637709682.4256563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-33.69140625",
    c3: "-44.921875",
    c4: "15.13671875",
  },
  {
    "": "2178",
    time: "1637709682.4295626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-17.578125",
    c3: "-37.59765625",
    c4: "22.94921875",
  },
  {
    "": "2179",
    time: "1637709682.4334688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-30.76171875",
    c3: "2.44140625",
    c4: "-20.01953125",
  },
  {
    "": "2180",
    time: "1637709682.437375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-54.19921875",
    c3: "-1.46484375",
    c4: "-32.71484375",
  },
  {
    "": "2181",
    time: "1637709682.4412813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-39.0625",
    c3: "-44.921875",
    c4: "-0.48828125",
  },
  {
    "": "2182",
    time: "1637709682.4451876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-43.45703125",
    c3: "-16.11328125",
    c4: "18.5546875",
  },
  {
    "": "2183",
    time: "1637709682.4490938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-66.89453125",
    c3: "21.484375",
    c4: "-9.27734375",
  },
  {
    "": "2184",
    time: "1637709682.464125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-60.05859375",
    c3: "-28.3203125",
    c4: "-38.0859375",
  },
  {
    "": "2185",
    time: "1637709682.4680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-38.0859375",
    c3: "-91.30859375",
    c4: "-13.671875",
  },
  {
    "": "2186",
    time: "1637709682.4719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-32.2265625",
    c3: "-71.77734375",
    c4: "19.04296875",
  },
  {
    "": "2187",
    time: "1637709682.4758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-35.64453125",
    c3: "-25.390625",
    c4: "10.25390625",
  },
  {
    "": "2188",
    time: "1637709682.47975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-39.55078125",
    c3: "-20.99609375",
    c4: "-28.3203125",
  },
  {
    "": "2189",
    time: "1637709682.4836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-43.9453125",
    c3: "-72.265625",
    c4: "-23.92578125",
  },
  {
    "": "2190",
    time: "1637709682.4875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-34.1796875",
    c3: "-30.76171875",
    c4: "7.32421875",
  },
  {
    "": "2191",
    time: "1637709682.4914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-44.43359375",
    c3: "5.37109375",
    c4: "-2.9296875",
  },
  {
    "": "2192",
    time: "1637709682.495375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-62.98828125",
    c3: "-52.734375",
    c4: "-24.90234375",
  },
  {
    "": "2193",
    time: "1637709682.4992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-51.26953125",
    c3: "-55.6640625",
    c4: "-20.01953125",
  },
  {
    "": "2194",
    time: "1637709682.5031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-42.48046875",
    c3: "-13.671875",
    c4: "4.8828125",
  },
  {
    "": "2195",
    time: "1637709682.5070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-41.015625",
    c3: "1.46484375",
    c4: "27.83203125",
  },
  {
    "": "2196",
    time: "1637709682.509125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-35.15625",
    c3: "-29.296875",
    c4: "-10.7421875",
  },
  {
    "": "2197",
    time: "1637709682.5130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-22.94921875",
    c3: "-41.015625",
    c4: "-34.66796875",
  },
  {
    "": "2198",
    time: "1637709682.5169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-51.26953125",
    c3: "-10.25390625",
    c4: "1.46484375",
  },
  {
    "": "2199",
    time: "1637709682.5208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-79.1015625",
    c3: "-12.6953125",
    c4: "18.5546875",
  },
  {
    "": "2200",
    time: "1637709682.52475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-45.8984375",
    c3: "-69.82421875",
    c4: "-0.9765625",
  },
  {
    "": "2201",
    time: "1637709682.5286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-23.4375",
    c3: "-90.33203125",
    c4: "-34.66796875",
  },
  {
    "": "2202",
    time: "1637709682.5325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-18.06640625",
    c3: "-42.96875",
    c4: "-26.85546875",
  },
  {
    "": "2203",
    time: "1637709682.5364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-29.78515625",
    c3: "-7.8125",
    c4: "18.06640625",
  },
  {
    "": "2204",
    time: "1637709682.540375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-59.5703125",
    c3: "-59.08203125",
    c4: "25.87890625",
  },
  {
    "": "2205",
    time: "1637709682.5442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-68.359375",
    c3: "-85.44921875",
    c4: "-26.3671875",
  },
  {
    "": "2206",
    time: "1637709682.5481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-63.4765625",
    c3: "-44.921875",
    c4: "-56.15234375",
  },
  {
    "": "2207",
    time: "1637709682.5520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-39.55078125",
    c3: "-15.13671875",
    c4: "4.39453125",
  },
  {
    "": "2208",
    time: "1637709682.554125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-16.6015625",
    c3: "-3.90625",
    c4: "32.71484375",
  },
  {
    "": "2209",
    time: "1637709682.5580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-20.5078125",
    c3: "-26.3671875",
    c4: "-18.06640625",
  },
  {
    "": "2210",
    time: "1637709682.5619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-38.57421875",
    c3: "-51.7578125",
    c4: "-34.66796875",
  },
  {
    "": "2211",
    time: "1637709682.5658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-49.31640625",
    c3: "-67.3828125",
    c4: "13.671875",
  },
  {
    "": "2212",
    time: "1637709682.56975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.6015625",
    c2: "-31.25",
    c3: "-75.1953125",
    c4: "53.7109375",
  },
  {
    "": "2213",
    time: "1637709682.5736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-24.4140625",
    c3: "-42.48046875",
    c4: "6.34765625",
  },
  {
    "": "2214",
    time: "1637709682.5775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-23.4375",
    c3: "-47.8515625",
    c4: "-13.671875",
  },
  {
    "": "2215",
    time: "1637709682.5814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-27.34375",
    c3: "-57.12890625",
    c4: "13.671875",
  },
  {
    "": "2216",
    time: "1637709682.585375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "19.04296875",
    c2: "-38.57421875",
    c3: "-39.55078125",
    c4: "28.3203125",
  },
  {
    "": "2217",
    time: "1637709682.5892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-30.76171875",
    c3: "-7.8125",
    c4: "15.625",
  },
  {
    "": "2218",
    time: "1637709682.5931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-54.6875",
    c3: "-20.5078125",
    c4: "-30.76171875",
  },
  {
    "": "2219",
    time: "1637709682.5970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-87.40234375",
    c3: "-43.9453125",
    c4: "-23.4375",
  },
  {
    "": "2220",
    time: "1637709682.600125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-40.52734375",
    c3: "-34.1796875",
    c4: "15.625",
  },
  {
    "": "2221",
    time: "1637709682.6040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-9.765625",
    c3: "-10.7421875",
    c4: "3.41796875",
  },
  {
    "": "2222",
    time: "1637709682.6079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-29.78515625",
    c3: "-20.01953125",
    c4: "-37.59765625",
  },
  {
    "": "2223",
    time: "1637709682.6118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-74.21875",
    c3: "-47.36328125",
    c4: "-39.55078125",
  },
  {
    "": "2224",
    time: "1637709682.61575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-55.6640625",
    c3: "-21.97265625",
    c4: "2.9296875",
  },
  {
    "": "2225",
    time: "1637709682.6196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.20703125",
    c2: "-12.6953125",
    c3: "-47.36328125",
    c4: "23.92578125",
  },
  {
    "": "2226",
    time: "1637709682.6235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-10.7421875",
    c3: "-56.15234375",
    c4: "-1.953125",
  },
  {
    "": "2227",
    time: "1637709682.6274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-6.34765625",
    c3: "-41.9921875",
    c4: "-24.90234375",
  },
  {
    "": "2228",
    time: "1637709682.631375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-8.30078125",
    c3: "-40.52734375",
    c4: "7.8125",
  },
  {
    "": "2229",
    time: "1637709682.6352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-24.90234375",
    c3: "-43.9453125",
    c4: "33.203125",
  },
  {
    "": "2230",
    time: "1637709682.6391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-52.24609375",
    c3: "-53.22265625",
    c4: "2.9296875",
  },
  {
    "": "2231",
    time: "1637709682.6430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-41.50390625",
    c3: "-49.31640625",
    c4: "-26.85546875",
  },
  {
    "": "2232",
    time: "1637709682.644125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-8.7890625",
    c3: "-27.34375",
    c4: "-18.06640625",
  },
  {
    "": "2233",
    time: "1637709682.6480312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-28.80859375",
    c3: "-5.859375",
    c4: "14.6484375",
  },
  {
    "": "2234",
    time: "1637709682.6519375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-41.015625",
    c3: "-14.6484375",
    c4: "5.859375",
  },
  {
    "": "2235",
    time: "1637709682.6558437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-31.73828125",
    c3: "-52.734375",
    c4: "-11.71875",
  },
  {
    "": "2236",
    time: "1637709682.65975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-39.0625",
    c3: "-61.5234375",
    c4: "-8.7890625",
  },
  {
    "": "2237",
    time: "1637709682.6636562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-28.3203125",
    c3: "-61.03515625",
    c4: "29.78515625",
  },
  {
    "": "2238",
    time: "1637709682.6675625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-4.39453125",
    c3: "-51.26953125",
    c4: "24.4140625",
  },
  {
    "": "2239",
    time: "1637709682.6714687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-9.27734375",
    c3: "-73.2421875",
    c4: "-9.765625",
  },
  {
    "": "2240",
    time: "1637709682.675375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-16.11328125",
    c3: "-55.6640625",
    c4: "-24.4140625",
  },
  {
    "": "2241",
    time: "1637709682.6792812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-26.3671875",
    c3: "-28.80859375",
    c4: "1.46484375",
  },
  {
    "": "2242",
    time: "1637709682.6831875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-56.640625",
    c3: "-29.78515625",
    c4: "27.34375",
  },
  {
    "": "2243",
    time: "1637709682.6870937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-43.9453125",
    c3: "-13.671875",
    c4: "-10.7421875",
  },
  {
    "": "2244",
    time: "1637709682.692125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-39.0625",
    c3: "-43.9453125",
    c4: "-32.2265625",
  },
  {
    "": "2245",
    time: "1637709682.6960313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-44.921875",
    c3: "-22.4609375",
    c4: "-0.9765625",
  },
  {
    "": "2246",
    time: "1637709682.6999376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.94921875",
    c2: "-37.109375",
    c3: "-9.27734375",
    c4: "22.4609375",
  },
  {
    "": "2247",
    time: "1637709682.7038438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-26.85546875",
    c3: "-13.18359375",
    c4: "-14.6484375",
  },
  {
    "": "2248",
    time: "1637709682.70775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-40.0390625",
    c3: "-1.953125",
    c4: "-43.9453125",
  },
  {
    "": "2249",
    time: "1637709682.7116563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-52.734375",
    c3: "-37.109375",
    c4: "-22.94921875",
  },
  {
    "": "2250",
    time: "1637709682.7155626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-14.16015625",
    c3: "-93.26171875",
    c4: "7.32421875",
  },
  {
    "": "2251",
    time: "1637709682.7194688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "7.32421875",
    c3: "-77.1484375",
    c4: "9.27734375",
  },
  {
    "": "2252",
    time: "1637709682.723375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "2.9296875",
    c3: "-25.87890625",
    c4: "-18.5546875",
  },
  {
    "": "2253",
    time: "1637709682.7272813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-12.20703125",
    c3: "-45.41015625",
    c4: "-30.76171875",
  },
  {
    "": "2254",
    time: "1637709682.7311876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-34.66796875",
    c3: "-43.45703125",
    c4: "17.08984375",
  },
  {
    "": "2255",
    time: "1637709682.7350938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-58.59375",
    c3: "-8.30078125",
    c4: "25.87890625",
  },
  {
    "": "2256",
    time: "1637709682.734125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-36.62109375",
    c3: "-22.94921875",
    c4: "-31.73828125",
  },
  {
    "": "2257",
    time: "1637709682.7380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-25.390625",
    c3: "-51.7578125",
    c4: "-56.640625",
  },
  {
    "": "2258",
    time: "1637709682.7419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-32.71484375",
    c3: "-62.5",
    c4: "3.90625",
  },
  {
    "": "2259",
    time: "1637709682.7458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-40.0390625",
    c3: "-32.71484375",
    c4: "27.34375",
  },
  {
    "": "2260",
    time: "1637709682.74975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-76.171875",
    c3: "-25.390625",
    c4: "-33.203125",
  },
  {
    "": "2261",
    time: "1637709682.7536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-58.10546875",
    c3: "-40.52734375",
    c4: "-54.19921875",
  },
  {
    "": "2262",
    time: "1637709682.7575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-37.109375",
    c3: "-103.02734375",
    c4: "-18.06640625",
  },
  {
    "": "2263",
    time: "1637709682.7614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-40.0390625",
    c3: "-93.75",
    c4: "22.4609375",
  },
  {
    "": "2264",
    time: "1637709682.765375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-16.6015625",
    c3: "-16.6015625",
    c4: "19.04296875",
  },
  {
    "": "2265",
    time: "1637709682.7692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-18.06640625",
    c3: "-22.4609375",
    c4: "-33.203125",
  },
  {
    "": "2266",
    time: "1637709682.7731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-35.15625",
    c3: "-27.83203125",
    c4: "-44.43359375",
  },
  {
    "": "2267",
    time: "1637709682.7770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-32.2265625",
    c3: "-5.37109375",
    c4: "18.06640625",
  },
  {
    "": "2268",
    time: "1637709682.781125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-73.2421875",
    c3: "-31.73828125",
    c4: "10.25390625",
  },
  {
    "": "2269",
    time: "1637709682.7850313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-77.1484375",
    c3: "-52.734375",
    c4: "-60.05859375",
  },
  {
    "": "2270",
    time: "1637709682.7889376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-16.6015625",
    c3: "-39.55078125",
    c4: "-73.73046875",
  },
  {
    "": "2271",
    time: "1637709682.7928438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-13.18359375",
    c3: "-35.15625",
    c4: "-8.7890625",
  },
  {
    "": "2272",
    time: "1637709682.79675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-46.875",
    c3: "-55.17578125",
    c4: "25.87890625",
  },
  {
    "": "2273",
    time: "1637709682.8006563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-28.3203125",
    c3: "-109.86328125",
    c4: "-15.625",
  },
  {
    "": "2274",
    time: "1637709682.8045626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-10.25390625",
    c3: "-122.55859375",
    c4: "-44.43359375",
  },
  {
    "": "2275",
    time: "1637709682.8084688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-30.76171875",
    c3: "-85.44921875",
    c4: "-4.39453125",
  },
  {
    "": "2276",
    time: "1637709682.812375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-20.01953125",
    c3: "-31.73828125",
    c4: "12.20703125",
  },
  {
    "": "2277",
    time: "1637709682.8162813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-31.25",
    c3: "-58.10546875",
    c4: "-22.94921875",
  },
  {
    "": "2278",
    time: "1637709682.8201876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-48.828125",
    c3: "-73.73046875",
    c4: "-39.0625",
  },
  {
    "": "2279",
    time: "1637709682.8240938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-41.015625",
    c3: "-20.5078125",
    c4: "-23.92578125",
  },
  {
    "": "2280",
    time: "1637709682.839125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-37.109375",
    c3: "-25.390625",
    c4: "20.99609375",
  },
  {
    "": "2281",
    time: "1637709682.8430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-41.50390625",
    c3: "-61.5234375",
    c4: "6.8359375",
  },
  {
    "": "2282",
    time: "1637709682.8469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-71.77734375",
    c3: "-61.5234375",
    c4: "-51.7578125",
  },
  {
    "": "2283",
    time: "1637709682.8508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-68.84765625",
    c3: "-51.26953125",
    c4: "-49.31640625",
  },
  {
    "": "2284",
    time: "1637709682.85475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-39.55078125",
    c3: "-37.109375",
    c4: "-13.671875",
  },
  {
    "": "2285",
    time: "1637709682.8586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-35.64453125",
    c3: "-81.0546875",
    c4: "-1.953125",
  },
  {
    "": "2286",
    time: "1637709682.8625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-41.50390625",
    c3: "-60.05859375",
    c4: "-22.94921875",
  },
  {
    "": "2287",
    time: "1637709682.8664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-49.31640625",
    c3: "-37.59765625",
    c4: "-41.9921875",
  },
  {
    "": "2288",
    time: "1637709682.870375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-52.734375",
    c3: "-86.9140625",
    c4: "-26.3671875",
  },
  {
    "": "2289",
    time: "1637709682.8742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-43.9453125",
    c3: "-38.0859375",
    c4: "8.30078125",
  },
  {
    "": "2290",
    time: "1637709682.8781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-34.1796875",
    c3: "-13.671875",
    c4: "-13.671875",
  },
  {
    "": "2291",
    time: "1637709682.8820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-47.8515625",
    c3: "-44.43359375",
    c4: "-54.6875",
  },
  {
    "": "2292",
    time: "1637709682.884125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-52.734375",
    c3: "-44.921875",
    c4: "-25.87890625",
  },
  {
    "": "2293",
    time: "1637709682.8880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-48.33984375",
    c3: "-40.0390625",
    c4: "14.6484375",
  },
  {
    "": "2294",
    time: "1637709682.8919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-66.89453125",
    c3: "-27.83203125",
    c4: "-12.20703125",
  },
  {
    "": "2295",
    time: "1637709682.8958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-62.5",
    c3: "-22.4609375",
    c4: "-28.80859375",
  },
  {
    "": "2296",
    time: "1637709682.89975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-55.17578125",
    c3: "-31.73828125",
    c4: "-16.11328125",
  },
  {
    "": "2297",
    time: "1637709682.9036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-53.22265625",
    c3: "-44.43359375",
    c4: "8.7890625",
  },
  {
    "": "2298",
    time: "1637709682.9075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-42.96875",
    c3: "-25.87890625",
    c4: "15.625",
  },
  {
    "": "2299",
    time: "1637709682.9114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-25.87890625",
    c3: "-13.671875",
    c4: "-19.04296875",
  },
  {
    "": "2300",
    time: "1637709682.915375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-23.92578125",
    c3: "-67.87109375",
    c4: "-21.484375",
  },
  {
    "": "2301",
    time: "1637709682.9192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-28.3203125",
    c3: "-57.12890625",
    c4: "22.4609375",
  },
  {
    "": "2302",
    time: "1637709682.9231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-2.9296875",
    c3: "-8.7890625",
    c4: "6.34765625",
  },
  {
    "": "2303",
    time: "1637709682.9270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-14.16015625",
    c3: "-9.27734375",
    c4: "-44.43359375",
  },
  {
    "": "2304",
    time: "1637709682.929125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-31.25",
    c3: "-40.0390625",
    c4: "-45.41015625",
  },
  {
    "": "2305",
    time: "1637709682.9330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-16.6015625",
    c3: "-29.78515625",
    c4: "-9.27734375",
  },
  {
    "": "2306",
    time: "1637709682.9369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-20.5078125",
    c3: "-16.11328125",
    c4: "-6.34765625",
  },
  {
    "": "2307",
    time: "1637709682.9408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-36.62109375",
    c3: "-53.7109375",
    c4: "-47.8515625",
  },
  {
    "": "2308",
    time: "1637709682.94475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-31.73828125",
    c3: "-92.7734375",
    c4: "-55.6640625",
  },
  {
    "": "2309",
    time: "1637709682.9486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-20.01953125",
    c3: "-78.125",
    c4: "-13.18359375",
  },
  {
    "": "2310",
    time: "1637709682.9525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-28.3203125",
    c3: "-54.6875",
    c4: "0.9765625",
  },
  {
    "": "2311",
    time: "1637709682.9564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-55.6640625",
    c3: "-35.64453125",
    c4: "-22.94921875",
  },
  {
    "": "2312",
    time: "1637709682.960375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-70.80078125",
    c3: "-36.1328125",
    c4: "-19.53125",
  },
  {
    "": "2313",
    time: "1637709682.9642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-45.41015625",
    c3: "-20.5078125",
    c4: "-16.6015625",
  },
  {
    "": "2314",
    time: "1637709682.9681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-3.41796875",
    c3: "-28.3203125",
    c4: "5.37109375",
  },
  {
    "": "2315",
    time: "1637709682.9720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-14.6484375",
    c3: "-42.96875",
    c4: "13.18359375",
  },
  {
    "": "2316",
    time: "1637709682.975125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-56.15234375",
    c3: "-28.3203125",
    c4: "-18.06640625",
  },
  {
    "": "2317",
    time: "1637709682.9790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-68.359375",
    c3: "-16.11328125",
    c4: "-23.92578125",
  },
  {
    "": "2318",
    time: "1637709682.9829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-36.1328125",
    c3: "-14.6484375",
    c4: "2.9296875",
  },
  {
    "": "2319",
    time: "1637709682.9868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-15.625",
    c3: "-40.0390625",
    c4: "22.4609375",
  },
  {
    "": "2320",
    time: "1637709682.99075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-31.73828125",
    c3: "-33.203125",
    c4: "-22.94921875",
  },
  {
    "": "2321",
    time: "1637709682.9946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-52.24609375",
    c3: "-28.3203125",
    c4: "-61.03515625",
  },
  {
    "": "2322",
    time: "1637709682.9985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-56.640625",
    c3: "-48.33984375",
    c4: "-30.76171875",
  },
  {
    "": "2323",
    time: "1637709683.0024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-34.66796875",
    c3: "-75.1953125",
    c4: "4.8828125",
  },
  {
    "": "2324",
    time: "1637709683.006375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-61.03515625",
    c3: "-58.59375",
    c4: "-3.41796875",
  },
  {
    "": "2325",
    time: "1637709683.0102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-78.125",
    c3: "-8.7890625",
    c4: "-30.76171875",
  },
  {
    "": "2326",
    time: "1637709683.0141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-23.92578125",
    c3: "-16.6015625",
    c4: "-29.296875",
  },
  {
    "": "2327",
    time: "1637709683.0180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-2.9296875",
    c3: "-70.80078125",
    c4: "10.25390625",
  },
  {
    "": "2328",
    time: "1637709683.021125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-37.59765625",
    c3: "-46.38671875",
    c4: "4.8828125",
  },
  {
    "": "2329",
    time: "1637709683.0250313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-31.73828125",
    c3: "2.44140625",
    c4: "-27.83203125",
  },
  {
    "": "2330",
    time: "1637709683.0289376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-15.625",
    c3: "-7.8125",
    c4: "-22.4609375",
  },
  {
    "": "2331",
    time: "1637709683.0328438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-38.0859375",
    c3: "-1.46484375",
    c4: "9.765625",
  },
  {
    "": "2332",
    time: "1637709683.03675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-46.875",
    c3: "-14.6484375",
    c4: "0.0",
  },
  {
    "": "2333",
    time: "1637709683.0406563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-37.59765625",
    c3: "-54.6875",
    c4: "-27.34375",
  },
  {
    "": "2334",
    time: "1637709683.0445626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-36.1328125",
    c3: "-62.98828125",
    c4: "-26.3671875",
  },
  {
    "": "2335",
    time: "1637709683.0484688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-25.390625",
    c3: "-83.0078125",
    c4: "18.06640625",
  },
  {
    "": "2336",
    time: "1637709683.052375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-18.06640625",
    c3: "-53.7109375",
    c4: "30.76171875",
  },
  {
    "": "2337",
    time: "1637709683.0562813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-44.921875",
    c3: "-22.94921875",
    c4: "-21.97265625",
  },
  {
    "": "2338",
    time: "1637709683.0601876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-30.2734375",
    c3: "-29.78515625",
    c4: "-50.29296875",
  },
  {
    "": "2339",
    time: "1637709683.0640938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-19.04296875",
    c3: "-38.0859375",
    c4: "-16.6015625",
  },
  {
    "": "2340",
    time: "1637709683.066125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-24.90234375",
    c3: "-58.10546875",
    c4: "13.671875",
  },
  {
    "": "2341",
    time: "1637709683.0700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-7.8125",
    c3: "-38.57421875",
    c4: "-22.4609375",
  },
  {
    "": "2342",
    time: "1637709683.0739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-15.13671875",
    c3: "-49.31640625",
    c4: "-48.828125",
  },
  {
    "": "2343",
    time: "1637709683.0778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-22.94921875",
    c3: "-55.6640625",
    c4: "-18.5546875",
  },
  {
    "": "2344",
    time: "1637709683.08175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-19.53125",
    c3: "-26.3671875",
    c4: "3.90625",
  },
  {
    "": "2345",
    time: "1637709683.0856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-37.109375",
    c3: "-22.4609375",
    c4: "-19.53125",
  },
  {
    "": "2346",
    time: "1637709683.0895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-42.48046875",
    c3: "-57.12890625",
    c4: "-50.78125",
  },
  {
    "": "2347",
    time: "1637709683.0934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-41.015625",
    c3: "-68.84765625",
    c4: "-38.57421875",
  },
  {
    "": "2348",
    time: "1637709683.097375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-42.96875",
    c3: "-25.87890625",
    c4: "4.8828125",
  },
  {
    "": "2349",
    time: "1637709683.1012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-52.24609375",
    c3: "-7.32421875",
    c4: "16.11328125",
  },
  {
    "": "2350",
    time: "1637709683.1051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-56.640625",
    c3: "-26.3671875",
    c4: "3.41796875",
  },
  {
    "": "2351",
    time: "1637709683.1090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-46.875",
    c3: "-34.66796875",
    c4: "-10.25390625",
  },
  {
    "": "2352",
    time: "1637709683.109125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "11.23046875",
    c3: "-23.92578125",
    c4: "14.6484375",
  },
  {
    "": "2353",
    time: "1637709683.1130311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "20.99609375",
    c3: "-36.1328125",
    c4: "29.78515625",
  },
  {
    "": "2354",
    time: "1637709683.1169374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-15.625",
    c3: "-35.15625",
    c4: "-22.94921875",
  },
  {
    "": "2355",
    time: "1637709683.1208436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-23.92578125",
    c3: "-22.4609375",
    c4: "-51.26953125",
  },
  {
    "": "2356",
    time: "1637709683.12475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-21.97265625",
    c3: "-19.53125",
    c4: "-3.41796875",
  },
  {
    "": "2357",
    time: "1637709683.1286561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-18.06640625",
    c3: "-35.64453125",
    c4: "43.9453125",
  },
  {
    "": "2358",
    time: "1637709683.1325624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-46.38671875",
    c3: "-64.453125",
    c4: "5.859375",
  },
  {
    "": "2359",
    time: "1637709683.1364686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-82.03125",
    c3: "-42.96875",
    c4: "-51.26953125",
  },
  {
    "": "2360",
    time: "1637709683.140375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-39.0625",
    c3: "-25.390625",
    c4: "-33.203125",
  },
  {
    "": "2361",
    time: "1637709683.1442811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.6484375",
    c2: "-17.578125",
    c3: "-11.23046875",
    c4: "25.87890625",
  },
  {
    "": "2362",
    time: "1637709683.1481874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "19.53125",
    c2: "-47.36328125",
    c3: "-4.39453125",
    c4: "11.23046875",
  },
  {
    "": "2363",
    time: "1637709683.1520936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-31.25",
    c3: "-45.41015625",
    c4: "-27.34375",
  },
  {
    "": "2364",
    time: "1637709683.157125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-25.87890625",
    c3: "-45.41015625",
    c4: "-35.15625",
  },
  {
    "": "2365",
    time: "1637709683.1610312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-36.62109375",
    c3: "-22.4609375",
    c4: "-0.48828125",
  },
  {
    "": "2366",
    time: "1637709683.1649375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-16.11328125",
    c3: "-23.4375",
    c4: "11.23046875",
  },
  {
    "": "2367",
    time: "1637709683.1688437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-19.04296875",
    c3: "-50.78125",
    c4: "-25.87890625",
  },
  {
    "": "2368",
    time: "1637709683.17275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-31.73828125",
    c3: "-55.17578125",
    c4: "-41.015625",
  },
  {
    "": "2369",
    time: "1637709683.1766562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-23.92578125",
    c3: "-43.45703125",
    c4: "-0.48828125",
  },
  {
    "": "2370",
    time: "1637709683.1805625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-32.2265625",
    c3: "-36.1328125",
    c4: "30.76171875",
  },
  {
    "": "2371",
    time: "1637709683.1844687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-42.48046875",
    c3: "-36.62109375",
    c4: "-20.01953125",
  },
  {
    "": "2372",
    time: "1637709683.188375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-37.59765625",
    c3: "-49.8046875",
    c4: "-49.31640625",
  },
  {
    "": "2373",
    time: "1637709683.1922812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-49.8046875",
    c3: "-47.8515625",
    c4: "-20.01953125",
  },
  {
    "": "2374",
    time: "1637709683.1961875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-58.10546875",
    c3: "-7.32421875",
    c4: "-4.8828125",
  },
  {
    "": "2375",
    time: "1637709683.2000937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-67.87109375",
    c3: "-4.39453125",
    c4: "-16.11328125",
  },
  {
    "": "2376",
    time: "1637709683.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-61.03515625",
    c3: "-35.15625",
    c4: "-27.83203125",
  },
  {
    "": "2377",
    time: "1637709683.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-32.2265625",
    c3: "-47.36328125",
    c4: "-13.671875",
  },
  {
    "": "2378",
    time: "1637709683.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-22.94921875",
    c3: "-40.0390625",
    c4: "19.53125",
  },
  {
    "": "2379",
    time: "1637709683.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-38.57421875",
    c3: "-46.38671875",
    c4: "5.37109375",
  },
  {
    "": "2380",
    time: "1637709683.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-41.50390625",
    c3: "-47.8515625",
    c4: "-48.33984375",
  },
  {
    "": "2381",
    time: "1637709683.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-42.48046875",
    c3: "-75.68359375",
    c4: "-25.87890625",
  },
  {
    "": "2382",
    time: "1637709683.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-38.57421875",
    c3: "-84.9609375",
    c4: "14.6484375",
  },
  {
    "": "2383",
    time: "1637709683.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-25.87890625",
    c3: "-11.23046875",
    c4: "4.8828125",
  },
  {
    "": "2384",
    time: "1637709683.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-21.97265625",
    c3: "-18.5546875",
    c4: "-20.01953125",
  },
  {
    "": "2385",
    time: "1637709683.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-34.66796875",
    c3: "-34.1796875",
    c4: "-33.203125",
  },
  {
    "": "2386",
    time: "1637709683.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-50.29296875",
    c3: "-9.765625",
    c4: "-2.44140625",
  },
  {
    "": "2387",
    time: "1637709683.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-49.8046875",
    c3: "-3.90625",
    c4: "21.484375",
  },
  {
    "": "2388",
    time: "1637709683.259125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-40.52734375",
    c3: "-10.7421875",
    c4: "-5.859375",
  },
  {
    "": "2389",
    time: "1637709683.2630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-20.01953125",
    c3: "-37.109375",
    c4: "-30.2734375",
  },
  {
    "": "2390",
    time: "1637709683.2669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "6.34765625",
    c3: "-55.17578125",
    c4: "-4.8828125",
  },
  {
    "": "2391",
    time: "1637709683.2708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-6.34765625",
    c3: "-24.4140625",
    c4: "16.6015625",
  },
  {
    "": "2392",
    time: "1637709683.27475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-28.80859375",
    c3: "-27.34375",
    c4: "-3.41796875",
  },
  {
    "": "2393",
    time: "1637709683.2786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-27.34375",
    c3: "-84.9609375",
    c4: "-27.34375",
  },
  {
    "": "2394",
    time: "1637709683.2825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-26.3671875",
    c3: "-61.5234375",
    c4: "-27.34375",
  },
  {
    "": "2395",
    time: "1637709683.2864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-42.96875",
    c3: "-13.671875",
    c4: "18.5546875",
  },
  {
    "": "2396",
    time: "1637709683.290375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-51.26953125",
    c3: "-57.12890625",
    c4: "17.578125",
  },
  {
    "": "2397",
    time: "1637709683.2942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-48.828125",
    c3: "-74.21875",
    c4: "-25.87890625",
  },
  {
    "": "2398",
    time: "1637709683.2981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-47.8515625",
    c3: "-22.94921875",
    c4: "-41.50390625",
  },
  {
    "": "2399",
    time: "1637709683.3020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-62.5",
    c3: "10.25390625",
    c4: "-7.8125",
  },
  {
    "": "2400",
    time: "1637709683.304125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "13.18359375",
    c2: "-66.40625",
    c3: "-14.6484375",
    c4: "24.90234375",
  },
  {
    "": "2401",
    time: "1637709683.3080313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-19.04296875",
    c3: "-38.0859375",
    c4: "-12.20703125",
  },
  {
    "": "2402",
    time: "1637709683.3119376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "1.46484375",
    c3: "-34.1796875",
    c4: "-39.0625",
  },
  {
    "": "2403",
    time: "1637709683.3158438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-17.08984375",
    c3: "-49.31640625",
    c4: "-0.9765625",
  },
  {
    "": "2404",
    time: "1637709683.31975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-31.25",
    c3: "-69.3359375",
    c4: "39.0625",
  },
  {
    "": "2405",
    time: "1637709683.3236563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-25.87890625",
    c3: "-48.33984375",
    c4: "7.32421875",
  },
  {
    "": "2406",
    time: "1637709683.3275626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-35.64453125",
    c3: "-18.5546875",
    c4: "-39.0625",
  },
  {
    "": "2407",
    time: "1637709683.3314688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-44.921875",
    c3: "-7.8125",
    c4: "-24.4140625",
  },
  {
    "": "2408",
    time: "1637709683.335375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-41.9921875",
    c3: "-53.22265625",
    c4: "17.08984375",
  },
  {
    "": "2409",
    time: "1637709683.3392813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-40.0390625",
    c3: "-46.38671875",
    c4: "12.20703125",
  },
  {
    "": "2410",
    time: "1637709683.3431876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-38.0859375",
    c3: "-28.3203125",
    c4: "-28.80859375",
  },
  {
    "": "2411",
    time: "1637709683.3470938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-45.8984375",
    c3: "-56.15234375",
    c4: "-36.62109375",
  },
  {
    "": "2412",
    time: "1637709683.349125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-33.69140625",
    c3: "-33.69140625",
    c4: "14.16015625",
  },
  {
    "": "2413",
    time: "1637709683.3530312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-33.69140625",
    c3: "-13.671875",
    c4: "20.01953125",
  },
  {
    "": "2414",
    time: "1637709683.3569374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-64.453125",
    c3: "-30.2734375",
    c4: "-23.4375",
  },
  {
    "": "2415",
    time: "1637709683.3608437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-46.875",
    c3: "-28.3203125",
    c4: "-38.0859375",
  },
  {
    "": "2416",
    time: "1637709683.36475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-31.25",
    c3: "-27.34375",
    c4: "-12.20703125",
  },
  {
    "": "2417",
    time: "1637709683.3686562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-21.484375",
    c3: "-34.1796875",
    c4: "10.25390625",
  },
  {
    "": "2418",
    time: "1637709683.3725624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-19.04296875",
    c3: "-24.4140625",
    c4: "-21.484375",
  },
  {
    "": "2419",
    time: "1637709683.3764687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-37.109375",
    c3: "-44.43359375",
    c4: "-37.59765625",
  },
  {
    "": "2420",
    time: "1637709683.380375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-41.50390625",
    c3: "-26.85546875",
    c4: "-10.7421875",
  },
  {
    "": "2421",
    time: "1637709683.3842812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-29.78515625",
    c3: "28.3203125",
    c4: "1.46484375",
  },
  {
    "": "2422",
    time: "1637709683.3881874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-57.6171875",
    c3: "-19.53125",
    c4: "-29.296875",
  },
  {
    "": "2423",
    time: "1637709683.3920937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-64.453125",
    c3: "-93.75",
    c4: "-55.6640625",
  },
  {
    "": "2424",
    time: "1637709683.395125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-32.71484375",
    c3: "-56.640625",
    c4: "-30.76171875",
  },
  {
    "": "2425",
    time: "1637709683.3990312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-30.76171875",
    c3: "16.11328125",
    c4: "1.953125",
  },
  {
    "": "2426",
    time: "1637709683.4029374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-27.34375",
    c3: "-12.20703125",
    c4: "-9.27734375",
  },
  {
    "": "2427",
    time: "1637709683.4068437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-31.25",
    c3: "-95.21484375",
    c4: "-31.25",
  },
  {
    "": "2428",
    time: "1637709683.41075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-36.1328125",
    c3: "-36.62109375",
    c4: "-31.25",
  },
  {
    "": "2429",
    time: "1637709683.4146562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-21.97265625",
    c3: "0.0",
    c4: "6.34765625",
  },
  {
    "": "2430",
    time: "1637709683.4185624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-17.08984375",
    c3: "-16.6015625",
    c4: "28.80859375",
  },
  {
    "": "2431",
    time: "1637709683.4224687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-57.12890625",
    c3: "-41.015625",
    c4: "-12.6953125",
  },
  {
    "": "2432",
    time: "1637709683.426375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-54.6875",
    c3: "-32.2265625",
    c4: "-42.48046875",
  },
  {
    "": "2433",
    time: "1637709683.4302812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-29.78515625",
    c3: "-8.30078125",
    c4: "-10.25390625",
  },
  {
    "": "2434",
    time: "1637709683.4341874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-30.76171875",
    c3: "-20.5078125",
    c4: "36.62109375",
  },
  {
    "": "2435",
    time: "1637709683.4380937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-21.97265625",
    c3: "-6.8359375",
    c4: "0.0",
  },
  {
    "": "2436",
    time: "1637709683.441125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-35.64453125",
    c3: "-31.25",
    c4: "-38.0859375",
  },
  {
    "": "2437",
    time: "1637709683.4450312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-30.2734375",
    c3: "-37.59765625",
    c4: "-6.8359375",
  },
  {
    "": "2438",
    time: "1637709683.4489374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-19.04296875",
    c3: "-13.18359375",
    c4: "18.06640625",
  },
  {
    "": "2439",
    time: "1637709683.4528437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-29.296875",
    c3: "-15.625",
    c4: "-1.953125",
  },
  {
    "": "2440",
    time: "1637709683.45675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-79.1015625",
    c3: "-11.71875",
    c4: "-35.15625",
  },
  {
    "": "2441",
    time: "1637709683.4606562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-95.703125",
    c3: "-15.625",
    c4: "-26.3671875",
  },
  {
    "": "2442",
    time: "1637709683.4645624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-38.0859375",
    c3: "-44.43359375",
    c4: "31.73828125",
  },
  {
    "": "2443",
    time: "1637709683.4684687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-14.6484375",
    c3: "-83.0078125",
    c4: "20.5078125",
  },
  {
    "": "2444",
    time: "1637709683.472375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-38.57421875",
    c3: "-20.01953125",
    c4: "-57.12890625",
  },
  {
    "": "2445",
    time: "1637709683.4762812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-48.828125",
    c3: "-24.4140625",
    c4: "-51.7578125",
  },
  {
    "": "2446",
    time: "1637709683.4801874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-54.6875",
    c3: "-73.73046875",
    c4: "6.34765625",
  },
  {
    "": "2447",
    time: "1637709683.4840937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-25.390625",
    c3: "-25.390625",
    c4: "2.9296875",
  },
  {
    "": "2448",
    time: "1637709683.484125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-16.6015625",
    c3: "-15.625",
    c4: "-34.1796875",
  },
  {
    "": "2449",
    time: "1637709683.4880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-42.48046875",
    c3: "-60.546875",
    c4: "-42.96875",
  },
  {
    "": "2450",
    time: "1637709683.4919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-38.0859375",
    c3: "-77.63671875",
    c4: "0.48828125",
  },
  {
    "": "2451",
    time: "1637709683.4958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-42.96875",
    c3: "-23.92578125",
    c4: "30.76171875",
  },
  {
    "": "2452",
    time: "1637709683.49975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-32.71484375",
    c3: "12.20703125",
    c4: "-7.32421875",
  },
  {
    "": "2453",
    time: "1637709683.5036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-27.34375",
    c3: "-30.2734375",
    c4: "-35.15625",
  },
  {
    "": "2454",
    time: "1637709683.5075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-52.734375",
    c3: "-77.63671875",
    c4: "-8.7890625",
  },
  {
    "": "2455",
    time: "1637709683.5114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-41.50390625",
    c3: "-62.5",
    c4: "14.16015625",
  },
  {
    "": "2456",
    time: "1637709683.515375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-41.9921875",
    c3: "-2.9296875",
    c4: "-12.20703125",
  },
  {
    "": "2457",
    time: "1637709683.5192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-69.82421875",
    c3: "-20.99609375",
    c4: "-49.31640625",
  },
  {
    "": "2458",
    time: "1637709683.5231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-40.0390625",
    c3: "-76.66015625",
    c4: "-41.9921875",
  },
  {
    "": "2459",
    time: "1637709683.5270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-23.92578125",
    c3: "-43.45703125",
    c4: "4.39453125",
  },
  {
    "": "2460",
    time: "1637709683.531125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-35.15625",
    c3: "0.0",
    c4: "-4.8828125",
  },
  {
    "": "2461",
    time: "1637709683.5350313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-13.671875",
    c3: "-19.53125",
    c4: "-38.57421875",
  },
  {
    "": "2462",
    time: "1637709683.5389376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-19.53125",
    c3: "-54.19921875",
    c4: "-36.1328125",
  },
  {
    "": "2463",
    time: "1637709683.5428438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-31.73828125",
    c3: "-17.08984375",
    c4: "9.765625",
  },
  {
    "": "2464",
    time: "1637709683.54675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-38.57421875",
    c3: "19.53125",
    c4: "26.3671875",
  },
  {
    "": "2465",
    time: "1637709683.5506563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-49.8046875",
    c3: "-20.99609375",
    c4: "-10.7421875",
  },
  {
    "": "2466",
    time: "1637709683.5545626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-59.08203125",
    c3: "-37.109375",
    c4: "-27.34375",
  },
  {
    "": "2467",
    time: "1637709683.5584688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-49.8046875",
    c3: "-10.25390625",
    c4: "5.37109375",
  },
  {
    "": "2468",
    time: "1637709683.562375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-41.50390625",
    c3: "-14.16015625",
    c4: "32.2265625",
  },
  {
    "": "2469",
    time: "1637709683.5662813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-68.359375",
    c3: "-55.6640625",
    c4: "21.97265625",
  },
  {
    "": "2470",
    time: "1637709683.5701876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-55.17578125",
    c3: "-41.015625",
    c4: "-24.4140625",
  },
  {
    "": "2471",
    time: "1637709683.5740938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-36.1328125",
    c3: "-22.4609375",
    c4: "-28.3203125",
  },
  {
    "": "2472",
    time: "1637709683.589125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-55.17578125",
    c3: "-26.85546875",
    c4: "17.08984375",
  },
  {
    "": "2473",
    time: "1637709683.5930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-25.390625",
    c3: "-27.83203125",
    c4: "2.9296875",
  },
  {
    "": "2474",
    time: "1637709683.5969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-4.8828125",
    c3: "-47.8515625",
    c4: "-38.57421875",
  },
  {
    "": "2475",
    time: "1637709683.6008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-14.6484375",
    c3: "-58.10546875",
    c4: "-23.4375",
  },
  {
    "": "2476",
    time: "1637709683.60475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-27.34375",
    c3: "-38.57421875",
    c4: "5.37109375",
  },
  {
    "": "2477",
    time: "1637709683.6086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-43.45703125",
    c3: "-52.24609375",
    c4: "3.90625",
  },
  {
    "": "2478",
    time: "1637709683.6125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-35.15625",
    c3: "-36.62109375",
    c4: "-22.94921875",
  },
  {
    "": "2479",
    time: "1637709683.6164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-24.4140625",
    c3: "-6.34765625",
    c4: "-34.66796875",
  },
  {
    "": "2480",
    time: "1637709683.620375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-32.2265625",
    c3: "-10.7421875",
    c4: "7.8125",
  },
  {
    "": "2481",
    time: "1637709683.6242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-32.71484375",
    c3: "-8.7890625",
    c4: "33.69140625",
  },
  {
    "": "2482",
    time: "1637709683.6281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-11.23046875",
    c3: "-4.8828125",
    c4: "-17.08984375",
  },
  {
    "": "2483",
    time: "1637709683.6320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-34.66796875",
    c3: "-22.4609375",
    c4: "-36.1328125",
  },
  {
    "": "2484",
    time: "1637709683.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-55.17578125",
    c3: "-29.78515625",
    c4: "4.39453125",
  },
  {
    "": "2485",
    time: "1637709683.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-36.1328125",
    c3: "-0.48828125",
    c4: "27.83203125",
  },
  {
    "": "2486",
    time: "1637709683.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-22.94921875",
    c3: "5.37109375",
    c4: "-5.37109375",
  },
  {
    "": "2487",
    time: "1637709683.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-27.83203125",
    c3: "-18.06640625",
    c4: "-46.875",
  },
  {
    "": "2488",
    time: "1637709683.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-9.765625",
    c3: "-34.1796875",
    c4: "-22.4609375",
  },
  {
    "": "2489",
    time: "1637709683.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.578125",
    c2: "10.25390625",
    c3: "-27.83203125",
    c4: "22.4609375",
  },
  {
    "": "2490",
    time: "1637709683.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-13.18359375",
    c3: "-33.203125",
    c4: "-3.90625",
  },
  {
    "": "2491",
    time: "1637709683.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-20.99609375",
    c3: "-27.34375",
    c4: "-41.50390625",
  },
  {
    "": "2492",
    time: "1637709683.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-13.18359375",
    c3: "-37.59765625",
    c4: "-21.97265625",
  },
  {
    "": "2493",
    time: "1637709683.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-25.390625",
    c3: "-21.484375",
    c4: "2.44140625",
  },
  {
    "": "2494",
    time: "1637709683.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-65.91796875",
    c3: "14.6484375",
    c4: "3.90625",
  },
  {
    "": "2495",
    time: "1637709683.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-57.12890625",
    c3: "-12.6953125",
    c4: "-13.671875",
  },
  {
    "": "2496",
    time: "1637709683.679125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-18.5546875",
    c3: "-39.55078125",
    c4: "-33.69140625",
  },
  {
    "": "2497",
    time: "1637709683.6830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-17.08984375",
    c3: "-16.6015625",
    c4: "-7.8125",
  },
  {
    "": "2498",
    time: "1637709683.6869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-33.69140625",
    c3: "-26.3671875",
    c4: "18.06640625",
  },
  {
    "": "2499",
    time: "1637709683.6908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-33.203125",
    c3: "-72.75390625",
    c4: "-12.20703125",
  },
  {
    "": "2500",
    time: "1637709683.69475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-40.52734375",
    c3: "-62.01171875",
    c4: "-29.78515625",
  },
  {
    "": "2501",
    time: "1637709683.6986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-32.71484375",
    c3: "-22.4609375",
    c4: "-14.6484375",
  },
  {
    "": "2502",
    time: "1637709683.7025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-30.2734375",
    c3: "0.0",
    c4: "1.953125",
  },
  {
    "": "2503",
    time: "1637709683.7064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-57.6171875",
    c3: "-19.04296875",
    c4: "-23.4375",
  },
  {
    "": "2504",
    time: "1637709683.710375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-43.45703125",
    c3: "-41.9921875",
    c4: "-53.22265625",
  },
  {
    "": "2505",
    time: "1637709683.7142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-38.0859375",
    c3: "-4.39453125",
    c4: "-33.69140625",
  },
  {
    "": "2506",
    time: "1637709683.7181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-58.10546875",
    c3: "7.8125",
    c4: "9.27734375",
  },
  {
    "": "2507",
    time: "1637709683.7220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-20.01953125",
    c3: "-5.37109375",
    c4: "16.11328125",
  },
  {
    "": "2508",
    time: "1637709683.725125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-7.32421875",
    c3: "-26.85546875",
    c4: "-15.625",
  },
  {
    "": "2509",
    time: "1637709683.7290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-23.92578125",
    c3: "-41.9921875",
    c4: "-44.921875",
  },
  {
    "": "2510",
    time: "1637709683.7329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-10.25390625",
    c3: "-50.29296875",
    c4: "-13.671875",
  },
  {
    "": "2511",
    time: "1637709683.7368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-20.01953125",
    c3: "-53.22265625",
    c4: "9.765625",
  },
  {
    "": "2512",
    time: "1637709683.74075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-24.90234375",
    c3: "-25.390625",
    c4: "-23.92578125",
  },
  {
    "": "2513",
    time: "1637709683.7446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-29.78515625",
    c3: "-26.85546875",
    c4: "-31.73828125",
  },
  {
    "": "2514",
    time: "1637709683.7485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-41.015625",
    c3: "-11.23046875",
    c4: "5.859375",
  },
  {
    "": "2515",
    time: "1637709683.7524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-47.36328125",
    c3: "-49.8046875",
    c4: "29.296875",
  },
  {
    "": "2516",
    time: "1637709683.756375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-48.828125",
    c3: "-60.05859375",
    c4: "13.671875",
  },
  {
    "": "2517",
    time: "1637709683.7602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-25.390625",
    c3: "17.08984375",
    c4: "-41.015625",
  },
  {
    "": "2518",
    time: "1637709683.7641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-19.53125",
    c3: "-2.9296875",
    c4: "-29.78515625",
  },
  {
    "": "2519",
    time: "1637709683.7680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-43.45703125",
    c3: "-29.296875",
    c4: "26.85546875",
  },
  {
    "": "2520",
    time: "1637709683.769125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-71.77734375",
    c3: "-7.8125",
    c4: "5.859375",
  },
  {
    "": "2521",
    time: "1637709683.7730312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-48.33984375",
    c3: "-39.0625",
    c4: "-26.85546875",
  },
  {
    "": "2522",
    time: "1637709683.7769375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "2.9296875",
    c3: "-52.24609375",
    c4: "-11.23046875",
  },
  {
    "": "2523",
    time: "1637709683.7808437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "16.6015625",
    c3: "-23.4375",
    c4: "37.59765625",
  },
  {
    "": "2524",
    time: "1637709683.78475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.6015625",
    c2: "-11.71875",
    c3: "20.5078125",
    c4: "24.90234375",
  },
  {
    "": "2525",
    time: "1637709683.7886562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-41.015625",
    c3: "3.90625",
    c4: "-17.08984375",
  },
  {
    "": "2526",
    time: "1637709683.7925625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-52.24609375",
    c3: "-61.5234375",
    c4: "-17.578125",
  },
  {
    "": "2527",
    time: "1637709683.7964687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-76.171875",
    c3: "-81.0546875",
    c4: "14.16015625",
  },
  {
    "": "2528",
    time: "1637709683.800375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-70.3125",
    c3: "-6.34765625",
    c4: "25.390625",
  },
  {
    "": "2529",
    time: "1637709683.8042812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-34.66796875",
    c3: "-7.32421875",
    c4: "-14.16015625",
  },
  {
    "": "2530",
    time: "1637709683.8081875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-9.765625",
    c3: "-61.5234375",
    c4: "-37.59765625",
  },
  {
    "": "2531",
    time: "1637709683.8120937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "4.8828125",
    c3: "-22.94921875",
    c4: "-3.41796875",
  },
  {
    "": "2532",
    time: "1637709683.816125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-10.7421875",
    c3: "17.08984375",
    c4: "17.08984375",
  },
  {
    "": "2533",
    time: "1637709683.8200312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-32.2265625",
    c3: "6.8359375",
    c4: "-5.859375",
  },
  {
    "": "2534",
    time: "1637709683.8239374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-11.71875",
    c3: "-22.94921875",
    c4: "-22.4609375",
  },
  {
    "": "2535",
    time: "1637709683.8278437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-20.99609375",
    c3: "-19.04296875",
    c4: "-28.80859375",
  },
  {
    "": "2536",
    time: "1637709683.83175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-45.41015625",
    c3: "12.6953125",
    c4: "10.7421875",
  },
  {
    "": "2537",
    time: "1637709683.8356562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-48.828125",
    c3: "-2.44140625",
    c4: "2.44140625",
  },
  {
    "": "2538",
    time: "1637709683.8395624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-48.828125",
    c3: "-60.05859375",
    c4: "-39.55078125",
  },
  {
    "": "2539",
    time: "1637709683.8434687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-45.41015625",
    c3: "-59.5703125",
    c4: "-34.1796875",
  },
  {
    "": "2540",
    time: "1637709683.847375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-21.484375",
    c3: "-3.90625",
    c4: "-8.30078125",
  },
  {
    "": "2541",
    time: "1637709683.8512812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-7.32421875",
    c3: "-8.30078125",
    c4: "-8.7890625",
  },
  {
    "": "2542",
    time: "1637709683.8551874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-19.04296875",
    c3: "-43.9453125",
    c4: "-47.36328125",
  },
];

export default EvaBlink;